import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountNumber: { input: any; output: any; }
  BigDecimal: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Byte: { input: any; output: any; }
  Bytes: { input: any; output: any; }
  CountryCode: { input: any; output: any; }
  CountryName: { input: any; output: any; }
  Cuid: { input: any; output: any; }
  Currency: { input: any; output: any; }
  DID: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  DeweyDecimal: { input: any; output: any; }
  Duration: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  EthereumAddress: { input: any; output: any; }
  GUID: { input: any; output: any; }
  GeoJSON: { input: any; output: any; }
  HSL: { input: any; output: any; }
  HSLA: { input: any; output: any; }
  HexColorCode: { input: any; output: any; }
  Hexadecimal: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  IP: { input: any; output: any; }
  IPCPatent: { input: any; output: any; }
  IPv4: { input: any; output: any; }
  IPv6: { input: any; output: any; }
  ISBN: { input: any; output: any; }
  ISO8601Duration: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  JWT: { input: any; output: any; }
  LCCSubclass: { input: any; output: any; }
  Latitude: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
  LocalEndTime: { input: any; output: any; }
  LocalTime: { input: any; output: any; }
  Locale: { input: any; output: any; }
  Long: { input: any; output: any; }
  Longitude: { input: any; output: any; }
  MAC: { input: any; output: any; }
  NegativeFloat: { input: any; output: any; }
  NegativeInt: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  NonNegativeFloat: { input: any; output: any; }
  NonNegativeInt: { input: any; output: any; }
  NonPositiveFloat: { input: any; output: any; }
  NonPositiveInt: { input: any; output: any; }
  ObjectID: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  Port: { input: any; output: any; }
  PositiveFloat: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
  RGB: { input: any; output: any; }
  RGBA: { input: any; output: any; }
  RoutingNumber: { input: any; output: any; }
  SESSN: { input: any; output: any; }
  SafeInt: { input: any; output: any; }
  SemVer: { input: any; output: any; }
  Time: { input: any; output: any; }
  TimeZone: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  URL: { input: any; output: any; }
  USCurrency: { input: any; output: any; }
  UUID: { input: any; output: any; }
  UnsignedFloat: { input: any; output: any; }
  UnsignedInt: { input: any; output: any; }
  UtcOffset: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AaveStrategy = {
  __typename?: 'AAVEStrategy';
  aavePool: Scalars['Bytes']['output'];
  aaveToken: Asset;
  currentlyDeployed: Scalars['BigInt']['output'];
  depositedAssets: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  pool: PoolV2;
  rewardToken?: Maybe<Asset>;
  rewardsClaimed: Scalars['BigInt']['output'];
  state: StrategyState;
  strategyFeeRate: Scalars['BigInt']['output'];
  totalFeesCollected: Scalars['BigInt']['output'];
  transaction?: Maybe<Transaction>;
  version: Scalars['Int']['output'];
  withdrawnAssets: Scalars['BigInt']['output'];
};

export type AaveStrategy_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  aavePool?: InputMaybe<Scalars['Bytes']['input']>;
  aavePool_contains?: InputMaybe<Scalars['Bytes']['input']>;
  aavePool_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  aavePool_not?: InputMaybe<Scalars['Bytes']['input']>;
  aavePool_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  aavePool_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  aaveToken?: InputMaybe<Scalars['String']['input']>;
  aaveToken_?: InputMaybe<Asset_Filter>;
  aaveToken_contains?: InputMaybe<Scalars['String']['input']>;
  aaveToken_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  aaveToken_ends_with?: InputMaybe<Scalars['String']['input']>;
  aaveToken_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  aaveToken_gt?: InputMaybe<Scalars['String']['input']>;
  aaveToken_gte?: InputMaybe<Scalars['String']['input']>;
  aaveToken_in?: InputMaybe<Array<Scalars['String']['input']>>;
  aaveToken_lt?: InputMaybe<Scalars['String']['input']>;
  aaveToken_lte?: InputMaybe<Scalars['String']['input']>;
  aaveToken_not?: InputMaybe<Scalars['String']['input']>;
  aaveToken_not_contains?: InputMaybe<Scalars['String']['input']>;
  aaveToken_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  aaveToken_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  aaveToken_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  aaveToken_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  aaveToken_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  aaveToken_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  aaveToken_starts_with?: InputMaybe<Scalars['String']['input']>;
  aaveToken_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  currentlyDeployed?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  currentlyDeployed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_not?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositedAssets?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositedAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  rewardToken?: InputMaybe<Scalars['String']['input']>;
  rewardToken_?: InputMaybe<Asset_Filter>;
  rewardToken_contains?: InputMaybe<Scalars['String']['input']>;
  rewardToken_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  rewardToken_ends_with?: InputMaybe<Scalars['String']['input']>;
  rewardToken_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  rewardToken_gt?: InputMaybe<Scalars['String']['input']>;
  rewardToken_gte?: InputMaybe<Scalars['String']['input']>;
  rewardToken_in?: InputMaybe<Array<Scalars['String']['input']>>;
  rewardToken_lt?: InputMaybe<Scalars['String']['input']>;
  rewardToken_lte?: InputMaybe<Scalars['String']['input']>;
  rewardToken_not?: InputMaybe<Scalars['String']['input']>;
  rewardToken_not_contains?: InputMaybe<Scalars['String']['input']>;
  rewardToken_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  rewardToken_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  rewardToken_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  rewardToken_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  rewardToken_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  rewardToken_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  rewardToken_starts_with?: InputMaybe<Scalars['String']['input']>;
  rewardToken_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  rewardsClaimed?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsClaimed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsClaimed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsClaimed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  rewardsClaimed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsClaimed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsClaimed_not?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsClaimed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  state?: InputMaybe<StrategyState>;
  state_in?: InputMaybe<Array<StrategyState>>;
  state_not?: InputMaybe<StrategyState>;
  state_not_in?: InputMaybe<Array<StrategyState>>;
  strategyFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strategyFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalFeesCollected?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalFeesCollected_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  withdrawnAssets?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawnAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum AaveStrategy_OrderBy {
  AavePool = 'aavePool',
  AaveToken = 'aaveToken',
  CurrentlyDeployed = 'currentlyDeployed',
  DepositedAssets = 'depositedAssets',
  Id = 'id',
  Pool = 'pool',
  RewardToken = 'rewardToken',
  RewardsClaimed = 'rewardsClaimed',
  State = 'state',
  StrategyFeeRate = 'strategyFeeRate',
  TotalFeesCollected = 'totalFeesCollected',
  Transaction = 'transaction',
  Version = 'version',
  WithdrawnAssets = 'withdrawnAssets'
}

export enum Access {
  Admin = 'admin',
  None = 'none',
  View = 'view'
}

export type Account = {
  __typename?: 'Account';
  averageInterest?: Maybe<Scalars['String']['output']>;
  bitmapFlags?: Maybe<BitmapFlags>;
  borrowerMeta?: Maybe<BorrowerMetadata>;
  currentAverageApy?: Maybe<Scalars['String']['output']>;
  delegateMeta?: Maybe<DelegateMetadata>;
  depositedMPL: Scalars['BigInt']['output'];
  depositedSyrup: Scalars['BigInt']['output'];
  dripsEarned?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isPermissionAdmin: Scalars['Boolean']['output'];
  isPoolDelegate: Scalars['Boolean']['output'];
  isSyrupLender: Scalars['Boolean']['output'];
  isValidBorrower: Scalars['Boolean']['output'];
  lendingApy?: Maybe<Scalars['String']['output']>;
  loans?: Maybe<Array<Loan>>;
  managedPools?: Maybe<Array<Pool>>;
  managedPoolsV2?: Maybe<Array<PoolV2>>;
  permissionsBitmap: Scalars['BigInt']['output'];
  poolPositions?: Maybe<Array<PoolPosition>>;
  poolV2Positions?: Maybe<Array<PoolV2Position>>;
  principalOwed?: Maybe<Scalars['String']['output']>;
  stSyrupBalance: Scalars['BigInt']['output'];
  stSyrupTxes?: Maybe<Array<StSyrupTx>>;
  syrupDripTxes?: Maybe<Array<SyrupDripTx>>;
  totalAmountClaimed: Scalars['BigInt']['output'];
  totalClaimableFees: Scalars['BigInt']['output'];
  totalClaimableInterest: Scalars['BigInt']['output'];
  totalClaimableReward: Scalars['BigInt']['output'];
  totalClaimableStakeReward: Scalars['BigInt']['output'];
  totalFeesEarned: Scalars['BigInt']['output'];
  totalInterestEarned: Scalars['BigInt']['output'];
  totalPoolTokenBalance: Scalars['BigInt']['output'];
  totalPoolTokensStaked: Scalars['BigInt']['output'];
  totalRewardPaid: Scalars['BigInt']['output'];
  totalStake: Scalars['BigInt']['output'];
  totalStakeLockerTokensStaked: Scalars['BigInt']['output'];
  totalStakeRewardPaid: Scalars['BigInt']['output'];
  totalsByAsset?: Maybe<Array<AccountTotal>>;
  txes?: Maybe<Array<Tx>>;
  withdrawnMPL: Scalars['BigInt']['output'];
  withdrawnSyrup: Scalars['BigInt']['output'];
  xMPLBalance: Scalars['BigInt']['output'];
  xMPLTxes?: Maybe<Array<XMplTx>>;
};


export type AccountLendingApyArgs = {
  poolIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type AccountLoansArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Loan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Loan_Filter>;
};


export type AccountManagedPoolsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Pool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Pool_Filter>;
};


export type AccountManagedPoolsV2Args = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolV2_Filter>;
};


export type AccountPoolPositionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolPosition_Filter>;
};


export type AccountPoolV2PositionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2Position_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolV2Position_Filter>;
};


export type AccountStSyrupTxesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StSyrupTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StSyrupTx_Filter>;
};


export type AccountSyrupDripTxesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SyrupDripTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SyrupDripTx_Filter>;
};


export type AccountTotalsByAssetArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountTotal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountTotal_Filter>;
};


export type AccountTxesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Tx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Tx_Filter>;
};


export type AccountXMplTxesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<XMplTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<XMplTx_Filter>;
};

export type AccountTotal = {
  __typename?: 'AccountTotal';
  account: Account;
  asset: Asset;
  claimableFees: Scalars['BigInt']['output'];
  claimableInterest: Scalars['BigInt']['output'];
  claimableReward: Scalars['BigInt']['output'];
  claimableStakeReward: Scalars['BigInt']['output'];
  feesEarned: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  interestEarned: Scalars['BigInt']['output'];
  poolTokenBalance: Scalars['BigInt']['output'];
  poolTokensStaked: Scalars['BigInt']['output'];
  principalOwed: Scalars['BigInt']['output'];
  rewardPaid: Scalars['BigInt']['output'];
  stake: Scalars['BigInt']['output'];
  stakeLockerTokensStaked: Scalars['BigInt']['output'];
  stakeRewardPaid: Scalars['BigInt']['output'];
};

export type AccountTotal_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<Asset_Filter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  claimableFees?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableInterest?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableReward?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableReward_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_not?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableStakeReward?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableStakeReward_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_not?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feesEarned?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feesEarned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_not?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interestEarned?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestEarned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolTokenBalance?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolTokenBalance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_not?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolTokensStaked?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_gt?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_gte?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolTokensStaked_lt?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_lte?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_not?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  rewardPaid?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  rewardPaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stake?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeLockerTokensStaked_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeRewardPaid?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeRewardPaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stake_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stake_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stake_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stake_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stake_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stake_not?: InputMaybe<Scalars['BigInt']['input']>;
  stake_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum AccountTotal_OrderBy {
  Account = 'account',
  Asset = 'asset',
  ClaimableFees = 'claimableFees',
  ClaimableInterest = 'claimableInterest',
  ClaimableReward = 'claimableReward',
  ClaimableStakeReward = 'claimableStakeReward',
  FeesEarned = 'feesEarned',
  Id = 'id',
  InterestEarned = 'interestEarned',
  PoolTokenBalance = 'poolTokenBalance',
  PoolTokensStaked = 'poolTokensStaked',
  PrincipalOwed = 'principalOwed',
  RewardPaid = 'rewardPaid',
  Stake = 'stake',
  StakeLockerTokensStaked = 'stakeLockerTokensStaked',
  StakeRewardPaid = 'stakeRewardPaid'
}

export enum AccountType {
  Individual = 'INDIVIDUAL',
  LegalEntity = 'LEGAL_ENTITY'
}

export type Account_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  depositedMPL?: InputMaybe<Scalars['BigInt']['input']>;
  depositedMPL_gt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedMPL_gte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedMPL_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositedMPL_lt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedMPL_lte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedMPL_not?: InputMaybe<Scalars['BigInt']['input']>;
  depositedMPL_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositedSyrup?: InputMaybe<Scalars['BigInt']['input']>;
  depositedSyrup_gt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedSyrup_gte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedSyrup_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositedSyrup_lt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedSyrup_lte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedSyrup_not?: InputMaybe<Scalars['BigInt']['input']>;
  depositedSyrup_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPermissionAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isPermissionAdmin_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isPermissionAdmin_not?: InputMaybe<Scalars['Boolean']['input']>;
  isPermissionAdmin_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isPoolDelegate?: InputMaybe<Scalars['Boolean']['input']>;
  isPoolDelegate_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isPoolDelegate_not?: InputMaybe<Scalars['Boolean']['input']>;
  isPoolDelegate_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isSyrupLender?: InputMaybe<Scalars['Boolean']['input']>;
  isSyrupLender_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isSyrupLender_not?: InputMaybe<Scalars['Boolean']['input']>;
  isSyrupLender_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isValidBorrower?: InputMaybe<Scalars['Boolean']['input']>;
  isValidBorrower_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isValidBorrower_not?: InputMaybe<Scalars['Boolean']['input']>;
  isValidBorrower_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  loans_?: InputMaybe<Loan_Filter>;
  managedPoolsV2_?: InputMaybe<PoolV2_Filter>;
  managedPools_?: InputMaybe<Pool_Filter>;
  permissionsBitmap?: InputMaybe<Scalars['BigInt']['input']>;
  permissionsBitmap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  permissionsBitmap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  permissionsBitmap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  permissionsBitmap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  permissionsBitmap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  permissionsBitmap_not?: InputMaybe<Scalars['BigInt']['input']>;
  permissionsBitmap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolPositions_?: InputMaybe<PoolPosition_Filter>;
  poolV2Positions_?: InputMaybe<PoolV2Position_Filter>;
  stSyrupBalance?: InputMaybe<Scalars['BigInt']['input']>;
  stSyrupBalance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stSyrupBalance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stSyrupBalance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stSyrupBalance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stSyrupBalance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stSyrupBalance_not?: InputMaybe<Scalars['BigInt']['input']>;
  stSyrupBalance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stSyrupTxes_?: InputMaybe<StSyrupTx_Filter>;
  syrupDripTxes_?: InputMaybe<SyrupDripTx_Filter>;
  totalAmountClaimed?: InputMaybe<Scalars['BigInt']['input']>;
  totalAmountClaimed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAmountClaimed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAmountClaimed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalAmountClaimed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalAmountClaimed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalAmountClaimed_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalAmountClaimed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalClaimableFees?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalClaimableFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalClaimableInterest?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalClaimableInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalClaimableReward?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableReward_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableReward_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableReward_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalClaimableReward_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableReward_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableReward_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableReward_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalClaimableStakeReward?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableStakeReward_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableStakeReward_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableStakeReward_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalClaimableStakeReward_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableStakeReward_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableStakeReward_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalClaimableStakeReward_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalFeesEarned?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesEarned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesEarned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesEarned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalFeesEarned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesEarned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesEarned_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesEarned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalInterestEarned?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalInterestEarned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPoolTokenBalance?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokenBalance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokenBalance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokenBalance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPoolTokenBalance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokenBalance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokenBalance_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokenBalance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPoolTokensStaked?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPoolTokensStaked_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalRewardPaid?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardPaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardPaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardPaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalRewardPaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardPaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardPaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalRewardPaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalStake?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalStakeLockerTokensStaked_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalStakeRewardPaid?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeRewardPaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeRewardPaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeRewardPaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalStakeRewardPaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeRewardPaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeRewardPaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeRewardPaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalStake_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalStake_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalStake_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalStake_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalStake_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalStake_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalStake_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalsByAsset_?: InputMaybe<AccountTotal_Filter>;
  txes_?: InputMaybe<Tx_Filter>;
  withdrawnMPL?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnMPL_gt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnMPL_gte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnMPL_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawnMPL_lt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnMPL_lte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnMPL_not?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnMPL_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawnSyrup?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnSyrup_gt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnSyrup_gte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnSyrup_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawnSyrup_lt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnSyrup_lte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnSyrup_not?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnSyrup_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  xMPLBalance?: InputMaybe<Scalars['BigInt']['input']>;
  xMPLBalance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  xMPLBalance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  xMPLBalance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  xMPLBalance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  xMPLBalance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  xMPLBalance_not?: InputMaybe<Scalars['BigInt']['input']>;
  xMPLBalance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  xMPLTxes_?: InputMaybe<XMplTx_Filter>;
};

export enum Account_OrderBy {
  DepositedMpl = 'depositedMPL',
  DepositedSyrup = 'depositedSyrup',
  Id = 'id',
  IsPermissionAdmin = 'isPermissionAdmin',
  IsPoolDelegate = 'isPoolDelegate',
  IsSyrupLender = 'isSyrupLender',
  IsValidBorrower = 'isValidBorrower',
  Loans = 'loans',
  ManagedPools = 'managedPools',
  ManagedPoolsV2 = 'managedPoolsV2',
  PermissionsBitmap = 'permissionsBitmap',
  PoolPositions = 'poolPositions',
  PoolV2Positions = 'poolV2Positions',
  StSyrupBalance = 'stSyrupBalance',
  StSyrupTxes = 'stSyrupTxes',
  SyrupDripTxes = 'syrupDripTxes',
  TotalAmountClaimed = 'totalAmountClaimed',
  TotalClaimableFees = 'totalClaimableFees',
  TotalClaimableInterest = 'totalClaimableInterest',
  TotalClaimableReward = 'totalClaimableReward',
  TotalClaimableStakeReward = 'totalClaimableStakeReward',
  TotalFeesEarned = 'totalFeesEarned',
  TotalInterestEarned = 'totalInterestEarned',
  TotalPoolTokenBalance = 'totalPoolTokenBalance',
  TotalPoolTokensStaked = 'totalPoolTokensStaked',
  TotalRewardPaid = 'totalRewardPaid',
  TotalStake = 'totalStake',
  TotalStakeLockerTokensStaked = 'totalStakeLockerTokensStaked',
  TotalStakeRewardPaid = 'totalStakeRewardPaid',
  TotalsByAsset = 'totalsByAsset',
  Txes = 'txes',
  WithdrawnMpl = 'withdrawnMPL',
  WithdrawnSyrup = 'withdrawnSyrup',
  XMplBalance = 'xMPLBalance',
  XMplTxes = 'xMPLTxes'
}

export type AddOrgWalletByMapleAdminInput = {
  orgId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
  walletAddress: Scalars['EthereumAddress']['input'];
};

export type AddOrgWalletInput = {
  orgId: Scalars['ID']['input'];
  walletAddress: Scalars['EthereumAddress']['input'];
};

export type AddWalletInput = {
  userId: Scalars['String']['input'];
  walletAddress: Scalars['EthereumAddress']['input'];
};

export type AddressCompliance = {
  __typename?: 'AddressCompliance';
  address: Scalars['String']['output'];
  chain: TrmChains;
  indicators?: Maybe<Array<RiskIndicators>>;
  link?: Maybe<Scalars['String']['output']>;
  permitted: Scalars['Boolean']['output'];
};

export type AggregatorAssetMap = {
  __typename?: 'AggregatorAssetMap';
  asset: Asset;
  id: Scalars['ID']['output'];
};

export type AggregatorAssetMap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<Asset_Filter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum AggregatorAssetMap_OrderBy {
  Asset = 'asset',
  Id = 'id'
}

export type Allocation = {
  __typename?: 'Allocation';
  deadline: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  maxId: Scalars['BigInt']['output'];
  root: Scalars['Bytes']['output'];
  syrupDrip: SyrupDrip;
};

export type Allocation_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  deadline?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_gt?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_gte?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  deadline_lt?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_lte?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_not?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maxId?: InputMaybe<Scalars['BigInt']['input']>;
  maxId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maxId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maxId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maxId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maxId_not?: InputMaybe<Scalars['BigInt']['input']>;
  maxId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  root?: InputMaybe<Scalars['Bytes']['input']>;
  root_contains?: InputMaybe<Scalars['Bytes']['input']>;
  root_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  root_not?: InputMaybe<Scalars['Bytes']['input']>;
  root_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  root_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  syrupDrip?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_?: InputMaybe<SyrupDrip_Filter>;
  syrupDrip_contains?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_ends_with?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_gt?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_gte?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_in?: InputMaybe<Array<Scalars['String']['input']>>;
  syrupDrip_lt?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_lte?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_not?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_not_contains?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  syrupDrip_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_starts_with?: InputMaybe<Scalars['String']['input']>;
  syrupDrip_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Allocation_OrderBy {
  Deadline = 'deadline',
  Id = 'id',
  MaxId = 'maxId',
  Root = 'root',
  SyrupDrip = 'syrupDrip'
}

export type ApplyReferralTokenInput = {
  refereeAddress: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ApyData = {
  __typename?: 'ApyData';
  apy: Scalars['BigInt']['output'];
  cumulativeDailyApy: Scalars['BigInt']['output'];
  cumulativeDailyApyValuesRecorded: Scalars['BigInt']['output'];
  cumulativeFees: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  last30DailyApyValues: Array<Scalars['BigInt']['output']>;
  lifetimeApy: Scalars['BigInt']['output'];
  lifetimeApyLastCalculated: Scalars['BigInt']['output'];
  lifetimeFees: Scalars['BigInt']['output'];
  managementFees: Scalars['BigInt']['output'];
  monthlyApy: Scalars['BigInt']['output'];
  monthlyApyLastCalculated: Scalars['BigInt']['output'];
  monthlyFees: Scalars['BigInt']['output'];
  poolV1?: Maybe<Pool>;
  poolV2?: Maybe<PoolV2>;
};

export type ApyData_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  apy?: InputMaybe<Scalars['BigInt']['input']>;
  apy_gt?: InputMaybe<Scalars['BigInt']['input']>;
  apy_gte?: InputMaybe<Scalars['BigInt']['input']>;
  apy_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  apy_lt?: InputMaybe<Scalars['BigInt']['input']>;
  apy_lte?: InputMaybe<Scalars['BigInt']['input']>;
  apy_not?: InputMaybe<Scalars['BigInt']['input']>;
  apy_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  cumulativeDailyApy?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApyValuesRecorded?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApyValuesRecorded_gt?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApyValuesRecorded_gte?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApyValuesRecorded_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  cumulativeDailyApyValuesRecorded_lt?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApyValuesRecorded_lte?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApyValuesRecorded_not?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApyValuesRecorded_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  cumulativeDailyApy_gt?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApy_gte?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApy_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  cumulativeDailyApy_lt?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApy_lte?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApy_not?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeDailyApy_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  cumulativeFees?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  cumulativeFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  cumulativeFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  last30DailyApyValues?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  last30DailyApyValues_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  last30DailyApyValues_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  last30DailyApyValues_not?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  last30DailyApyValues_not_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  last30DailyApyValues_not_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lifetimeApy?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApyLastCalculated?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApyLastCalculated_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApyLastCalculated_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApyLastCalculated_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lifetimeApyLastCalculated_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApyLastCalculated_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApyLastCalculated_not?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApyLastCalculated_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lifetimeApy_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApy_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApy_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lifetimeApy_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApy_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApy_not?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeApy_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lifetimeFees?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lifetimeFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  lifetimeFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  managementFees?: InputMaybe<Scalars['BigInt']['input']>;
  managementFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  managementFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  managementFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  managementFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  managementFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  managementFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  managementFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  monthlyApy?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApyLastCalculated?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApyLastCalculated_gt?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApyLastCalculated_gte?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApyLastCalculated_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  monthlyApyLastCalculated_lt?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApyLastCalculated_lte?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApyLastCalculated_not?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApyLastCalculated_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  monthlyApy_gt?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApy_gte?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApy_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  monthlyApy_lt?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApy_lte?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApy_not?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyApy_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  monthlyFees?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  monthlyFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  monthlyFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolV1?: InputMaybe<Scalars['String']['input']>;
  poolV1_?: InputMaybe<Pool_Filter>;
  poolV1_contains?: InputMaybe<Scalars['String']['input']>;
  poolV1_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV1_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolV1_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV1_gt?: InputMaybe<Scalars['String']['input']>;
  poolV1_gte?: InputMaybe<Scalars['String']['input']>;
  poolV1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolV1_lt?: InputMaybe<Scalars['String']['input']>;
  poolV1_lte?: InputMaybe<Scalars['String']['input']>;
  poolV1_not?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolV1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV1_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolV1_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV2?: InputMaybe<Scalars['String']['input']>;
  poolV2_?: InputMaybe<PoolV2_Filter>;
  poolV2_contains?: InputMaybe<Scalars['String']['input']>;
  poolV2_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV2_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolV2_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV2_gt?: InputMaybe<Scalars['String']['input']>;
  poolV2_gte?: InputMaybe<Scalars['String']['input']>;
  poolV2_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolV2_lt?: InputMaybe<Scalars['String']['input']>;
  poolV2_lte?: InputMaybe<Scalars['String']['input']>;
  poolV2_not?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolV2_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV2_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolV2_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum ApyData_OrderBy {
  Apy = 'apy',
  CumulativeDailyApy = 'cumulativeDailyApy',
  CumulativeDailyApyValuesRecorded = 'cumulativeDailyApyValuesRecorded',
  CumulativeFees = 'cumulativeFees',
  Id = 'id',
  Last30DailyApyValues = 'last30DailyApyValues',
  LifetimeApy = 'lifetimeApy',
  LifetimeApyLastCalculated = 'lifetimeApyLastCalculated',
  LifetimeFees = 'lifetimeFees',
  ManagementFees = 'managementFees',
  MonthlyApy = 'monthlyApy',
  MonthlyApyLastCalculated = 'monthlyApyLastCalculated',
  MonthlyFees = 'monthlyFees',
  PoolV1 = 'poolV1',
  PoolV2 = 'poolV2'
}

export type Asset = {
  __typename?: 'Asset';
  amount: Scalars['BigInt']['output'];
  amountAsLiquidity: Scalars['BigInt']['output'];
  chainLinkAggregator: Scalars['Bytes']['output'];
  decimals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isValidCollateralAsset: Scalars['Boolean']['output'];
  isValidLiquidityAsset: Scalars['Boolean']['output'];
  isValidPoolAsset: Scalars['Boolean']['output'];
  isValidStakeAsset: Scalars['Boolean']['output'];
  lastAggregatorCheckTimestamp: Scalars['BigInt']['output'];
  lastPriceUpdateTimestamp: Scalars['BigInt']['output'];
  price: Scalars['BigInt']['output'];
  priceFeed: Scalars['Bytes']['output'];
  priceUsd?: Maybe<Scalars['String']['output']>;
  symbol: Scalars['String']['output'];
};

export type AssetMap = {
  __typename?: 'AssetMap';
  asset: Asset;
  id: Scalars['ID']['output'];
};

export type AssetMap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<Asset_Filter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum AssetMap_OrderBy {
  Asset = 'asset',
  Id = 'id'
}

export type Asset_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amountAsLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  amountAsLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amountAsLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amountAsLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountAsLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amountAsLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amountAsLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  amountAsLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  chainLinkAggregator?: InputMaybe<Scalars['Bytes']['input']>;
  chainLinkAggregator_contains?: InputMaybe<Scalars['Bytes']['input']>;
  chainLinkAggregator_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  chainLinkAggregator_not?: InputMaybe<Scalars['Bytes']['input']>;
  chainLinkAggregator_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  chainLinkAggregator_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isValidCollateralAsset?: InputMaybe<Scalars['Boolean']['input']>;
  isValidCollateralAsset_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isValidCollateralAsset_not?: InputMaybe<Scalars['Boolean']['input']>;
  isValidCollateralAsset_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isValidLiquidityAsset?: InputMaybe<Scalars['Boolean']['input']>;
  isValidLiquidityAsset_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isValidLiquidityAsset_not?: InputMaybe<Scalars['Boolean']['input']>;
  isValidLiquidityAsset_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isValidPoolAsset?: InputMaybe<Scalars['Boolean']['input']>;
  isValidPoolAsset_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isValidPoolAsset_not?: InputMaybe<Scalars['Boolean']['input']>;
  isValidPoolAsset_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isValidStakeAsset?: InputMaybe<Scalars['Boolean']['input']>;
  isValidStakeAsset_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isValidStakeAsset_not?: InputMaybe<Scalars['Boolean']['input']>;
  isValidStakeAsset_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  lastAggregatorCheckTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  lastAggregatorCheckTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastAggregatorCheckTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastAggregatorCheckTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastAggregatorCheckTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastAggregatorCheckTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastAggregatorCheckTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastAggregatorCheckTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastPriceUpdateTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  lastPriceUpdateTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastPriceUpdateTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastPriceUpdateTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastPriceUpdateTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastPriceUpdateTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastPriceUpdateTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastPriceUpdateTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  price?: InputMaybe<Scalars['BigInt']['input']>;
  priceFeed?: InputMaybe<Scalars['Bytes']['input']>;
  priceFeed_contains?: InputMaybe<Scalars['Bytes']['input']>;
  priceFeed_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  priceFeed_not?: InputMaybe<Scalars['Bytes']['input']>;
  priceFeed_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  priceFeed_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  price_gt?: InputMaybe<Scalars['BigInt']['input']>;
  price_gte?: InputMaybe<Scalars['BigInt']['input']>;
  price_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  price_lt?: InputMaybe<Scalars['BigInt']['input']>;
  price_lte?: InputMaybe<Scalars['BigInt']['input']>;
  price_not?: InputMaybe<Scalars['BigInt']['input']>;
  price_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Asset_OrderBy {
  Amount = 'amount',
  AmountAsLiquidity = 'amountAsLiquidity',
  ChainLinkAggregator = 'chainLinkAggregator',
  Decimals = 'decimals',
  Id = 'id',
  IsValidCollateralAsset = 'isValidCollateralAsset',
  IsValidLiquidityAsset = 'isValidLiquidityAsset',
  IsValidPoolAsset = 'isValidPoolAsset',
  IsValidStakeAsset = 'isValidStakeAsset',
  LastAggregatorCheckTimestamp = 'lastAggregatorCheckTimestamp',
  LastPriceUpdateTimestamp = 'lastPriceUpdateTimestamp',
  Price = 'price',
  PriceFeed = 'priceFeed',
  Symbol = 'symbol'
}

export type AutoRedeemerConfig = {
  __typename?: 'AutoRedeemerConfig';
  asset: Erc20;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lockup: Scalars['String']['output'];
  maxGasPrice: Scalars['String']['output'];
  pool: Erc20;
  wm: Wm;
};

export type AvailableInterestStatement = {
  __typename?: 'AvailableInterestStatement';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type BPool = {
  __typename?: 'BPool';
  id: Scalars['ID']['output'];
  lastUpdateTimestamp: Scalars['BigInt']['output'];
  mplBalance: Scalars['BigInt']['output'];
  pairBalance: Scalars['BigInt']['output'];
  pairDecimals?: Maybe<Scalars['Int']['output']>;
  pairSymbol: Scalars['String']['output'];
  pairToken: Scalars['Bytes']['output'];
  totalSupply: Scalars['BigInt']['output'];
};

export type BPool_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastUpdateTimestamp?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdateTimestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdateTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  mplBalance?: InputMaybe<Scalars['BigInt']['input']>;
  mplBalance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  mplBalance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  mplBalance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  mplBalance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  mplBalance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  mplBalance_not?: InputMaybe<Scalars['BigInt']['input']>;
  mplBalance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pairBalance?: InputMaybe<Scalars['BigInt']['input']>;
  pairBalance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  pairBalance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  pairBalance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pairBalance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  pairBalance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  pairBalance_not?: InputMaybe<Scalars['BigInt']['input']>;
  pairBalance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pairDecimals?: InputMaybe<Scalars['Int']['input']>;
  pairDecimals_gt?: InputMaybe<Scalars['Int']['input']>;
  pairDecimals_gte?: InputMaybe<Scalars['Int']['input']>;
  pairDecimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  pairDecimals_lt?: InputMaybe<Scalars['Int']['input']>;
  pairDecimals_lte?: InputMaybe<Scalars['Int']['input']>;
  pairDecimals_not?: InputMaybe<Scalars['Int']['input']>;
  pairDecimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  pairSymbol?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_contains?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_gt?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_gte?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pairSymbol_lt?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_lte?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_not?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pairSymbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  pairSymbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pairToken?: InputMaybe<Scalars['Bytes']['input']>;
  pairToken_contains?: InputMaybe<Scalars['Bytes']['input']>;
  pairToken_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  pairToken_not?: InputMaybe<Scalars['Bytes']['input']>;
  pairToken_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  pairToken_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  totalSupply?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum BPool_OrderBy {
  Id = 'id',
  LastUpdateTimestamp = 'lastUpdateTimestamp',
  MplBalance = 'mplBalance',
  PairBalance = 'pairBalance',
  PairDecimals = 'pairDecimals',
  PairSymbol = 'pairSymbol',
  PairToken = 'pairToken',
  TotalSupply = 'totalSupply'
}

export type Banner = {
  __typename?: 'Banner';
  _id: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  type: BannerType;
};

export enum BannerType {
  Error = 'error',
  Info = 'info',
  Neutral = 'neutral',
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Warning = 'warning'
}

export type BitmapFlags = {
  __typename?: 'BitmapFlags';
  accredited: Scalars['Boolean']['output'];
  kyc: Scalars['Boolean']['output'];
  nonUs: Scalars['Boolean']['output'];
  syrup: Scalars['Boolean']['output'];
  us: Scalars['Boolean']['output'];
};

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  number_gte?: InputMaybe<Scalars['Int']['input']>;
};

export type Bond = {
  __typename?: 'Bond';
  dayEnd: Scalars['Int']['output'];
  dayStart: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type BondMaturity = {
  __typename?: 'BondMaturity';
  bondPeriods?: Maybe<Array<Bond>>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  weightedAvgPeriodDays?: Maybe<Scalars['String']['output']>;
};

export type BondPosition = {
  __typename?: 'BondPosition';
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  parAmount: Scalars['Float']['output'];
  poolId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  yieldCoupon: Scalars['Float']['output'];
};

export type BorrowerAccessRequested = {
  __typename?: 'BorrowerAccessRequested';
  requested: Scalars['Boolean']['output'];
  typeformResponse?: Maybe<TypeformResponse>;
};

export type BorrowerInfo = {
  __typename?: 'BorrowerInfo';
  companyEmail?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  ethereumAddress?: Maybe<Scalars['String']['output']>;
};

export type BorrowerMetadata = {
  __typename?: 'BorrowerMetadata';
  _id: Scalars['String']['output'];
  aboutCeoName?: Maybe<Scalars['String']['output']>;
  aboutFoundedDate?: Maybe<Scalars['String']['output']>;
  aboutInfo?: Maybe<Scalars['String']['output']>;
  aboutNumEmployees?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  companyEmail: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  companyPublicName?: Maybe<Scalars['String']['output']>;
  contactEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contactName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  ethereumAddress: Scalars['String']['output'];
  linkedIn?: Maybe<Scalars['String']['output']>;
  revenueUsage?: Maybe<Scalars['String']['output']>;
  state: BorrowerState;
  telegram?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  website: Scalars['String']['output'];
};

export type BorrowerPoolStats = {
  __typename?: 'BorrowerPoolStats';
  avgInterestRate: Scalars['String']['output'];
  avgTermLengthDays: Scalars['Float']['output'];
  borrower?: Maybe<BorrowerMetadata>;
  createdAt: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  numActiveLoans: Scalars['Int']['output'];
  numLatePayments: Scalars['Int']['output'];
  numLoansOriginated: Scalars['Int']['output'];
  numPayments: Scalars['Int']['output'];
  poolAsset: Scalars['String']['output'];
  poolConcentrationPercent: Scalars['String']['output'];
  poolId: Scalars['String']['output'];
  principalRepaid: Scalars['String']['output'];
  totalLoansOriginatedVal: Scalars['String']['output'];
  totalOutstandingDebt: Scalars['String']['output'];
};

export enum BorrowerState {
  Approved = 'Approved',
  Blocked = 'Blocked',
  Unapproved = 'Unapproved'
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type ChangeHistory = {
  __typename?: 'ChangeHistory';
  changes: Scalars['JSON']['output'];
  documentId: Scalars['ID']['output'];
  lastModifiedBy?: Maybe<User>;
  lastModifiedClient?: Maybe<Scalars['String']['output']>;
  operationType: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type ChangeRolesInput = {
  id: Scalars['ID']['input'];
  roles: Array<RoleInput>;
};

export type Collateral = {
  __typename?: 'Collateral';
  asset: CollateralAsset;
  assetAmount?: Maybe<Scalars['String']['output']>;
  assetValueUsd?: Maybe<Scalars['String']['output']>;
  bitgoWalletId: Scalars['String']['output'];
  custodian?: Maybe<Custodian>;
  history?: Maybe<Array<ChangeHistory>>;
  initialLevel: Scalars['Int']['output'];
  liquidationLevel: Scalars['Int']['output'];
  liquidationRequiredNotifiedAt?: Maybe<Scalars['String']['output']>;
  liquidationThreshold?: Maybe<Scalars['Int']['output']>;
  liquidationWarningNotifiedAt?: Maybe<Scalars['String']['output']>;
  loanAddress: Scalars['String']['output'];
  marginCallLevel: Scalars['Int']['output'];
  marginCallNoticePeriodHours: Scalars['Int']['output'];
  marginCallRequiredNotifiedAt?: Maybe<Scalars['String']['output']>;
  marginCallThreshold?: Maybe<Scalars['Int']['output']>;
  marginCallWarningNotifiedAt?: Maybe<Scalars['String']['output']>;
  refundLevel: Scalars['Int']['output'];
  state: CollateralState;
};

export enum CollateralAsset {
  Ada = 'ADA',
  Akt = 'AKT',
  Ath = 'ATH',
  Avax = 'AVAX',
  Bnb = 'BNB',
  Btc = 'BTC',
  Eth = 'ETH',
  Fil = 'FIL',
  Ftm = 'FTM',
  Gbtc = 'GBTC',
  Inj = 'INJ',
  Lbtc = 'LBTC',
  LpUsr = 'LP_USR',
  Ltc = 'LTC',
  OrcaLpPyusdc = 'OrcaLP_PYUSDC',
  Pol = 'POL',
  PtUsr = 'PT_USR',
  PtSUsde = 'PT_sUSDE',
  S = 'S',
  Sol = 'SOL',
  Usdc = 'USDC',
  Usr = 'USR',
  Ustb = 'USTB',
  Wsteth = 'WSTETH',
  Xrp = 'XRP',
  AUsdc = 'aUSDC',
  AUsdt = 'aUSDT',
  SDai = 'sDAI',
  SUsds = 'sUSDS',
  TEth = 'tETH'
}

export type CollateralInfo = {
  __typename?: 'CollateralInfo';
  collateralAsset?: Maybe<Scalars['String']['output']>;
  collateralAssetAmount?: Maybe<Scalars['String']['output']>;
  custodian?: Maybe<Custodian>;
  custodianId?: Maybe<Scalars['String']['output']>;
  initialLevel?: Maybe<Scalars['Int']['output']>;
  liquidationLevel?: Maybe<Scalars['Int']['output']>;
  liquidationPrice?: Maybe<Scalars['String']['output']>;
  liquidationRequiredNotifiedAt?: Maybe<Scalars['String']['output']>;
  liquidationThreshold?: Maybe<Scalars['Int']['output']>;
  liquidationWarningNotifiedAt?: Maybe<Scalars['String']['output']>;
  marginCallLevel?: Maybe<Scalars['Int']['output']>;
  marginCallNoticePeriodHours?: Maybe<Scalars['Int']['output']>;
  marginCallRequiredNotifiedAt?: Maybe<Scalars['String']['output']>;
  marginCallThreshold?: Maybe<Scalars['Int']['output']>;
  marginCallWarningNotifiedAt?: Maybe<Scalars['String']['output']>;
  refundLevel?: Maybe<Scalars['Int']['output']>;
};

export type CollateralInput = {
  asset: CollateralAsset;
  assetAmount?: InputMaybe<Scalars['String']['input']>;
  bitgoWalletId: Scalars['String']['input'];
  custodian?: InputMaybe<Custodian>;
  initialLevel: Scalars['Int']['input'];
  liquidationLevel: Scalars['Int']['input'];
  liquidationThreshold?: InputMaybe<Scalars['Int']['input']>;
  marginCallLevel: Scalars['Int']['input'];
  marginCallNoticePeriodHours: Scalars['Int']['input'];
  marginCallThreshold?: InputMaybe<Scalars['Int']['input']>;
  refundLevel: Scalars['Int']['input'];
};

export enum CollateralState {
  DepositPending = 'DepositPending',
  Deposited = 'Deposited',
  LiquidationComplete = 'LiquidationComplete',
  LiquidationPending = 'LiquidationPending',
  MarginCalled = 'MarginCalled',
  ReturnPending = 'ReturnPending',
  Returned = 'Returned'
}

export type CollateralStateResponse = {
  __typename?: 'CollateralStateResponse';
  state: CollateralState;
};

export type CollateralTx = {
  __typename?: 'CollateralTx';
  addedBy: User;
  amount: Scalars['String']['output'];
  asset: CollateralAsset;
  custodian?: Maybe<Custodian>;
  custodianId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  loanId: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
  txHash?: Maybe<Scalars['String']['output']>;
  type: CollateralTxType;
};

export type CollateralTxInput = {
  amount: Scalars['String']['input'];
  asset?: InputMaybe<CollateralAsset>;
  custodian?: InputMaybe<Custodian>;
  custodianId?: InputMaybe<Scalars['String']['input']>;
  txHash?: InputMaybe<Scalars['String']['input']>;
  type: CollateralTxType;
};

export enum CollateralTxType {
  CollateralRefund = 'CollateralRefund',
  Correction = 'Correction',
  Other = 'Other',
  PostCollateral = 'PostCollateral',
  ProactiveTopUp = 'ProactiveTopUp',
  Reallocation = 'Reallocation',
  ReturnCollateral = 'ReturnCollateral',
  TopUpForMarginCall = 'TopUpForMarginCall',
  TopUpForRefinance = 'TopUpForRefinance'
}

export type CollateralType = {
  __typename?: 'CollateralType';
  _id: Scalars['ID']['output'];
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CollateralizedLoan = {
  __typename?: 'CollateralizedLoan';
  acmRatio?: Maybe<Scalars['String']['output']>;
  borrower?: Maybe<BorrowerInfo>;
  collateral?: Maybe<CollateralInfo>;
  id: Scalars['ID']['output'];
  liquidityAsset: Scalars['String']['output'];
  pool?: Maybe<PoolMetadata>;
  principalOwed: Scalars['String']['output'];
  state: Scalars['String']['output'];
  type: CollateralizedLoanType;
};

export type CollateralizedLoanConnection = {
  __typename?: 'CollateralizedLoanConnection';
  nodes?: Maybe<Array<CollateralizedLoan>>;
  pageInfo: PageInfo;
};

export enum CollateralizedLoanType {
  Otc = 'OTC',
  OpenTerm = 'OpenTerm'
}

export enum CommitDays {
  Ninety = 'NINETY',
  OneHundredEighty = 'ONE_HUNDRED_EIGHTY'
}

export type Commitment = {
  __typename?: 'Commitment';
  accruedDrips: Scalars['Float']['output'];
  accruedDripsByInterval: Scalars['Float']['output'];
  accruedDripsBySeason: Array<SeasonDrips>;
  amount: Scalars['String']['output'];
  asset?: Maybe<Asset>;
  connector?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  date: Scalars['String']['output'];
  dateEnd?: Maybe<Scalars['String']['output']>;
  days: Scalars['Int']['output'];
  depositTxes: Array<Scalars['String']['output']>;
  dripsEarned: Scalars['Float']['output'];
  dripsPerDay: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isTransfer?: Maybe<Scalars['Boolean']['output']>;
  isWithdrawnEarly?: Maybe<Scalars['Boolean']['output']>;
  lastWithdrawnDate?: Maybe<Scalars['String']['output']>;
  originalDate?: Maybe<Scalars['String']['output']>;
  pool: Scalars['String']['output'];
  previousCommitments?: Maybe<Array<Commitment>>;
  seasons: Array<Season>;
  shares: Scalars['String']['output'];
  totalDrips: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  wallet: ExternalWallet;
  withdrawTxes: Array<Scalars['String']['output']>;
  withdrawnAmount: Scalars['String']['output'];
  withdrawnShares: Scalars['String']['output'];
};

export type ContactUsFormInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['EmailAddress']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type CreateAutoRedeemerConfig = {
  lockupAmount: Scalars['String']['input'];
  maxGasPriceGwei: Scalars['String']['input'];
  poolAddress: Scalars['String']['input'];
};

export type CreateBannerInput = {
  active: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  type: BannerType;
};

export type CreateBondInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  parAmount: Scalars['Float']['input'];
  poolId: Scalars['String']['input'];
  yieldCoupon: Scalars['Float']['input'];
};

export type CreateBorrowerInput = {
  aboutCeoName?: InputMaybe<Scalars['String']['input']>;
  aboutFoundedDate?: InputMaybe<Scalars['String']['input']>;
  aboutInfo?: InputMaybe<Scalars['String']['input']>;
  aboutNumEmployees?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  companyEmail: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  companyPublicName?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactName: Scalars['String']['input'];
  ethereumAddress: Scalars['String']['input'];
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  revenueUsage?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<BorrowerState>;
  telegram?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website: Scalars['String']['input'];
};

export type CreateCollateralTypeInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateCommitmentInput = {
  connector?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  days: Scalars['Int']['input'];
  depositTxes: Array<Scalars['String']['input']>;
  pool: Scalars['String']['input'];
  shares: Scalars['String']['input'];
  wallet: Scalars['ID']['input'];
};

export type CreateDelegateInput = {
  aboutBusiness: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  companySize?: InputMaybe<Scalars['Int']['input']>;
  deckFileName?: InputMaybe<Scalars['String']['input']>;
  deckFileUrl?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  owner: Scalars['String']['input'];
  profileUrl?: InputMaybe<Scalars['String']['input']>;
  telegram?: InputMaybe<Scalars['String']['input']>;
  totalAssetsUnderManagement?: InputMaybe<Scalars['Int']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website: Scalars['String']['input'];
};

export type CreateDepositInput = {
  symbol: CollateralAsset;
  totalDeposits?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLegalEntityInput = {
  countryOfOperation: Scalars['String']['input'];
  lendingAppetite: Scalars['String']['input'];
  name: Scalars['String']['input'];
  source?: InputMaybe<Source>;
};

export type CreateLendingEpochConfigurationInput = {
  epochRedemptionRate: Scalars['Int']['input'];
  pool: Scalars['String']['input'];
  schedule: Scalars['String']['input'];
};

export type CreateLiquidityManagerConfig = {
  gasThreshold: Scalars['String']['input'];
  maxGasPrice: Scalars['String']['input'];
  poolAddress: Scalars['String']['input'];
  reservedAssets: Scalars['String']['input'];
  strategies: Array<LiquidityManagerStrategyConfigInput>;
};

export type CreateLoanInput = {
  contractAddress: Scalars['String']['input'];
  nextCallDate?: InputMaybe<Scalars['String']['input']>;
  nonRecallPeriodDays?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateNativeAssetInput = {
  address: Scalars['String']['input'];
  collateralYield?: InputMaybe<Scalars['Int']['input']>;
  decimals: Scalars['Int']['input'];
  symbol: Scalars['String']['input'];
};

export type CreateNativePoolInput = {
  decimals: Scalars['Int']['input'];
  nativePoolId: Scalars['String']['input'];
};

export type CreatePoolCategoryInput = {
  color: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
};

export type CreatePoolInjectionInput = {
  address: Scalars['String']['input'];
  dryRun: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  maxInjectionAmount: Scalars['String']['input'];
  minInjectionAmount: Scalars['String']['input'];
  randomnessVariance: Scalars['Int']['input'];
  sourceWallet: Scalars['String']['input'];
  targetFrequency: Scalars['Int']['input'];
  targetYield: Scalars['Float']['input'];
  xirrPeriod: Scalars['Int']['input'];
};

export type CreatePoolInput = {
  asset?: InputMaybe<Scalars['String']['input']>;
  benchmarkApy?: InputMaybe<Scalars['String']['input']>;
  cardDescription?: InputMaybe<Scalars['String']['input']>;
  carouselPriority?: InputMaybe<Scalars['Int']['input']>;
  collateralApy?: InputMaybe<Scalars['String']['input']>;
  collateralType?: InputMaybe<Scalars['String']['input']>;
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  docSendUrl?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  highlights?: InputMaybe<Array<InputMaybe<PoolHighlightInput>>>;
  image?: InputMaybe<Scalars['String']['input']>;
  isACMPool?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isTreasuryPool?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  lendReqs?: InputMaybe<Array<LendReq>>;
  overview?: InputMaybe<Scalars['String']['input']>;
  permittedAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  poolCategory: Scalars['String']['input'];
  poolCollaterals?: InputMaybe<Array<PoolCollateralInput>>;
  poolDelegate?: InputMaybe<Scalars['String']['input']>;
  poolName: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  reportFileName?: InputMaybe<Scalars['String']['input']>;
  reportFileUrl?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<PoolV2State>;
  strategy: Scalars['String']['input'];
  underwritingBullets?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateSeasonInput = {
  dripsConversionRate?: InputMaybe<Scalars['Int']['input']>;
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type CreateUpcomingAllocationInput = {
  start: Scalars['String']['input'];
};

export type CreateUploadUrlInput = {
  directory: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type CreateUserInput = {
  accountType?: InputMaybe<AccountType>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Source>;
};

export enum Custodian {
  Anchorage = 'ANCHORAGE',
  Bitgo = 'BITGO',
  CoinbasePrime = 'COINBASE_PRIME',
  Fireblocks = 'FIREBLOCKS',
  Tradestation = 'TRADESTATION',
  Zodia = 'ZODIA'
}

export type DelegateMetadata = {
  __typename?: 'DelegateMetadata';
  _id?: Maybe<Scalars['String']['output']>;
  aboutBusiness?: Maybe<Scalars['String']['output']>;
  allowList?: Maybe<Scalars['Boolean']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deckFileName?: Maybe<Scalars['String']['output']>;
  deckFileUrl?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner: Scalars['String']['output'];
  profileUrl?: Maybe<Scalars['String']['output']>;
  telegram?: Maybe<Scalars['String']['output']>;
  totalAssetsUnderManagement?: Maybe<Scalars['Int']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type Deposit = {
  __typename?: 'Deposit';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  symbol: Scalars['String']['output'];
  totalDeposits: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type DepositSignature = {
  __typename?: 'DepositSignature';
  bitmap: Scalars['Int']['output'];
  deadline: Scalars['Int']['output'];
  r: Scalars['String']['output'];
  s: Scalars['String']['output'];
  v: Scalars['String']['output'];
};

export type DripsSnapshot = {
  __typename?: 'DripsSnapshot';
  accruedDripsByInterval: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  boosts?: Maybe<Array<SyrupBoost>>;
  commitment: Commitment;
  currentAmount: Scalars['String']['output'];
  currentDripsByInterval: Scalars['String']['output'];
  date: Scalars['String']['output'];
  dripsEarned: Scalars['String']['output'];
  lastWithdrawnDate?: Maybe<Scalars['String']['output']>;
  walletAddress: Scalars['String']['output'];
  withdrawnAmount: Scalars['String']['output'];
};

export type Erc20 = {
  __typename?: 'ERC20';
  address: Scalars['String']['output'];
  decimals: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
};

export type ExitCycle = {
  __typename?: 'ExitCycle';
  id: Scalars['ID']['output'];
  totalLockedShares: Scalars['BigInt']['output'];
  windowEnd: Scalars['BigInt']['output'];
  windowStart: Scalars['BigInt']['output'];
};

export type ExitCycle_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  totalLockedShares?: InputMaybe<Scalars['BigInt']['input']>;
  totalLockedShares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLockedShares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLockedShares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLockedShares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLockedShares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLockedShares_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLockedShares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  windowEnd?: InputMaybe<Scalars['BigInt']['input']>;
  windowEnd_gt?: InputMaybe<Scalars['BigInt']['input']>;
  windowEnd_gte?: InputMaybe<Scalars['BigInt']['input']>;
  windowEnd_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  windowEnd_lt?: InputMaybe<Scalars['BigInt']['input']>;
  windowEnd_lte?: InputMaybe<Scalars['BigInt']['input']>;
  windowEnd_not?: InputMaybe<Scalars['BigInt']['input']>;
  windowEnd_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  windowStart?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_gt?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_gte?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  windowStart_lt?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_lte?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_not?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum ExitCycle_OrderBy {
  Id = 'id',
  TotalLockedShares = 'totalLockedShares',
  WindowEnd = 'windowEnd',
  WindowStart = 'windowStart'
}

export type ExternalWallet = {
  __typename?: 'ExternalWallet';
  address: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSyrup: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type FeeManager = {
  __typename?: 'FeeManager';
  id: Scalars['ID']['output'];
  loans?: Maybe<Array<Loan>>;
};


export type FeeManagerLoansArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Loan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Loan_Filter>;
};

export type FeeManager_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  loans_?: InputMaybe<Loan_Filter>;
};

export enum FeeManager_OrderBy {
  Id = 'id',
  Loans = 'loans'
}

export type FileMetadata = {
  __typename?: 'FileMetadata';
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FileUploadUrl = {
  __typename?: 'FileUploadUrl';
  url: Scalars['String']['output'];
};

export type FunctionLevelBitmap = {
  __typename?: 'FunctionLevelBitmap';
  bitmap: Scalars['BigInt']['output'];
  functionId: Scalars['String']['output'];
  functionIdBytes: Scalars['Bytes']['output'];
  id: Scalars['ID']['output'];
  pool: PoolV2;
};

export type FunctionLevelBitmap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  bitmap?: InputMaybe<Scalars['BigInt']['input']>;
  bitmap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  bitmap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  bitmap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  bitmap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  bitmap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  bitmap_not?: InputMaybe<Scalars['BigInt']['input']>;
  bitmap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  functionId?: InputMaybe<Scalars['String']['input']>;
  functionIdBytes?: InputMaybe<Scalars['Bytes']['input']>;
  functionIdBytes_contains?: InputMaybe<Scalars['Bytes']['input']>;
  functionIdBytes_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  functionIdBytes_not?: InputMaybe<Scalars['Bytes']['input']>;
  functionIdBytes_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  functionIdBytes_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  functionId_contains?: InputMaybe<Scalars['String']['input']>;
  functionId_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  functionId_ends_with?: InputMaybe<Scalars['String']['input']>;
  functionId_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  functionId_gt?: InputMaybe<Scalars['String']['input']>;
  functionId_gte?: InputMaybe<Scalars['String']['input']>;
  functionId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  functionId_lt?: InputMaybe<Scalars['String']['input']>;
  functionId_lte?: InputMaybe<Scalars['String']['input']>;
  functionId_not?: InputMaybe<Scalars['String']['input']>;
  functionId_not_contains?: InputMaybe<Scalars['String']['input']>;
  functionId_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  functionId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  functionId_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  functionId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  functionId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  functionId_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  functionId_starts_with?: InputMaybe<Scalars['String']['input']>;
  functionId_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum FunctionLevelBitmap_OrderBy {
  Bitmap = 'bitmap',
  FunctionId = 'functionId',
  FunctionIdBytes = 'functionIdBytes',
  Id = 'id',
  Pool = 'pool'
}

export type Global = {
  __typename?: 'Global';
  defaultGracePeriod: Scalars['BigInt']['output'];
  fundingPeriod: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  investorFee: Scalars['BigInt']['output'];
  lpCooldownPeriod: Scalars['BigInt']['output'];
  lpWithdrawWindow: Scalars['BigInt']['output'];
  maxSwapSlippage: Scalars['BigInt']['output'];
  minLoanEquity: Scalars['BigInt']['output'];
  stakerCooldownPeriod: Scalars['BigInt']['output'];
  stakerUnstakeWindow: Scalars['BigInt']['output'];
  swapOutRequired: Scalars['BigInt']['output'];
  treasuryFee: Scalars['BigInt']['output'];
};

export type GlobalAllocation = {
  __typename?: 'GlobalAllocation';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  deadline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxId: Scalars['Int']['output'];
  merkleRoot: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  start?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type GlobalV2 = {
  __typename?: 'GlobalV2';
  id: Scalars['ID']['output'];
  mapleTreasury: Scalars['Bytes']['output'];
};

export type GlobalV2_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  mapleTreasury?: InputMaybe<Scalars['Bytes']['input']>;
  mapleTreasury_contains?: InputMaybe<Scalars['Bytes']['input']>;
  mapleTreasury_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  mapleTreasury_not?: InputMaybe<Scalars['Bytes']['input']>;
  mapleTreasury_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  mapleTreasury_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum GlobalV2_OrderBy {
  Id = 'id',
  MapleTreasury = 'mapleTreasury'
}

export type Global_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  defaultGracePeriod?: InputMaybe<Scalars['BigInt']['input']>;
  defaultGracePeriod_gt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultGracePeriod_gte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultGracePeriod_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultGracePeriod_lt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultGracePeriod_lte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultGracePeriod_not?: InputMaybe<Scalars['BigInt']['input']>;
  defaultGracePeriod_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriod_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriod_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriod_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingPeriod_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriod_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriod_not?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriod_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  investorFee?: InputMaybe<Scalars['BigInt']['input']>;
  investorFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  investorFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  investorFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  investorFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  investorFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  investorFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  investorFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpCooldownPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  lpCooldownPeriod_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lpCooldownPeriod_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lpCooldownPeriod_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpCooldownPeriod_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lpCooldownPeriod_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lpCooldownPeriod_not?: InputMaybe<Scalars['BigInt']['input']>;
  lpCooldownPeriod_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpWithdrawWindow?: InputMaybe<Scalars['BigInt']['input']>;
  lpWithdrawWindow_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lpWithdrawWindow_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lpWithdrawWindow_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpWithdrawWindow_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lpWithdrawWindow_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lpWithdrawWindow_not?: InputMaybe<Scalars['BigInt']['input']>;
  lpWithdrawWindow_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxSwapSlippage?: InputMaybe<Scalars['BigInt']['input']>;
  maxSwapSlippage_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maxSwapSlippage_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maxSwapSlippage_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxSwapSlippage_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maxSwapSlippage_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maxSwapSlippage_not?: InputMaybe<Scalars['BigInt']['input']>;
  maxSwapSlippage_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  minLoanEquity?: InputMaybe<Scalars['BigInt']['input']>;
  minLoanEquity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  minLoanEquity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  minLoanEquity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  minLoanEquity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  minLoanEquity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  minLoanEquity_not?: InputMaybe<Scalars['BigInt']['input']>;
  minLoanEquity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakerCooldownPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  stakerCooldownPeriod_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakerCooldownPeriod_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakerCooldownPeriod_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakerCooldownPeriod_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakerCooldownPeriod_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakerCooldownPeriod_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakerCooldownPeriod_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakerUnstakeWindow?: InputMaybe<Scalars['BigInt']['input']>;
  stakerUnstakeWindow_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakerUnstakeWindow_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakerUnstakeWindow_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakerUnstakeWindow_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakerUnstakeWindow_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakerUnstakeWindow_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakerUnstakeWindow_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  swapOutRequired?: InputMaybe<Scalars['BigInt']['input']>;
  swapOutRequired_gt?: InputMaybe<Scalars['BigInt']['input']>;
  swapOutRequired_gte?: InputMaybe<Scalars['BigInt']['input']>;
  swapOutRequired_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  swapOutRequired_lt?: InputMaybe<Scalars['BigInt']['input']>;
  swapOutRequired_lte?: InputMaybe<Scalars['BigInt']['input']>;
  swapOutRequired_not?: InputMaybe<Scalars['BigInt']['input']>;
  swapOutRequired_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  treasuryFee?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  treasuryFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Global_OrderBy {
  DefaultGracePeriod = 'defaultGracePeriod',
  FundingPeriod = 'fundingPeriod',
  Id = 'id',
  InvestorFee = 'investorFee',
  LpCooldownPeriod = 'lpCooldownPeriod',
  LpWithdrawWindow = 'lpWithdrawWindow',
  MaxSwapSlippage = 'maxSwapSlippage',
  MinLoanEquity = 'minLoanEquity',
  StakerCooldownPeriod = 'stakerCooldownPeriod',
  StakerUnstakeWindow = 'stakerUnstakeWindow',
  SwapOutRequired = 'swapOutRequired',
  TreasuryFee = 'treasuryFee'
}

export type HubspotFormSubmission = {
  __typename?: 'HubspotFormSubmission';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Injection = {
  __typename?: 'Injection';
  amount: Scalars['String']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
};

export type InterestStatement = {
  __typename?: 'InterestStatement';
  aggregated?: Maybe<Array<InterestStatementAggregated>>;
  breakdowns?: Maybe<Array<InterestStatementBreakdown>>;
  header: InterestStatementHeader;
};

export type InterestStatementAggregated = {
  __typename?: 'InterestStatementAggregated';
  currency: Scalars['String']['output'];
  decimals: Scalars['Int']['output'];
  deposits: Scalars['String']['output'];
  impairmentReversal: Scalars['String']['output'];
  lendingBalanceEnd: Scalars['String']['output'];
  lendingBalanceStart: Scalars['String']['output'];
  realizedLosses: Scalars['String']['output'];
  totalAccruedInterest: Scalars['String']['output'];
  withdrawals: Scalars['String']['output'];
};

export type InterestStatementBreakdown = {
  __typename?: 'InterestStatementBreakdown';
  currency: Scalars['String']['output'];
  decimals: Scalars['Int']['output'];
  impairmentReversal: Scalars['String']['output'];
  lendingBalanceEnd: Scalars['String']['output'];
  lendingBalanceStart: Scalars['String']['output'];
  poolName: Scalars['String']['output'];
  totalAccruedInterest: Scalars['String']['output'];
};

export type InterestStatementHeader = {
  __typename?: 'InterestStatementHeader';
  period: Scalars['String']['output'];
  statementBlockEnd?: Maybe<Scalars['Int']['output']>;
  statementBlockStart?: Maybe<Scalars['Int']['output']>;
  statementPeriodEnd: Scalars['String']['output'];
  statementPeriodStart: Scalars['String']['output'];
  walletAddress: Scalars['String']['output'];
};

export type InviteMemberToEntityInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
  role: MembershipRole;
};

export enum LendReq {
  AccountMla = 'AccountMLA',
  Accreditation = 'Accreditation',
  Kyc = 'KYC',
  Tax = 'Tax'
}

export type LendReqStatus = {
  __typename?: 'LendReqStatus';
  requirement: LendReq;
  status: SubmissionStatus;
};

export type LendingEpoch = {
  __typename?: 'LendingEpoch';
  endAt: Scalars['Int']['output'];
  epochRedemptionRate: Scalars['Int']['output'];
  inflows: Scalars['String']['output'];
  interval: Scalars['Int']['output'];
  outflowRequests: Scalars['String']['output'];
  outflows: Scalars['String']['output'];
  pool: Scalars['String']['output'];
  startAt: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type LendingEpochConfiguration = {
  __typename?: 'LendingEpochConfiguration';
  currentEpochBlockNumber?: Maybe<Scalars['Int']['output']>;
  epochRedemptionRate: Scalars['Int']['output'];
  interval: Scalars['Int']['output'];
  pool: Scalars['String']['output'];
  schedule: Scalars['String']['output'];
  startAt: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type LiquidationInfo = {
  __typename?: 'LiquidationInfo';
  fees: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  interest: Scalars['BigInt']['output'];
  lateInterest: Scalars['BigInt']['output'];
  principal: Scalars['BigInt']['output'];
};

export type LiquidationInfo_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  fees?: InputMaybe<Scalars['BigInt']['input']>;
  fees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fees_not?: InputMaybe<Scalars['BigInt']['input']>;
  fees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interest?: InputMaybe<Scalars['BigInt']['input']>;
  interest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interest_not?: InputMaybe<Scalars['BigInt']['input']>;
  interest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterest?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principal?: InputMaybe<Scalars['BigInt']['input']>;
  principal_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principal_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principal_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principal_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principal_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principal_not?: InputMaybe<Scalars['BigInt']['input']>;
  principal_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum LiquidationInfo_OrderBy {
  Fees = 'fees',
  Id = 'id',
  Interest = 'interest',
  LateInterest = 'lateInterest',
  Principal = 'principal'
}

export type LiquidityAsset = {
  __typename?: 'LiquidityAsset';
  decimals: Scalars['Int']['output'];
  symbol: CollateralAsset;
};

export type LiquidityAssetInput = {
  decimals: Scalars['Int']['input'];
  symbol: Scalars['String']['input'];
};

export type LiquidityManagerConfig = {
  __typename?: 'LiquidityManagerConfig';
  asset: Erc20;
  botEnabled: Scalars['Boolean']['output'];
  dryrunMode: Scalars['Boolean']['output'];
  gasThreshold?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxGasPrice?: Maybe<Scalars['String']['output']>;
  pool: Erc20;
  principalOut?: Maybe<Scalars['String']['output']>;
  reservedAssets?: Maybe<Scalars['String']['output']>;
  strategies: Array<LiquidityManagerStrategy>;
  strategiesEnabled: Scalars['Boolean']['output'];
  withdrawalsEnabled: Scalars['Boolean']['output'];
  wm: Wm;
};

export type LiquidityManagerStrategy = {
  __typename?: 'LiquidityManagerStrategy';
  address: Scalars['String']['output'];
  maxAum: Scalars['String']['output'];
  minTxAmount: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
};

export type LiquidityManagerStrategyConfigInput = {
  address: Scalars['String']['input'];
  maxAum: Scalars['String']['input'];
  minTxAmount: Scalars['String']['input'];
  priority: Scalars['Int']['input'];
  symbol: Scalars['String']['input'];
};

export type Loan = {
  __typename?: 'Loan';
  acmRatio?: Maybe<Scalars['String']['output']>;
  amountFunded: Scalars['BigInt']['output'];
  borrower: Account;
  claimableAmount: Scalars['BigInt']['output'];
  collateral?: Maybe<Collateral>;
  collateralAmount: Scalars['BigInt']['output'];
  collateralAsset: Asset;
  collateralLocker: Scalars['Bytes']['output'];
  collateralRatio: Scalars['BigInt']['output'];
  collateralRequired: Scalars['BigInt']['output'];
  collateralSwapped: Scalars['BigInt']['output'];
  debtLockerVersion: Scalars['Int']['output'];
  defaultSuffered: Scalars['BigInt']['output'];
  delegateOriginationFee?: Maybe<Scalars['BigInt']['output']>;
  delegateServiceFee?: Maybe<Scalars['BigInt']['output']>;
  drawdownAmount: Scalars['BigInt']['output'];
  drawdownAvailable: Scalars['BigInt']['output'];
  drawdownDate: Scalars['BigInt']['output'];
  earlyFeeRate: Scalars['BigInt']['output'];
  endingPrincipal: Scalars['BigInt']['output'];
  feeManager?: Maybe<FeeManager>;
  fundingDate: Scalars['BigInt']['output'];
  fundingLocker: Scalars['Bytes']['output'];
  fundingPeriodDays: Scalars['BigInt']['output'];
  fundingPool?: Maybe<PoolV2>;
  fundingPoolV1?: Maybe<Pool>;
  fundingTransaction?: Maybe<Transaction>;
  fundsRedirected: Scalars['BigInt']['output'];
  gracePeriodDays: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  impairDate: Scalars['BigInt']['output'];
  impairmentTxes?: Maybe<Array<Tx>>;
  initialEndingPrincipal: Scalars['BigInt']['output'];
  initialInterestRate: Scalars['BigInt']['output'];
  initialRequestAmount: Scalars['BigInt']['output'];
  initialTermDays: Scalars['BigInt']['output'];
  initialVersion: Scalars['Int']['output'];
  interestCalc: Scalars['Bytes']['output'];
  interestPaid: Scalars['BigInt']['output'];
  interestRate: Scalars['BigInt']['output'];
  isImpaired: Scalars['Boolean']['output'];
  isMigrationLoan: Scalars['Boolean']['output'];
  lateFeeCalc: Scalars['Bytes']['output'];
  lateFeeRate: Scalars['BigInt']['output'];
  lateInterestPremium: Scalars['BigInt']['output'];
  lender: LoanManager;
  liquidationExcess: Scalars['BigInt']['output'];
  liquidityAsset: Asset;
  liquidityAssetReturned: Scalars['BigInt']['output'];
  loanHistories?: Maybe<Array<LoanHistory>>;
  loanRefinances?: Maybe<Array<LoanRefinance>>;
  maturityDate: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  nextPayment: Scalars['BigInt']['output'];
  nextPaymentBreakdown?: Maybe<PaymentBreakdown>;
  nextPaymentDue: Scalars['BigInt']['output'];
  numLenders: Scalars['BigInt']['output'];
  numRefinances: Scalars['BigInt']['output'];
  paymentIntervalDays: Scalars['BigInt']['output'];
  paymentsRemaining: Scalars['BigInt']['output'];
  platformOriginationFee?: Maybe<Scalars['BigInt']['output']>;
  platformOriginationFeeRate?: Maybe<Scalars['BigInt']['output']>;
  platformServiceFee?: Maybe<Scalars['BigInt']['output']>;
  platformServiceFeeRate?: Maybe<Scalars['BigInt']['output']>;
  premiumCalc: Scalars['Bytes']['output'];
  principalOwed: Scalars['BigInt']['output'];
  repossessed: Scalars['Boolean']['output'];
  requestAmount: Scalars['BigInt']['output'];
  startDate: Scalars['BigInt']['output'];
  state: LoanState;
  stateDetail?: Maybe<LoanStateDetail>;
  symbol: Scalars['String']['output'];
  termDays: Scalars['BigInt']['output'];
  transaction: Transaction;
  treasuryFees: Scalars['BigInt']['output'];
  version: Scalars['Int']['output'];
};


export type LoanImpairmentTxesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Tx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Tx_Filter>;
};


export type LoanLoanHistoriesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanHistory_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LoanHistory_Filter>;
};


export type LoanLoanRefinancesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanRefinance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LoanRefinance_Filter>;
};

export type LoanHistory = {
  __typename?: 'LoanHistory';
  amountFunded: Scalars['BigInt']['output'];
  borrower: Account;
  claimableAmount: Scalars['BigInt']['output'];
  collateralAmount: Scalars['BigInt']['output'];
  collateralAsset: Asset;
  collateralRatio: Scalars['BigInt']['output'];
  collateralRequired: Scalars['BigInt']['output'];
  debtLockerVersion: Scalars['Int']['output'];
  delegateOriginationFee?: Maybe<Scalars['BigInt']['output']>;
  delegateServiceFee?: Maybe<Scalars['BigInt']['output']>;
  drawdownAmount: Scalars['BigInt']['output'];
  drawdownAvailable: Scalars['BigInt']['output'];
  earlyFeeRate: Scalars['BigInt']['output'];
  endingPrincipal: Scalars['BigInt']['output'];
  fundingPool?: Maybe<PoolV2>;
  fundingPoolV1?: Maybe<Pool>;
  fundsRedirected: Scalars['BigInt']['output'];
  gracePeriodDays: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  interestRate: Scalars['BigInt']['output'];
  isImpaired: Scalars['Boolean']['output'];
  lateFeeRate: Scalars['BigInt']['output'];
  lateInterestPremium: Scalars['BigInt']['output'];
  liquidityAsset: Asset;
  loan: Loan;
  maturityDate: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  nextPayment: Scalars['BigInt']['output'];
  nextPaymentBreakdown?: Maybe<PaymentBreakdown>;
  nextPaymentDue: Scalars['BigInt']['output'];
  paymentIntervalDays: Scalars['BigInt']['output'];
  paymentsRemaining: Scalars['BigInt']['output'];
  platformOriginationFee?: Maybe<Scalars['BigInt']['output']>;
  platformOriginationFeeRate?: Maybe<Scalars['BigInt']['output']>;
  platformServiceFee?: Maybe<Scalars['BigInt']['output']>;
  platformServiceFeeRate?: Maybe<Scalars['BigInt']['output']>;
  principalOwed: Scalars['BigInt']['output'];
  requestAmount: Scalars['BigInt']['output'];
  startDate: Scalars['BigInt']['output'];
  state: LoanState;
  termDays: Scalars['BigInt']['output'];
  transaction: Transaction;
  treasuryFees: Scalars['BigInt']['output'];
  version: Scalars['Int']['output'];
};

export type LoanHistory_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountFunded?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountFunded_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_not?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  borrower?: InputMaybe<Scalars['String']['input']>;
  borrower_?: InputMaybe<Account_Filter>;
  borrower_contains?: InputMaybe<Scalars['String']['input']>;
  borrower_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_ends_with?: InputMaybe<Scalars['String']['input']>;
  borrower_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_gt?: InputMaybe<Scalars['String']['input']>;
  borrower_gte?: InputMaybe<Scalars['String']['input']>;
  borrower_in?: InputMaybe<Array<Scalars['String']['input']>>;
  borrower_lt?: InputMaybe<Scalars['String']['input']>;
  borrower_lte?: InputMaybe<Scalars['String']['input']>;
  borrower_not?: InputMaybe<Scalars['String']['input']>;
  borrower_not_contains?: InputMaybe<Scalars['String']['input']>;
  borrower_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  borrower_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  borrower_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  borrower_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_starts_with?: InputMaybe<Scalars['String']['input']>;
  borrower_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  claimableAmount?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralAmount?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralAsset?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_?: InputMaybe<Asset_Filter>;
  collateralAsset_contains?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_gt?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_gte?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  collateralAsset_lt?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_lte?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  collateralAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralRatio?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralRatio_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralRequired?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralRequired_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debtLockerVersion?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_gt?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_gte?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  debtLockerVersion_lt?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_lte?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_not?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  delegateOriginationFee?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateOriginationFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFee?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  drawdownAmount?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  drawdownAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  drawdownAvailable?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_gt?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_gte?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  drawdownAvailable_lt?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_lte?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_not?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  earlyFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  earlyFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  endingPrincipal?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_gt?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_gte?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  endingPrincipal_lt?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_lte?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_not?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingPool?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_?: InputMaybe<Pool_Filter>;
  fundingPoolV1_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_gt?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_gte?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPoolV1_lt?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_lte?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPoolV1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_?: InputMaybe<PoolV2_Filter>;
  fundingPool_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_gt?: InputMaybe<Scalars['String']['input']>;
  fundingPool_gte?: InputMaybe<Scalars['String']['input']>;
  fundingPool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPool_lt?: InputMaybe<Scalars['String']['input']>;
  fundingPool_lte?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundsRedirected?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundsRedirected_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_not?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  gracePeriodDays?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_gt?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_gte?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  gracePeriodDays_lt?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_lte?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_not?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interestRate?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  isImpaired?: InputMaybe<Scalars['Boolean']['input']>;
  isImpaired_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isImpaired_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImpaired_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  lateFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPremium?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPremium_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityAsset?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_?: InputMaybe<Asset_Filter>;
  liquidityAsset_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_gt?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_gte?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityAsset_lt?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_lte?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  maturityDate?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maturityDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPayment?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentBreakdown?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_?: InputMaybe<PaymentBreakdown_Filter>;
  nextPaymentBreakdown_contains?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_ends_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_gt?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_gte?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nextPaymentBreakdown_lt?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_lte?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_contains?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nextPaymentBreakdown_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_starts_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentDue?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_gt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_gte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextPaymentDue_lt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_lte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_not?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextPayment_gt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPayment_gte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPayment_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextPayment_lt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPayment_lte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPayment_not?: InputMaybe<Scalars['BigInt']['input']>;
  nextPayment_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentIntervalDays?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_gt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_gte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentIntervalDays_lt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_lte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_not?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentsRemaining?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_gt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_gte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentsRemaining_lt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_lte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_not?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformOriginationFee?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformOriginationFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformOriginationFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformOriginationFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFee?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  requestAmount?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  requestAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startDate?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  state?: InputMaybe<LoanState>;
  state_in?: InputMaybe<Array<LoanState>>;
  state_not?: InputMaybe<LoanState>;
  state_not_in?: InputMaybe<Array<LoanState>>;
  termDays?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_gt?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_gte?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  termDays_lt?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_lte?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_not?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  treasuryFees?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  treasuryFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum LoanHistory_OrderBy {
  AmountFunded = 'amountFunded',
  Borrower = 'borrower',
  ClaimableAmount = 'claimableAmount',
  CollateralAmount = 'collateralAmount',
  CollateralAsset = 'collateralAsset',
  CollateralRatio = 'collateralRatio',
  CollateralRequired = 'collateralRequired',
  DebtLockerVersion = 'debtLockerVersion',
  DelegateOriginationFee = 'delegateOriginationFee',
  DelegateServiceFee = 'delegateServiceFee',
  DrawdownAmount = 'drawdownAmount',
  DrawdownAvailable = 'drawdownAvailable',
  EarlyFeeRate = 'earlyFeeRate',
  EndingPrincipal = 'endingPrincipal',
  FundingPool = 'fundingPool',
  FundingPoolV1 = 'fundingPoolV1',
  FundsRedirected = 'fundsRedirected',
  GracePeriodDays = 'gracePeriodDays',
  Id = 'id',
  InterestRate = 'interestRate',
  IsImpaired = 'isImpaired',
  LateFeeRate = 'lateFeeRate',
  LateInterestPremium = 'lateInterestPremium',
  LiquidityAsset = 'liquidityAsset',
  Loan = 'loan',
  MaturityDate = 'maturityDate',
  Name = 'name',
  NextPayment = 'nextPayment',
  NextPaymentBreakdown = 'nextPaymentBreakdown',
  NextPaymentDue = 'nextPaymentDue',
  PaymentIntervalDays = 'paymentIntervalDays',
  PaymentsRemaining = 'paymentsRemaining',
  PlatformOriginationFee = 'platformOriginationFee',
  PlatformOriginationFeeRate = 'platformOriginationFeeRate',
  PlatformServiceFee = 'platformServiceFee',
  PlatformServiceFeeRate = 'platformServiceFeeRate',
  PrincipalOwed = 'principalOwed',
  RequestAmount = 'requestAmount',
  StartDate = 'startDate',
  State = 'state',
  TermDays = 'termDays',
  Transaction = 'transaction',
  TreasuryFees = 'treasuryFees',
  Version = 'version'
}

export type LoanManager = {
  __typename?: 'LoanManager';
  accountedInterest: Scalars['BigInt']['output'];
  domainEnd: Scalars['BigInt']['output'];
  domainStart: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  issuanceRate: Scalars['BigInt']['output'];
  pool: PoolV2;
  principalOut: Scalars['BigInt']['output'];
  version: Scalars['Int']['output'];
};

export type LoanManager_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  accountedInterest?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  accountedInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainEnd?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_gt?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_gte?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainEnd_lt?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_lte?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_not?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainStart?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_gt?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_gte?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainStart_lt?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_lte?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_not?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  issuanceRate?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  issuanceRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  principalOut?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOut_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum LoanManager_OrderBy {
  AccountedInterest = 'accountedInterest',
  DomainEnd = 'domainEnd',
  DomainStart = 'domainStart',
  Id = 'id',
  IssuanceRate = 'issuanceRate',
  Pool = 'pool',
  PrincipalOut = 'principalOut',
  Version = 'version'
}

export type LoanMap = {
  __typename?: 'LoanMap';
  id: Scalars['ID']['output'];
  loan: Loan;
};

export type LoanMap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum LoanMap_OrderBy {
  Id = 'id',
  Loan = 'loan'
}

export type LoanMetadata = {
  __typename?: 'LoanMetadata';
  _id: Scalars['String']['output'];
  contractAddress: Scalars['String']['output'];
  nextCallDate?: Maybe<Scalars['String']['output']>;
  nonRecallPeriodDays?: Maybe<Scalars['Int']['output']>;
};

export type LoanPosition = {
  __typename?: 'LoanPosition';
  amount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  loan: Loan;
  owner: Scalars['Bytes']['output'];
  pool: Pool;
  principalOwed: Scalars['BigInt']['output'];
  state: LoanState;
  transaction: Transaction;
};

export type LoanPositionMap = {
  __typename?: 'LoanPositionMap';
  id: Scalars['ID']['output'];
  loanPosition: LoanPosition;
};

export type LoanPositionMap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  loanPosition?: InputMaybe<Scalars['String']['input']>;
  loanPosition_?: InputMaybe<LoanPosition_Filter>;
  loanPosition_contains?: InputMaybe<Scalars['String']['input']>;
  loanPosition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loanPosition_ends_with?: InputMaybe<Scalars['String']['input']>;
  loanPosition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanPosition_gt?: InputMaybe<Scalars['String']['input']>;
  loanPosition_gte?: InputMaybe<Scalars['String']['input']>;
  loanPosition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loanPosition_lt?: InputMaybe<Scalars['String']['input']>;
  loanPosition_lte?: InputMaybe<Scalars['String']['input']>;
  loanPosition_not?: InputMaybe<Scalars['String']['input']>;
  loanPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  loanPosition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loanPosition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loanPosition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanPosition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loanPosition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loanPosition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanPosition_starts_with?: InputMaybe<Scalars['String']['input']>;
  loanPosition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum LoanPositionMap_OrderBy {
  Id = 'id',
  LoanPosition = 'loanPosition'
}

export type LoanPosition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['Bytes']['input']>;
  owner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  owner_not?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<Pool_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  principalOwed?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  state?: InputMaybe<LoanState>;
  state_in?: InputMaybe<Array<LoanState>>;
  state_not?: InputMaybe<LoanState>;
  state_not_in?: InputMaybe<Array<LoanState>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum LoanPosition_OrderBy {
  Amount = 'amount',
  Id = 'id',
  Loan = 'loan',
  Owner = 'owner',
  Pool = 'pool',
  PrincipalOwed = 'principalOwed',
  State = 'state',
  Transaction = 'transaction'
}

export type LoanRefinance = {
  __typename?: 'LoanRefinance';
  calls: Array<Scalars['Bytes']['output']>;
  deadline: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  loan?: Maybe<Loan>;
  loanHistory?: Maybe<LoanHistory>;
  principalOwed: Scalars['BigInt']['output'];
  refinanceCalls: RefinanceCalls;
  refinanceInterest: Scalars['BigInt']['output'];
  status: RefinanceStatus;
  updatedAt: Scalars['BigInt']['output'];
};

export type LoanRefinance_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  calls?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  calls_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  calls_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  calls_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  calls_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  calls_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  deadline?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_gt?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_gte?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  deadline_lt?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_lte?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_not?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loanHistory?: InputMaybe<Scalars['String']['input']>;
  loanHistory_?: InputMaybe<LoanHistory_Filter>;
  loanHistory_contains?: InputMaybe<Scalars['String']['input']>;
  loanHistory_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loanHistory_ends_with?: InputMaybe<Scalars['String']['input']>;
  loanHistory_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanHistory_gt?: InputMaybe<Scalars['String']['input']>;
  loanHistory_gte?: InputMaybe<Scalars['String']['input']>;
  loanHistory_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loanHistory_lt?: InputMaybe<Scalars['String']['input']>;
  loanHistory_lte?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_contains?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loanHistory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanHistory_starts_with?: InputMaybe<Scalars['String']['input']>;
  loanHistory_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  principalOwed?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  refinanceCalls?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_?: InputMaybe<RefinanceCalls_Filter>;
  refinanceCalls_contains?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_ends_with?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_gt?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_gte?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_in?: InputMaybe<Array<Scalars['String']['input']>>;
  refinanceCalls_lt?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_lte?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_contains?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  refinanceCalls_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_starts_with?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceInterest?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  refinanceInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  status?: InputMaybe<RefinanceStatus>;
  status_in?: InputMaybe<Array<RefinanceStatus>>;
  status_not?: InputMaybe<RefinanceStatus>;
  status_not_in?: InputMaybe<Array<RefinanceStatus>>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum LoanRefinance_OrderBy {
  Calls = 'calls',
  Deadline = 'deadline',
  Id = 'id',
  Loan = 'loan',
  LoanHistory = 'loanHistory',
  PrincipalOwed = 'principalOwed',
  RefinanceCalls = 'refinanceCalls',
  RefinanceInterest = 'refinanceInterest',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export enum LoanState {
  Active = 'Active',
  DrawdownFunds = 'DrawdownFunds',
  Liquidated = 'Liquidated',
  LiquidatedAndClaimed = 'LiquidatedAndClaimed',
  Matured = 'Matured',
  RemoveCollateral = 'RemoveCollateral',
  Unfunded = 'Unfunded',
  WaitingForAcceptance = 'WaitingForAcceptance'
}

export enum LoanStateDetail {
  ActiveDefaulted = 'ActiveDefaulted',
  ActiveInArrears = 'ActiveInArrears',
  ActiveRepaymentDue = 'ActiveRepaymentDue',
  UnfundedExpired = 'UnfundedExpired',
  WaitingForAcceptanceExpired = 'WaitingForAcceptanceExpired'
}

export type Loan_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountFunded?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountFunded_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_not?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  borrower?: InputMaybe<Scalars['String']['input']>;
  borrower_?: InputMaybe<Account_Filter>;
  borrower_contains?: InputMaybe<Scalars['String']['input']>;
  borrower_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_ends_with?: InputMaybe<Scalars['String']['input']>;
  borrower_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_gt?: InputMaybe<Scalars['String']['input']>;
  borrower_gte?: InputMaybe<Scalars['String']['input']>;
  borrower_in?: InputMaybe<Array<Scalars['String']['input']>>;
  borrower_lt?: InputMaybe<Scalars['String']['input']>;
  borrower_lte?: InputMaybe<Scalars['String']['input']>;
  borrower_not?: InputMaybe<Scalars['String']['input']>;
  borrower_not_contains?: InputMaybe<Scalars['String']['input']>;
  borrower_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  borrower_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  borrower_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  borrower_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_starts_with?: InputMaybe<Scalars['String']['input']>;
  borrower_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  claimableAmount?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  claimableAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralAmount?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateralAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralAsset?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_?: InputMaybe<Asset_Filter>;
  collateralAsset_contains?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_gt?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_gte?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  collateralAsset_lt?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_lte?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  collateralAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  collateralAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  collateralLocker?: InputMaybe<Scalars['Bytes']['input']>;
  collateralLocker_contains?: InputMaybe<Scalars['Bytes']['input']>;
  collateralLocker_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  collateralLocker_not?: InputMaybe<Scalars['Bytes']['input']>;
  collateralLocker_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  collateralLocker_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  collateralRatio?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralRatio_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRatio_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralRequired?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralRequired_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateralRequired_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralSwapped?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSwapped_gt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSwapped_gte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSwapped_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralSwapped_lt?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSwapped_lte?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSwapped_not?: InputMaybe<Scalars['BigInt']['input']>;
  collateralSwapped_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  debtLockerVersion?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_gt?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_gte?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  debtLockerVersion_lt?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_lte?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_not?: InputMaybe<Scalars['Int']['input']>;
  debtLockerVersion_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  defaultSuffered?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_gt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_gte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultSuffered_lt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_lte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_not?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateOriginationFee?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateOriginationFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateOriginationFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFee?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  drawdownAmount?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  drawdownAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  drawdownAvailable?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_gt?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_gte?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  drawdownAvailable_lt?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_lte?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_not?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownAvailable_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  drawdownDate?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  drawdownDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  drawdownDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  earlyFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  earlyFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  earlyFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  endingPrincipal?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_gt?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_gte?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  endingPrincipal_lt?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_lte?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_not?: InputMaybe<Scalars['BigInt']['input']>;
  endingPrincipal_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feeManager?: InputMaybe<Scalars['String']['input']>;
  feeManager_?: InputMaybe<FeeManager_Filter>;
  feeManager_contains?: InputMaybe<Scalars['String']['input']>;
  feeManager_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  feeManager_ends_with?: InputMaybe<Scalars['String']['input']>;
  feeManager_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  feeManager_gt?: InputMaybe<Scalars['String']['input']>;
  feeManager_gte?: InputMaybe<Scalars['String']['input']>;
  feeManager_in?: InputMaybe<Array<Scalars['String']['input']>>;
  feeManager_lt?: InputMaybe<Scalars['String']['input']>;
  feeManager_lte?: InputMaybe<Scalars['String']['input']>;
  feeManager_not?: InputMaybe<Scalars['String']['input']>;
  feeManager_not_contains?: InputMaybe<Scalars['String']['input']>;
  feeManager_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  feeManager_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  feeManager_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  feeManager_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  feeManager_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  feeManager_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  feeManager_starts_with?: InputMaybe<Scalars['String']['input']>;
  feeManager_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingDate?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingLocker?: InputMaybe<Scalars['Bytes']['input']>;
  fundingLocker_contains?: InputMaybe<Scalars['Bytes']['input']>;
  fundingLocker_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  fundingLocker_not?: InputMaybe<Scalars['Bytes']['input']>;
  fundingLocker_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  fundingLocker_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  fundingPeriodDays?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriodDays_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriodDays_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriodDays_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingPeriodDays_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriodDays_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriodDays_not?: InputMaybe<Scalars['BigInt']['input']>;
  fundingPeriodDays_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingPool?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_?: InputMaybe<Pool_Filter>;
  fundingPoolV1_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_gt?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_gte?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPoolV1_lt?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_lte?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPoolV1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPoolV1_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_?: InputMaybe<PoolV2_Filter>;
  fundingPool_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_gt?: InputMaybe<Scalars['String']['input']>;
  fundingPool_gte?: InputMaybe<Scalars['String']['input']>;
  fundingPool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPool_lt?: InputMaybe<Scalars['String']['input']>;
  fundingPool_lte?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_?: InputMaybe<Transaction_Filter>;
  fundingTransaction_contains?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_gt?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_gte?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingTransaction_lt?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_lte?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingTransaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundsRedirected?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundsRedirected_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_not?: InputMaybe<Scalars['BigInt']['input']>;
  fundsRedirected_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  gracePeriodDays?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_gt?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_gte?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  gracePeriodDays_lt?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_lte?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_not?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodDays_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  impairDate?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  impairDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  impairmentTxes_?: InputMaybe<Tx_Filter>;
  initialEndingPrincipal?: InputMaybe<Scalars['BigInt']['input']>;
  initialEndingPrincipal_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialEndingPrincipal_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialEndingPrincipal_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialEndingPrincipal_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialEndingPrincipal_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialEndingPrincipal_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialEndingPrincipal_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialInterestRate?: InputMaybe<Scalars['BigInt']['input']>;
  initialInterestRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialInterestRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialInterestRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialInterestRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialInterestRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialInterestRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialInterestRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialRequestAmount?: InputMaybe<Scalars['BigInt']['input']>;
  initialRequestAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialRequestAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialRequestAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialRequestAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialRequestAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialRequestAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialRequestAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialTermDays?: InputMaybe<Scalars['BigInt']['input']>;
  initialTermDays_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialTermDays_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialTermDays_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialTermDays_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialTermDays_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialTermDays_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialTermDays_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialVersion?: InputMaybe<Scalars['Int']['input']>;
  initialVersion_gt?: InputMaybe<Scalars['Int']['input']>;
  initialVersion_gte?: InputMaybe<Scalars['Int']['input']>;
  initialVersion_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  initialVersion_lt?: InputMaybe<Scalars['Int']['input']>;
  initialVersion_lte?: InputMaybe<Scalars['Int']['input']>;
  initialVersion_not?: InputMaybe<Scalars['Int']['input']>;
  initialVersion_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  interestCalc?: InputMaybe<Scalars['Bytes']['input']>;
  interestCalc_contains?: InputMaybe<Scalars['Bytes']['input']>;
  interestCalc_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  interestCalc_not?: InputMaybe<Scalars['Bytes']['input']>;
  interestCalc_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  interestCalc_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  interestPaid?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestPaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestRate?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  isImpaired?: InputMaybe<Scalars['Boolean']['input']>;
  isImpaired_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isImpaired_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImpaired_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isMigrationLoan?: InputMaybe<Scalars['Boolean']['input']>;
  isMigrationLoan_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isMigrationLoan_not?: InputMaybe<Scalars['Boolean']['input']>;
  isMigrationLoan_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  lateFeeCalc?: InputMaybe<Scalars['Bytes']['input']>;
  lateFeeCalc_contains?: InputMaybe<Scalars['Bytes']['input']>;
  lateFeeCalc_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  lateFeeCalc_not?: InputMaybe<Scalars['Bytes']['input']>;
  lateFeeCalc_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  lateFeeCalc_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  lateFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPremium?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPremium_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lender?: InputMaybe<Scalars['String']['input']>;
  lender_?: InputMaybe<LoanManager_Filter>;
  lender_contains?: InputMaybe<Scalars['String']['input']>;
  lender_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_ends_with?: InputMaybe<Scalars['String']['input']>;
  lender_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_gt?: InputMaybe<Scalars['String']['input']>;
  lender_gte?: InputMaybe<Scalars['String']['input']>;
  lender_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lender_lt?: InputMaybe<Scalars['String']['input']>;
  lender_lte?: InputMaybe<Scalars['String']['input']>;
  lender_not?: InputMaybe<Scalars['String']['input']>;
  lender_not_contains?: InputMaybe<Scalars['String']['input']>;
  lender_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lender_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lender_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lender_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_starts_with?: InputMaybe<Scalars['String']['input']>;
  lender_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidationExcess?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationExcess_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationExcess_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationExcess_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidationExcess_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationExcess_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationExcess_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidationExcess_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityAsset?: InputMaybe<Scalars['String']['input']>;
  liquidityAssetReturned?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetReturned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetReturned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetReturned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityAssetReturned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetReturned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetReturned_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetReturned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityAsset_?: InputMaybe<Asset_Filter>;
  liquidityAsset_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_gt?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_gte?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityAsset_lt?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_lte?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanHistories_?: InputMaybe<LoanHistory_Filter>;
  loanRefinances_?: InputMaybe<LoanRefinance_Filter>;
  maturityDate?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maturityDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPayment?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentBreakdown?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_?: InputMaybe<PaymentBreakdown_Filter>;
  nextPaymentBreakdown_contains?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_ends_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_gt?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_gte?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nextPaymentBreakdown_lt?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_lte?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_contains?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nextPaymentBreakdown_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_starts_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentDue?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_gt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_gte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextPaymentDue_lt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_lte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_not?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextPayment_gt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPayment_gte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPayment_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextPayment_lt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPayment_lte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPayment_not?: InputMaybe<Scalars['BigInt']['input']>;
  nextPayment_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numLenders?: InputMaybe<Scalars['BigInt']['input']>;
  numLenders_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numLenders_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numLenders_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numLenders_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numLenders_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numLenders_not?: InputMaybe<Scalars['BigInt']['input']>;
  numLenders_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numRefinances?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numRefinances_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_not?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentIntervalDays?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_gt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_gte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentIntervalDays_lt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_lte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_not?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentsRemaining?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_gt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_gte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentsRemaining_lt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_lte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_not?: InputMaybe<Scalars['BigInt']['input']>;
  paymentsRemaining_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformOriginationFee?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformOriginationFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformOriginationFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformOriginationFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFee?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  premiumCalc?: InputMaybe<Scalars['Bytes']['input']>;
  premiumCalc_contains?: InputMaybe<Scalars['Bytes']['input']>;
  premiumCalc_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  premiumCalc_not?: InputMaybe<Scalars['Bytes']['input']>;
  premiumCalc_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  premiumCalc_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  principalOwed?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  repossessed?: InputMaybe<Scalars['Boolean']['input']>;
  repossessed_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  repossessed_not?: InputMaybe<Scalars['Boolean']['input']>;
  repossessed_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  requestAmount?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  requestAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startDate?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  state?: InputMaybe<LoanState>;
  state_in?: InputMaybe<Array<LoanState>>;
  state_not?: InputMaybe<LoanState>;
  state_not_in?: InputMaybe<Array<LoanState>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  termDays?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_gt?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_gte?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  termDays_lt?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_lte?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_not?: InputMaybe<Scalars['BigInt']['input']>;
  termDays_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  treasuryFees?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  treasuryFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum Loan_OrderBy {
  AmountFunded = 'amountFunded',
  Borrower = 'borrower',
  ClaimableAmount = 'claimableAmount',
  CollateralAmount = 'collateralAmount',
  CollateralAsset = 'collateralAsset',
  CollateralLocker = 'collateralLocker',
  CollateralRatio = 'collateralRatio',
  CollateralRequired = 'collateralRequired',
  CollateralSwapped = 'collateralSwapped',
  DebtLockerVersion = 'debtLockerVersion',
  DefaultSuffered = 'defaultSuffered',
  DelegateOriginationFee = 'delegateOriginationFee',
  DelegateServiceFee = 'delegateServiceFee',
  DrawdownAmount = 'drawdownAmount',
  DrawdownAvailable = 'drawdownAvailable',
  DrawdownDate = 'drawdownDate',
  EarlyFeeRate = 'earlyFeeRate',
  EndingPrincipal = 'endingPrincipal',
  FeeManager = 'feeManager',
  FundingDate = 'fundingDate',
  FundingLocker = 'fundingLocker',
  FundingPeriodDays = 'fundingPeriodDays',
  FundingPool = 'fundingPool',
  FundingPoolV1 = 'fundingPoolV1',
  FundingTransaction = 'fundingTransaction',
  FundsRedirected = 'fundsRedirected',
  GracePeriodDays = 'gracePeriodDays',
  Id = 'id',
  ImpairDate = 'impairDate',
  ImpairmentTxes = 'impairmentTxes',
  InitialEndingPrincipal = 'initialEndingPrincipal',
  InitialInterestRate = 'initialInterestRate',
  InitialRequestAmount = 'initialRequestAmount',
  InitialTermDays = 'initialTermDays',
  InitialVersion = 'initialVersion',
  InterestCalc = 'interestCalc',
  InterestPaid = 'interestPaid',
  InterestRate = 'interestRate',
  IsImpaired = 'isImpaired',
  IsMigrationLoan = 'isMigrationLoan',
  LateFeeCalc = 'lateFeeCalc',
  LateFeeRate = 'lateFeeRate',
  LateInterestPremium = 'lateInterestPremium',
  Lender = 'lender',
  LiquidationExcess = 'liquidationExcess',
  LiquidityAsset = 'liquidityAsset',
  LiquidityAssetReturned = 'liquidityAssetReturned',
  LoanHistories = 'loanHistories',
  LoanRefinances = 'loanRefinances',
  MaturityDate = 'maturityDate',
  Name = 'name',
  NextPayment = 'nextPayment',
  NextPaymentBreakdown = 'nextPaymentBreakdown',
  NextPaymentDue = 'nextPaymentDue',
  NumLenders = 'numLenders',
  NumRefinances = 'numRefinances',
  PaymentIntervalDays = 'paymentIntervalDays',
  PaymentsRemaining = 'paymentsRemaining',
  PlatformOriginationFee = 'platformOriginationFee',
  PlatformOriginationFeeRate = 'platformOriginationFeeRate',
  PlatformServiceFee = 'platformServiceFee',
  PlatformServiceFeeRate = 'platformServiceFeeRate',
  PremiumCalc = 'premiumCalc',
  PrincipalOwed = 'principalOwed',
  Repossessed = 'repossessed',
  RequestAmount = 'requestAmount',
  StartDate = 'startDate',
  State = 'state',
  Symbol = 'symbol',
  TermDays = 'termDays',
  Transaction = 'transaction',
  TreasuryFees = 'treasuryFees',
  Version = 'version'
}

export type MplTx = {
  __typename?: 'MPLTx';
  account: Account;
  id: Scalars['ID']['output'];
  timestamp: Scalars['BigInt']['output'];
  tokensMigrated: Scalars['BigInt']['output'];
  transaction: Transaction;
};

export type MplTx_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokensMigrated?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokensMigrated_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_not?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum MplTx_OrderBy {
  Account = 'account',
  Id = 'id',
  Timestamp = 'timestamp',
  TokensMigrated = 'tokensMigrated',
  Transaction = 'transaction'
}

export type Maple = {
  __typename?: 'Maple';
  aggregateLpApy: Scalars['BigInt']['output'];
  global: Global;
  globalV2: GlobalV2;
  governor: Scalars['Bytes']['output'];
  id: Scalars['ID']['output'];
  mpl: Asset;
  numAssets: Scalars['BigInt']['output'];
  numUniqueBorrowers?: Maybe<Scalars['String']['output']>;
  operationalAdmin: Scalars['Bytes']['output'];
  tokenStats?: Maybe<TokenStats>;
  totalActiveLoans: Scalars['BigInt']['output'];
  totalCurrentLoaned: Scalars['BigInt']['output'];
  totalInterestEarned: Scalars['BigInt']['output'];
  totalInterestEarnedV2?: Maybe<Scalars['String']['output']>;
  totalLiquidity: Scalars['BigDecimal']['output'];
  totalLiquidityCap: Scalars['BigInt']['output'];
  totalLiquidityProvided: Scalars['BigInt']['output'];
  totalLoanOriginations: Scalars['BigInt']['output'];
  totalLoans: Scalars['BigInt']['output'];
  totalNativeLoanOriginations?: Maybe<Scalars['String']['output']>;
  totalPoolV2s: Scalars['BigInt']['output'];
  totalPools: Scalars['BigInt']['output'];
  totalPrincipalOut?: Maybe<Scalars['String']['output']>;
  totalTreasuryFees: Scalars['BigInt']['output'];
  totalValueLocked: Scalars['BigDecimal']['output'];
  totalValueLockedV2?: Maybe<Scalars['String']['output']>;
  totalsByAsset: Array<Total>;
  xMPL?: Maybe<XMpl>;
};


export type MapleTotalsByAssetArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Total_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Total_Filter>;
};

export type Maple_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  aggregateLpApy?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_gt?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_gte?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  aggregateLpApy_lt?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_lte?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_not?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  global?: InputMaybe<Scalars['String']['input']>;
  globalV2?: InputMaybe<Scalars['String']['input']>;
  globalV2_?: InputMaybe<GlobalV2_Filter>;
  globalV2_contains?: InputMaybe<Scalars['String']['input']>;
  globalV2_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  globalV2_ends_with?: InputMaybe<Scalars['String']['input']>;
  globalV2_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  globalV2_gt?: InputMaybe<Scalars['String']['input']>;
  globalV2_gte?: InputMaybe<Scalars['String']['input']>;
  globalV2_in?: InputMaybe<Array<Scalars['String']['input']>>;
  globalV2_lt?: InputMaybe<Scalars['String']['input']>;
  globalV2_lte?: InputMaybe<Scalars['String']['input']>;
  globalV2_not?: InputMaybe<Scalars['String']['input']>;
  globalV2_not_contains?: InputMaybe<Scalars['String']['input']>;
  globalV2_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  globalV2_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  globalV2_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  globalV2_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  globalV2_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  globalV2_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  globalV2_starts_with?: InputMaybe<Scalars['String']['input']>;
  globalV2_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  global_?: InputMaybe<Global_Filter>;
  global_contains?: InputMaybe<Scalars['String']['input']>;
  global_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  global_ends_with?: InputMaybe<Scalars['String']['input']>;
  global_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  global_gt?: InputMaybe<Scalars['String']['input']>;
  global_gte?: InputMaybe<Scalars['String']['input']>;
  global_in?: InputMaybe<Array<Scalars['String']['input']>>;
  global_lt?: InputMaybe<Scalars['String']['input']>;
  global_lte?: InputMaybe<Scalars['String']['input']>;
  global_not?: InputMaybe<Scalars['String']['input']>;
  global_not_contains?: InputMaybe<Scalars['String']['input']>;
  global_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  global_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  global_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  global_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  global_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  global_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  global_starts_with?: InputMaybe<Scalars['String']['input']>;
  global_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  governor?: InputMaybe<Scalars['Bytes']['input']>;
  governor_contains?: InputMaybe<Scalars['Bytes']['input']>;
  governor_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  governor_not?: InputMaybe<Scalars['Bytes']['input']>;
  governor_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  governor_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  mpl?: InputMaybe<Scalars['String']['input']>;
  mpl_?: InputMaybe<Asset_Filter>;
  mpl_contains?: InputMaybe<Scalars['String']['input']>;
  mpl_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  mpl_ends_with?: InputMaybe<Scalars['String']['input']>;
  mpl_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  mpl_gt?: InputMaybe<Scalars['String']['input']>;
  mpl_gte?: InputMaybe<Scalars['String']['input']>;
  mpl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  mpl_lt?: InputMaybe<Scalars['String']['input']>;
  mpl_lte?: InputMaybe<Scalars['String']['input']>;
  mpl_not?: InputMaybe<Scalars['String']['input']>;
  mpl_not_contains?: InputMaybe<Scalars['String']['input']>;
  mpl_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  mpl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  mpl_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  mpl_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  mpl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  mpl_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  mpl_starts_with?: InputMaybe<Scalars['String']['input']>;
  mpl_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  numAssets?: InputMaybe<Scalars['BigInt']['input']>;
  numAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  numAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  operationalAdmin?: InputMaybe<Scalars['Bytes']['input']>;
  operationalAdmin_contains?: InputMaybe<Scalars['Bytes']['input']>;
  operationalAdmin_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  operationalAdmin_not?: InputMaybe<Scalars['Bytes']['input']>;
  operationalAdmin_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  operationalAdmin_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  totalActiveLoans?: InputMaybe<Scalars['BigInt']['input']>;
  totalActiveLoans_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalActiveLoans_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalActiveLoans_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalActiveLoans_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalActiveLoans_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalActiveLoans_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalActiveLoans_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalCurrentLoaned?: InputMaybe<Scalars['BigInt']['input']>;
  totalCurrentLoaned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalCurrentLoaned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalCurrentLoaned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalCurrentLoaned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalCurrentLoaned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalCurrentLoaned_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalCurrentLoaned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalInterestEarned?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalInterestEarned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidityCap?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityCap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityCap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityCap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidityCap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityCap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityCap_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityCap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidityProvided?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityProvided_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityProvided_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityProvided_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidityProvided_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityProvided_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityProvided_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLiquidityProvided_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLiquidity_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidity_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidity_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalLiquidity_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidity_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidity_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidity_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalLoanOriginations?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLoanOriginations_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLoans?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoans_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoans_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoans_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLoans_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoans_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoans_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoans_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPoolV2s?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolV2s_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolV2s_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolV2s_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPoolV2s_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolV2s_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolV2s_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolV2s_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPools?: InputMaybe<Scalars['BigInt']['input']>;
  totalPools_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPools_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPools_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPools_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPools_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPools_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalPools_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalTreasuryFees?: InputMaybe<Scalars['BigInt']['input']>;
  totalTreasuryFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalTreasuryFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalTreasuryFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalTreasuryFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalTreasuryFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalTreasuryFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalTreasuryFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalValueLocked?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalValueLocked_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalValueLocked_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalValueLocked_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalValueLocked_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalValueLocked_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalValueLocked_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalValueLocked_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalsByAsset?: InputMaybe<Array<Scalars['String']['input']>>;
  totalsByAsset_?: InputMaybe<Total_Filter>;
  totalsByAsset_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  totalsByAsset_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  totalsByAsset_not?: InputMaybe<Array<Scalars['String']['input']>>;
  totalsByAsset_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  totalsByAsset_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  xMPL?: InputMaybe<Scalars['String']['input']>;
  xMPL_?: InputMaybe<XMpl_Filter>;
  xMPL_contains?: InputMaybe<Scalars['String']['input']>;
  xMPL_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  xMPL_ends_with?: InputMaybe<Scalars['String']['input']>;
  xMPL_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  xMPL_gt?: InputMaybe<Scalars['String']['input']>;
  xMPL_gte?: InputMaybe<Scalars['String']['input']>;
  xMPL_in?: InputMaybe<Array<Scalars['String']['input']>>;
  xMPL_lt?: InputMaybe<Scalars['String']['input']>;
  xMPL_lte?: InputMaybe<Scalars['String']['input']>;
  xMPL_not?: InputMaybe<Scalars['String']['input']>;
  xMPL_not_contains?: InputMaybe<Scalars['String']['input']>;
  xMPL_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  xMPL_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  xMPL_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  xMPL_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  xMPL_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  xMPL_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  xMPL_starts_with?: InputMaybe<Scalars['String']['input']>;
  xMPL_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Maple_OrderBy {
  AggregateLpApy = 'aggregateLpApy',
  Global = 'global',
  GlobalV2 = 'globalV2',
  Governor = 'governor',
  Id = 'id',
  Mpl = 'mpl',
  NumAssets = 'numAssets',
  OperationalAdmin = 'operationalAdmin',
  TotalActiveLoans = 'totalActiveLoans',
  TotalCurrentLoaned = 'totalCurrentLoaned',
  TotalInterestEarned = 'totalInterestEarned',
  TotalLiquidity = 'totalLiquidity',
  TotalLiquidityCap = 'totalLiquidityCap',
  TotalLiquidityProvided = 'totalLiquidityProvided',
  TotalLoanOriginations = 'totalLoanOriginations',
  TotalLoans = 'totalLoans',
  TotalPoolV2s = 'totalPoolV2s',
  TotalPools = 'totalPools',
  TotalTreasuryFees = 'totalTreasuryFees',
  TotalValueLocked = 'totalValueLocked',
  TotalsByAsset = 'totalsByAsset',
  XMpl = 'xMPL'
}

export type MembershipInput = {
  orgId: Scalars['ID']['input'];
  role: MembershipRole;
  userId: Scalars['ID']['input'];
};

export enum MembershipRole {
  OrgAdmin = 'ORG_ADMIN',
  OrgMember = 'ORG_MEMBER',
  OrgOwner = 'ORG_OWNER'
}

export type MplRewards = {
  __typename?: 'MplRewards';
  id: Scalars['ID']['output'];
  paused: Scalars['Boolean']['output'];
  periodFinish: Scalars['BigInt']['output'];
  reward: Scalars['BigInt']['output'];
  rewardRate: Scalars['BigInt']['output'];
  rewardsDuration: Scalars['BigInt']['output'];
};

export type MplRewards_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  paused_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  paused_not?: InputMaybe<Scalars['Boolean']['input']>;
  paused_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  periodFinish?: InputMaybe<Scalars['BigInt']['input']>;
  periodFinish_gt?: InputMaybe<Scalars['BigInt']['input']>;
  periodFinish_gte?: InputMaybe<Scalars['BigInt']['input']>;
  periodFinish_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  periodFinish_lt?: InputMaybe<Scalars['BigInt']['input']>;
  periodFinish_lte?: InputMaybe<Scalars['BigInt']['input']>;
  periodFinish_not?: InputMaybe<Scalars['BigInt']['input']>;
  periodFinish_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  reward?: InputMaybe<Scalars['BigInt']['input']>;
  rewardRate?: InputMaybe<Scalars['BigInt']['input']>;
  rewardRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  rewardRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  rewardRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  rewardRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  rewardRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  rewardRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  rewardRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  reward_gt?: InputMaybe<Scalars['BigInt']['input']>;
  reward_gte?: InputMaybe<Scalars['BigInt']['input']>;
  reward_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  reward_lt?: InputMaybe<Scalars['BigInt']['input']>;
  reward_lte?: InputMaybe<Scalars['BigInt']['input']>;
  reward_not?: InputMaybe<Scalars['BigInt']['input']>;
  reward_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  rewardsDuration?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsDuration_gt?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsDuration_gte?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsDuration_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  rewardsDuration_lt?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsDuration_lte?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsDuration_not?: InputMaybe<Scalars['BigInt']['input']>;
  rewardsDuration_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum MplRewards_OrderBy {
  Id = 'id',
  Paused = 'paused',
  PeriodFinish = 'periodFinish',
  Reward = 'reward',
  RewardRate = 'rewardRate',
  RewardsDuration = 'rewardsDuration'
}

export type Mutation = {
  __typename?: 'Mutation';
  addCollateralTx: CollateralTx;
  addOrgWallet: MutationResponse;
  addOrgWalletByMapleAdmin: MutationResponse;
  addRolesToUser?: Maybe<User>;
  addWallet: MutationResponse;
  applyReferralToken?: Maybe<MutationResponse>;
  commitBalance: MutationResponse;
  createAutoRedeemerConfig: AutoRedeemerConfig;
  createBanner: Banner;
  createBond: BondPosition;
  createBorrower?: Maybe<BorrowerMetadata>;
  createCollateral: Collateral;
  createCollateralType: CollateralType;
  createCommitment: Commitment;
  createDelegate: DelegateMetadata;
  createDeposit: Deposit;
  createLegalEntity?: Maybe<User>;
  createLendingEpochConfiguration: LendingEpochConfiguration;
  createLiquidityManagerConfig: LiquidityManagerConfig;
  createLoan: LoanMetadata;
  createNativeAsset?: Maybe<MutationResponse>;
  createNativeLoan: NativeLoan;
  createNativePool: NativePool;
  createPool: PoolMetadata;
  createPoolCategory: PoolCategory;
  createPoolInjection: MutationResponse;
  createReferralToken: ReferralToken;
  createSeason: MutationResponse;
  createSyrupUser: SyrupUser;
  createUpcomingAllocation: MutationResponse;
  createUploadURL: FileUploadUrl;
  createUser?: Maybe<User>;
  deleteAutoRedeemerConfig: MutationResponse;
  deleteLiquidityManagerConfig: MutationResponse;
  deleteReferralToken: ReferralToken;
  deleteSyrupUser: SyrupUser;
  deleteUpcomingAllocation: MutationResponse;
  deleteUser: MutationResponse;
  inviteMemberToEntity?: Maybe<MutationResponse>;
  joinOrg?: Maybe<Org>;
  linkOrgSecuritize: Org;
  linkUserSecuritize: User;
  recommit: MutationResponse;
  removeBond: BondPosition;
  removeMemberFromEntity?: Maybe<Org>;
  removeRolesFromUser?: Maybe<User>;
  submitContactUsForm: HubspotFormSubmission;
  submitNewsletterForm: HubspotFormSubmission;
  submitSyrupUsdcForm: HubspotFormSubmission;
  updateAddressCompliance: AddressCompliance;
  updateAutoRedeemerConfig?: Maybe<AutoRedeemerConfig>;
  updateBanner?: Maybe<Banner>;
  updateBond: BondPosition;
  updateBorrower?: Maybe<BorrowerMetadata>;
  updateCollateral: MutationResponse;
  updateCollateralState: CollateralStateResponse;
  updateCollateralType: CollateralType;
  updateCommitment: Commitment;
  updateDelegate?: Maybe<DelegateMetadata>;
  updateDeposit: Deposit;
  updateLegalEntity: Org;
  updateLiquidityManagerConfig: LiquidityManagerConfig;
  updateLoan: LoanMetadata;
  updateMemberRole?: Maybe<User>;
  updateNativeAsset?: Maybe<MutationResponse>;
  updateNativeLoan: NativeLoan;
  updateNativePool: NativePool;
  updateOrgPools?: Maybe<Org>;
  updateOrgVerification?: Maybe<UserVerification>;
  updatePool: PoolMetadata;
  updatePoolCategory: PoolCategory;
  updatePoolInjection: MutationResponse;
  updatePriceOverride?: Maybe<MutationResponse>;
  updateReferralToken: ReferralToken;
  updateSeason: MutationResponse;
  updateSolStats: SolanaGlobals;
  updateSyrupGlobals: MutationResponse;
  updateUpcomingAllocation: MutationResponse;
  updateUser?: Maybe<User>;
  updateUserPools?: Maybe<User>;
  updateUserVerification?: Maybe<UserVerification>;
};


export type MutationAddCollateralTxArgs = {
  input: CollateralTxInput;
  loanId: Scalars['String']['input'];
};


export type MutationAddOrgWalletArgs = {
  inputs: AddOrgWalletInput;
};


export type MutationAddOrgWalletByMapleAdminArgs = {
  inputs: AddOrgWalletByMapleAdminInput;
};


export type MutationAddRolesToUserArgs = {
  inputs: ChangeRolesInput;
};


export type MutationAddWalletArgs = {
  inputs: AddWalletInput;
};


export type MutationApplyReferralTokenArgs = {
  inputs: ApplyReferralTokenInput;
};


export type MutationCommitBalanceArgs = {
  address: Scalars['String']['input'];
  connector?: InputMaybe<Scalars['String']['input']>;
  days: CommitDays;
  poolId: Scalars['String']['input'];
  shares: Scalars['String']['input'];
};


export type MutationCreateAutoRedeemerConfigArgs = {
  input: CreateAutoRedeemerConfig;
};


export type MutationCreateBannerArgs = {
  banner: CreateBannerInput;
};


export type MutationCreateBondArgs = {
  bond: CreateBondInput;
};


export type MutationCreateBorrowerArgs = {
  borrower: CreateBorrowerInput;
};


export type MutationCreateCollateralArgs = {
  id: Scalars['String']['input'];
  inputs: CollateralInput;
};


export type MutationCreateCollateralTypeArgs = {
  collateralType: CreateCollateralTypeInput;
};


export type MutationCreateCommitmentArgs = {
  inputs: CreateCommitmentInput;
};


export type MutationCreateDelegateArgs = {
  delegate: CreateDelegateInput;
};


export type MutationCreateDepositArgs = {
  inputs: CreateDepositInput;
};


export type MutationCreateLegalEntityArgs = {
  inputs: CreateLegalEntityInput;
  userId: Scalars['String']['input'];
};


export type MutationCreateLendingEpochConfigurationArgs = {
  input: CreateLendingEpochConfigurationInput;
};


export type MutationCreateLiquidityManagerConfigArgs = {
  input: CreateLiquidityManagerConfig;
};


export type MutationCreateLoanArgs = {
  inputs: CreateLoanInput;
};


export type MutationCreateNativeAssetArgs = {
  inputs: CreateNativeAssetInput;
};


export type MutationCreateNativeLoanArgs = {
  inputs: NativeLoanInput;
};


export type MutationCreateNativePoolArgs = {
  nativePool: CreateNativePoolInput;
};


export type MutationCreatePoolArgs = {
  pool: CreatePoolInput;
};


export type MutationCreatePoolCategoryArgs = {
  poolCategory: CreatePoolCategoryInput;
};


export type MutationCreatePoolInjectionArgs = {
  input: CreatePoolInjectionInput;
};


export type MutationCreateReferralTokenArgs = {
  inputs: ReferralTokenInput;
};


export type MutationCreateSeasonArgs = {
  inputs: CreateSeasonInput;
};


export type MutationCreateSyrupUserArgs = {
  inputs: SyrupUserInput;
};


export type MutationCreateUpcomingAllocationArgs = {
  inputs: CreateUpcomingAllocationInput;
};


export type MutationCreateUploadUrlArgs = {
  input: CreateUploadUrlInput;
};


export type MutationCreateUserArgs = {
  inputs: CreateUserInput;
};


export type MutationDeleteAutoRedeemerConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLiquidityManagerConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReferralTokenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSyrupUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUpcomingAllocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInviteMemberToEntityArgs = {
  inputs: InviteMemberToEntityInput;
};


export type MutationJoinOrgArgs = {
  inputs: MembershipInput;
};


export type MutationLinkOrgSecuritizeArgs = {
  code: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationLinkUserSecuritizeArgs = {
  code: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRecommitArgs = {
  address: Scalars['String']['input'];
  commitmentId: Scalars['ID']['input'];
  days: CommitDays;
};


export type MutationRemoveBondArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveMemberFromEntityArgs = {
  inputs: RemoveMemberFromEntityInput;
};


export type MutationRemoveRolesFromUserArgs = {
  inputs: ChangeRolesInput;
};


export type MutationSubmitContactUsFormArgs = {
  inputs: ContactUsFormInput;
};


export type MutationSubmitNewsletterFormArgs = {
  inputs: NewsletterFormInput;
};


export type MutationSubmitSyrupUsdcFormArgs = {
  inputs: SyrupUsdcFormInput;
};


export type MutationUpdateAddressComplianceArgs = {
  address: Scalars['String']['input'];
  permitted: Scalars['Boolean']['input'];
};


export type MutationUpdateAutoRedeemerConfigArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAutoRedeemerConfig;
};


export type MutationUpdateBannerArgs = {
  banner: UpdateBannerInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateBondArgs = {
  id: Scalars['String']['input'];
  updates: UpdateBondInput;
};


export type MutationUpdateBorrowerArgs = {
  borrower: UpdateBorrowerInput;
  ethereumAddress: Scalars['String']['input'];
};


export type MutationUpdateCollateralArgs = {
  id: Scalars['String']['input'];
  inputs: UpdateCollateralInput;
};


export type MutationUpdateCollateralStateArgs = {
  id: Scalars['String']['input'];
  state: CollateralState;
};


export type MutationUpdateCollateralTypeArgs = {
  id: Scalars['String']['input'];
  updates: UpdateCollateralTypeInput;
};


export type MutationUpdateCommitmentArgs = {
  id: Scalars['ID']['input'];
  updates: UpdateCommitmentInput;
};


export type MutationUpdateDelegateArgs = {
  delegate: UpdateDelegateInput;
  ethereumAddress: Scalars['String']['input'];
};


export type MutationUpdateDepositArgs = {
  id: Scalars['ID']['input'];
  updates: UpdateDepositInput;
};


export type MutationUpdateLegalEntityArgs = {
  id: Scalars['ID']['input'];
  inputs: UpdateLegalEntityInput;
};


export type MutationUpdateLiquidityManagerConfigArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLiquidityManagerConfig;
};


export type MutationUpdateLoanArgs = {
  id: Scalars['String']['input'];
  updates: UpdateLoanInput;
};


export type MutationUpdateMemberRoleArgs = {
  inputs: UpdateMemberRoleInput;
};


export type MutationUpdateNativeAssetArgs = {
  id: Scalars['ID']['input'];
  updates: UpdateNativeAssetInput;
};


export type MutationUpdateNativeLoanArgs = {
  id: Scalars['String']['input'];
  updates: NativeLoanUpdate;
};


export type MutationUpdateNativePoolArgs = {
  nativePoolId: Scalars['String']['input'];
  updates: UpdateNativePoolInput;
};


export type MutationUpdateOrgPoolsArgs = {
  orgId: Scalars['ID']['input'];
  poolId: Scalars['String']['input'];
};


export type MutationUpdateOrgVerificationArgs = {
  inputs: VerificationInput;
  orgId: Scalars['ID']['input'];
};


export type MutationUpdatePoolArgs = {
  id: Scalars['String']['input'];
  updates: UpdatePoolInput;
};


export type MutationUpdatePoolCategoryArgs = {
  id: Scalars['String']['input'];
  updates: UpdatePoolCategoryInput;
};


export type MutationUpdatePoolInjectionArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePoolInjectionInput;
};


export type MutationUpdatePriceOverrideArgs = {
  enabled: Scalars['Boolean']['input'];
  price: Scalars['Float']['input'];
  symbol: Scalars['String']['input'];
};


export type MutationUpdateReferralTokenArgs = {
  id: Scalars['ID']['input'];
  inputs: ReferralTokenUpdate;
};


export type MutationUpdateSeasonArgs = {
  id: Scalars['ID']['input'];
  updates: UpdateSeasonInput;
};


export type MutationUpdateSolStatsArgs = {
  totalInterestEarned: Scalars['String']['input'];
  totalLiquidityProvided: Scalars['String']['input'];
  totalLoanOriginations: Scalars['String']['input'];
};


export type MutationUpdateSyrupGlobalsArgs = {
  inputs: UpdateSyrupGlobalsInput;
};


export type MutationUpdateUpcomingAllocationArgs = {
  id: Scalars['ID']['input'];
  updates: UpdateUpcomingAllocationInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  inputs: UpdateUserInput;
};


export type MutationUpdateUserPoolsArgs = {
  poolId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserVerificationArgs = {
  inputs: VerificationInput;
  userId: Scalars['ID']['input'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type NativeAsset = {
  __typename?: 'NativeAsset';
  address: Scalars['String']['output'];
  collateralYield?: Maybe<Scalars['Int']['output']>;
  decimals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  symbol: Scalars['String']['output'];
};

export type NativeLoan = {
  __typename?: 'NativeLoan';
  collateralAsset?: Maybe<CollateralAsset>;
  collateralAssetAmount?: Maybe<Scalars['String']['output']>;
  companyEmail: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  contactEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt: Scalars['String']['output'];
  custodian?: Maybe<Custodian>;
  custodianId?: Maybe<Scalars['String']['output']>;
  deposit?: Maybe<Deposit>;
  fundingPool?: Maybe<PoolMetadata>;
  fundingSource?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<ChangeHistory>>;
  id: Scalars['ID']['output'];
  initialLevel?: Maybe<Scalars['Int']['output']>;
  interestRate: Scalars['String']['output'];
  liquidationLevel?: Maybe<Scalars['Int']['output']>;
  liquidationPrice?: Maybe<Scalars['String']['output']>;
  liquidationRequiredNotifiedAt?: Maybe<Scalars['String']['output']>;
  liquidationThreshold?: Maybe<Scalars['Int']['output']>;
  liquidationWarningNotifiedAt?: Maybe<Scalars['String']['output']>;
  liquidityAsset: LiquidityAsset;
  marginCallLevel?: Maybe<Scalars['Int']['output']>;
  marginCallNoticePeriodHours?: Maybe<Scalars['Int']['output']>;
  marginCallRequiredNotifiedAt?: Maybe<Scalars['String']['output']>;
  marginCallThreshold?: Maybe<Scalars['Int']['output']>;
  marginCallWarningNotifiedAt?: Maybe<Scalars['String']['output']>;
  principalOwed: Scalars['String']['output'];
  ratio?: Maybe<Scalars['String']['output']>;
  refundLevel?: Maybe<Scalars['Int']['output']>;
  requestAmount: Scalars['String']['output'];
  term: NativeLoanTerm;
  updatedAt: Scalars['String']['output'];
};

export type NativeLoanInput = {
  collateralAsset?: InputMaybe<CollateralAsset>;
  collateralAssetAmount?: InputMaybe<Scalars['String']['input']>;
  companyEmail: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  contactEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  custodian?: InputMaybe<Custodian>;
  custodianId?: InputMaybe<Scalars['String']['input']>;
  fundingSource?: InputMaybe<Scalars['String']['input']>;
  initialLevel?: InputMaybe<Scalars['Int']['input']>;
  interestRate: Scalars['Int']['input'];
  liquidationLevel?: InputMaybe<Scalars['Int']['input']>;
  liquidationThreshold?: InputMaybe<Scalars['Int']['input']>;
  liquidityAssetSymbol: CollateralAsset;
  marginCallLevel?: InputMaybe<Scalars['Int']['input']>;
  marginCallNoticePeriodHours?: InputMaybe<Scalars['Int']['input']>;
  marginCallThreshold?: InputMaybe<Scalars['Int']['input']>;
  principalOwed?: InputMaybe<Scalars['String']['input']>;
  refundLevel?: InputMaybe<Scalars['Int']['input']>;
  requestAmount: Scalars['String']['input'];
  term: NativeLoanTerm;
};

export type NativeLoanSnapshot = {
  __typename?: 'NativeLoanSnapshot';
  collateralAmount?: Maybe<Scalars['Float']['output']>;
  collateralAsset?: Maybe<Scalars['String']['output']>;
  collateralPrice?: Maybe<Scalars['Float']['output']>;
  collateralValueUsd?: Maybe<Scalars['Float']['output']>;
  collateralizationRatio?: Maybe<Scalars['Float']['output']>;
  loanAmount: Scalars['Float']['output'];
  loanAsset: Scalars['String']['output'];
  loanAssetPrice: Scalars['Float']['output'];
  loanId: Scalars['String']['output'];
  loanValueUsd: Scalars['Float']['output'];
};

export enum NativeLoanTerm {
  FixedTerm = 'FixedTerm',
  OpenTerm = 'OpenTerm'
}

export type NativeLoanUpdate = {
  collateralAsset?: InputMaybe<CollateralAsset>;
  collateralAssetAmount?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  custodian?: InputMaybe<Custodian>;
  custodianId?: InputMaybe<Scalars['String']['input']>;
  fundingSource?: InputMaybe<Scalars['String']['input']>;
  initialLevel?: InputMaybe<Scalars['Int']['input']>;
  interestRate?: InputMaybe<Scalars['Int']['input']>;
  liquidationLevel?: InputMaybe<Scalars['Int']['input']>;
  liquidationThreshold?: InputMaybe<Scalars['Int']['input']>;
  liquidityAssetSymbol?: InputMaybe<CollateralAsset>;
  marginCallLevel?: InputMaybe<Scalars['Int']['input']>;
  marginCallNoticePeriodHours?: InputMaybe<Scalars['Int']['input']>;
  marginCallThreshold?: InputMaybe<Scalars['Int']['input']>;
  principalOwed?: InputMaybe<Scalars['String']['input']>;
  refundLevel?: InputMaybe<Scalars['Int']['input']>;
  requestAmount?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<NativeLoanTerm>;
};

export type NativePool = {
  __typename?: 'NativePool';
  decimals: Scalars['Int']['output'];
  nativePoolId: Scalars['String']['output'];
  tvlNative?: Maybe<Scalars['String']['output']>;
  tvlUsd?: Maybe<Scalars['String']['output']>;
};

export type NewsletterFormInput = {
  email: Scalars['EmailAddress']['input'];
  marketingConsent: Scalars['Boolean']['input'];
};

export type OtlRefinanceCalls = {
  __typename?: 'OTLRefinanceCalls';
  decreasePrincipal?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  increasePrincipal?: Maybe<Scalars['String']['output']>;
  setDelegateServiceFeeRate?: Maybe<Scalars['String']['output']>;
  setGracePeriod?: Maybe<Scalars['String']['output']>;
  setInterestRate?: Maybe<Scalars['String']['output']>;
  setLateFeeRate?: Maybe<Scalars['String']['output']>;
  setLateInterestPremiumRate?: Maybe<Scalars['String']['output']>;
  setNoticePeriod?: Maybe<Scalars['String']['output']>;
  setPaymentInterval?: Maybe<Scalars['String']['output']>;
};

export type OtlRefinanceCalls_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  decreasePrincipal?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_contains?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_ends_with?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_gt?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_gte?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  decreasePrincipal_lt?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_lte?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_not?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_not_contains?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  decreasePrincipal_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_starts_with?: InputMaybe<Scalars['String']['input']>;
  decreasePrincipal_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  increasePrincipal?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_contains?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_ends_with?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_gt?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_gte?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  increasePrincipal_lt?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_lte?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_contains?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  increasePrincipal_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_starts_with?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_contains?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_ends_with?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_gt?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_gte?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setDelegateServiceFeeRate_lt?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_lte?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_not?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_not_contains?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setDelegateServiceFeeRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_starts_with?: InputMaybe<Scalars['String']['input']>;
  setDelegateServiceFeeRate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_contains?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_ends_with?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_gt?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_gte?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setGracePeriod_lt?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_lte?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_contains?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setGracePeriod_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_starts_with?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_contains?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_ends_with?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_gt?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_gte?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setInterestRate_lt?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_lte?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_contains?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setInterestRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_starts_with?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_contains?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_ends_with?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_gt?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_gte?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setLateFeeRate_lt?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_lte?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_contains?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setLateFeeRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_starts_with?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_contains?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_ends_with?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_gt?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_gte?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setLateInterestPremiumRate_lt?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_lte?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_not?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_not_contains?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setLateInterestPremiumRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_starts_with?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremiumRate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_contains?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_ends_with?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_gt?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_gte?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setNoticePeriod_lt?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_lte?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_not?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_not_contains?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setNoticePeriod_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_starts_with?: InputMaybe<Scalars['String']['input']>;
  setNoticePeriod_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_contains?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_ends_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_gt?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_gte?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setPaymentInterval_lt?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_lte?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_contains?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setPaymentInterval_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_starts_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OtlRefinanceCalls_OrderBy {
  DecreasePrincipal = 'decreasePrincipal',
  Id = 'id',
  IncreasePrincipal = 'increasePrincipal',
  SetDelegateServiceFeeRate = 'setDelegateServiceFeeRate',
  SetGracePeriod = 'setGracePeriod',
  SetInterestRate = 'setInterestRate',
  SetLateFeeRate = 'setLateFeeRate',
  SetLateInterestPremiumRate = 'setLateInterestPremiumRate',
  SetNoticePeriod = 'setNoticePeriod',
  SetPaymentInterval = 'setPaymentInterval'
}

export type OtlRepayment = {
  __typename?: 'OTLRepayment';
  account: Account;
  delegateManagementFee?: Maybe<Scalars['BigInt']['output']>;
  delegateServiceFee: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  interest: Scalars['BigInt']['output'];
  late: Scalars['Boolean']['output'];
  lateInterest: Scalars['BigInt']['output'];
  loan: OpenTermLoan;
  netInterest?: Maybe<Scalars['BigInt']['output']>;
  platformManagementFee?: Maybe<Scalars['BigInt']['output']>;
  platformServiceFee: Scalars['BigInt']['output'];
  principal: Scalars['BigInt']['output'];
  total: Scalars['BigInt']['output'];
  transaction: Transaction;
};

export type OtlRepayment_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  delegateManagementFee?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateManagementFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFee?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interest?: InputMaybe<Scalars['BigInt']['input']>;
  interest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interest_not?: InputMaybe<Scalars['BigInt']['input']>;
  interest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  late?: InputMaybe<Scalars['Boolean']['input']>;
  lateInterest?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  late_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  late_not?: InputMaybe<Scalars['Boolean']['input']>;
  late_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<OpenTermLoan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  netInterest?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  netInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformManagementFee?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformManagementFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFee?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principal?: InputMaybe<Scalars['BigInt']['input']>;
  principal_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principal_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principal_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principal_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principal_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principal_not?: InputMaybe<Scalars['BigInt']['input']>;
  principal_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  total?: InputMaybe<Scalars['BigInt']['input']>;
  total_gt?: InputMaybe<Scalars['BigInt']['input']>;
  total_gte?: InputMaybe<Scalars['BigInt']['input']>;
  total_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  total_lt?: InputMaybe<Scalars['BigInt']['input']>;
  total_lte?: InputMaybe<Scalars['BigInt']['input']>;
  total_not?: InputMaybe<Scalars['BigInt']['input']>;
  total_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OtlRepayment_OrderBy {
  Account = 'account',
  DelegateManagementFee = 'delegateManagementFee',
  DelegateServiceFee = 'delegateServiceFee',
  Id = 'id',
  Interest = 'interest',
  Late = 'late',
  LateInterest = 'lateInterest',
  Loan = 'loan',
  NetInterest = 'netInterest',
  PlatformManagementFee = 'platformManagementFee',
  PlatformServiceFee = 'platformServiceFee',
  Principal = 'principal',
  Total = 'total',
  Transaction = 'transaction'
}

export type OpenTermLoan = {
  __typename?: 'OpenTermLoan';
  acmRatio?: Maybe<Scalars['String']['output']>;
  amountFunded: Scalars['BigInt']['output'];
  borrower: Account;
  collateral?: Maybe<Collateral>;
  defaultDate: Scalars['BigInt']['output'];
  defaultSuffered: Scalars['BigInt']['output'];
  delegateServiceFeeRate: Scalars['BigInt']['output'];
  fundingDate: Scalars['BigInt']['output'];
  fundingPool: PoolV2;
  fundingTransaction?: Maybe<Transaction>;
  gracePeriodSeconds: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  impairDate: Scalars['BigInt']['output'];
  interestPaid: Scalars['BigInt']['output'];
  interestRate: Scalars['BigInt']['output'];
  isCalled: Scalars['Boolean']['output'];
  isImpaired: Scalars['Boolean']['output'];
  isRepossessed: Scalars['Boolean']['output'];
  lateFeeRate: Scalars['BigInt']['output'];
  lateInterestPaid: Scalars['BigInt']['output'];
  lateInterestPremium: Scalars['BigInt']['output'];
  lender: OpenTermLoanManager;
  liquidityAsset: Asset;
  loanMeta?: Maybe<LoanMetadata>;
  loanRefinances?: Maybe<Array<OpenTermLoanRefinance>>;
  maturityDate: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  nextPaymentBreakdown?: Maybe<PaymentBreakdown>;
  nextPaymentDue: Scalars['BigInt']['output'];
  noticePeriodSeconds: Scalars['BigInt']['output'];
  numPayments: Scalars['BigInt']['output'];
  numRefinances: Scalars['BigInt']['output'];
  paymentIntervalDays: Scalars['BigInt']['output'];
  platformServiceFeeRate: Scalars['BigInt']['output'];
  principalCalled: Scalars['BigInt']['output'];
  principalOwed: Scalars['BigInt']['output'];
  requestAmount: Scalars['BigInt']['output'];
  startDate: Scalars['BigInt']['output'];
  state: LoanState;
  stateDetail?: Maybe<LoanStateDetail>;
  symbol: Scalars['String']['output'];
  transaction: Transaction;
  version: Scalars['Int']['output'];
  yield?: Maybe<Scalars['String']['output']>;
};


export type OpenTermLoanLoanRefinancesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoanRefinance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OpenTermLoanRefinance_Filter>;
};

export type OpenTermLoanHistory = {
  __typename?: 'OpenTermLoanHistory';
  amountFunded: Scalars['BigInt']['output'];
  borrower: Account;
  defaultDate: Scalars['BigInt']['output'];
  delegateServiceFeeRate: Scalars['BigInt']['output'];
  fundingDate: Scalars['BigInt']['output'];
  fundingPool: PoolV2;
  gracePeriodSeconds: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  interestPaid: Scalars['BigInt']['output'];
  interestRate: Scalars['BigInt']['output'];
  lateFeeRate: Scalars['BigInt']['output'];
  lateInterestPaid: Scalars['BigInt']['output'];
  lateInterestPremium: Scalars['BigInt']['output'];
  lender: OpenTermLoanManager;
  liquidityAsset: Asset;
  loan: Loan;
  loanMeta?: Maybe<LoanMetadata>;
  nextPaymentDue: Scalars['BigInt']['output'];
  noticePeriodSeconds: Scalars['BigInt']['output'];
  numRefinances: Scalars['BigInt']['output'];
  paymentIntervalDays: Scalars['BigInt']['output'];
  platformServiceFeeRate: Scalars['BigInt']['output'];
  principalOwed: Scalars['BigInt']['output'];
  requestAmount: Scalars['BigInt']['output'];
  startDate: Scalars['BigInt']['output'];
  state: LoanState;
  transaction: Transaction;
  version: Scalars['Int']['output'];
};

export type OpenTermLoanHistory_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountFunded?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountFunded_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_not?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  borrower?: InputMaybe<Scalars['String']['input']>;
  borrower_?: InputMaybe<Account_Filter>;
  borrower_contains?: InputMaybe<Scalars['String']['input']>;
  borrower_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_ends_with?: InputMaybe<Scalars['String']['input']>;
  borrower_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_gt?: InputMaybe<Scalars['String']['input']>;
  borrower_gte?: InputMaybe<Scalars['String']['input']>;
  borrower_in?: InputMaybe<Array<Scalars['String']['input']>>;
  borrower_lt?: InputMaybe<Scalars['String']['input']>;
  borrower_lte?: InputMaybe<Scalars['String']['input']>;
  borrower_not?: InputMaybe<Scalars['String']['input']>;
  borrower_not_contains?: InputMaybe<Scalars['String']['input']>;
  borrower_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  borrower_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  borrower_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  borrower_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_starts_with?: InputMaybe<Scalars['String']['input']>;
  borrower_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  defaultDate?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingDate?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingPool?: InputMaybe<Scalars['String']['input']>;
  fundingPool_?: InputMaybe<PoolV2_Filter>;
  fundingPool_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_gt?: InputMaybe<Scalars['String']['input']>;
  fundingPool_gte?: InputMaybe<Scalars['String']['input']>;
  fundingPool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPool_lt?: InputMaybe<Scalars['String']['input']>;
  fundingPool_lte?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  gracePeriodSeconds?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_gt?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_gte?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  gracePeriodSeconds_lt?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_lte?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_not?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interestPaid?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestPaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestRate?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPaid?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPremium?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPremium_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lender?: InputMaybe<Scalars['String']['input']>;
  lender_?: InputMaybe<OpenTermLoanManager_Filter>;
  lender_contains?: InputMaybe<Scalars['String']['input']>;
  lender_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_ends_with?: InputMaybe<Scalars['String']['input']>;
  lender_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_gt?: InputMaybe<Scalars['String']['input']>;
  lender_gte?: InputMaybe<Scalars['String']['input']>;
  lender_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lender_lt?: InputMaybe<Scalars['String']['input']>;
  lender_lte?: InputMaybe<Scalars['String']['input']>;
  lender_not?: InputMaybe<Scalars['String']['input']>;
  lender_not_contains?: InputMaybe<Scalars['String']['input']>;
  lender_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lender_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lender_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lender_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_starts_with?: InputMaybe<Scalars['String']['input']>;
  lender_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_?: InputMaybe<Asset_Filter>;
  liquidityAsset_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_gt?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_gte?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityAsset_lt?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_lte?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentDue?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_gt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_gte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextPaymentDue_lt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_lte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_not?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  noticePeriodSeconds?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_gt?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_gte?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  noticePeriodSeconds_lt?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_lte?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_not?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numRefinances?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numRefinances_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_not?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentIntervalDays?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_gt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_gte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentIntervalDays_lt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_lte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_not?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  requestAmount?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  requestAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startDate?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  state?: InputMaybe<LoanState>;
  state_in?: InputMaybe<Array<LoanState>>;
  state_not?: InputMaybe<LoanState>;
  state_not_in?: InputMaybe<Array<LoanState>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum OpenTermLoanHistory_OrderBy {
  AmountFunded = 'amountFunded',
  Borrower = 'borrower',
  DefaultDate = 'defaultDate',
  DelegateServiceFeeRate = 'delegateServiceFeeRate',
  FundingDate = 'fundingDate',
  FundingPool = 'fundingPool',
  GracePeriodSeconds = 'gracePeriodSeconds',
  Id = 'id',
  InterestPaid = 'interestPaid',
  InterestRate = 'interestRate',
  LateFeeRate = 'lateFeeRate',
  LateInterestPaid = 'lateInterestPaid',
  LateInterestPremium = 'lateInterestPremium',
  Lender = 'lender',
  LiquidityAsset = 'liquidityAsset',
  Loan = 'loan',
  NextPaymentDue = 'nextPaymentDue',
  NoticePeriodSeconds = 'noticePeriodSeconds',
  NumRefinances = 'numRefinances',
  PaymentIntervalDays = 'paymentIntervalDays',
  PlatformServiceFeeRate = 'platformServiceFeeRate',
  PrincipalOwed = 'principalOwed',
  RequestAmount = 'requestAmount',
  StartDate = 'startDate',
  State = 'state',
  Transaction = 'transaction',
  Version = 'version'
}

export type OpenTermLoanManager = {
  __typename?: 'OpenTermLoanManager';
  accountedInterest: Scalars['BigInt']['output'];
  domainEnd: Scalars['BigInt']['output'];
  domainStart: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  issuanceRate: Scalars['BigInt']['output'];
  pool: PoolV2;
  principalOut: Scalars['BigInt']['output'];
  version: Scalars['Int']['output'];
};

export type OpenTermLoanManager_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  accountedInterest?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  accountedInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainEnd?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_gt?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_gte?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainEnd_lt?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_lte?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_not?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainStart?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_gt?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_gte?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainStart_lt?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_lte?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_not?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  issuanceRate?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  issuanceRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  principalOut?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOut_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum OpenTermLoanManager_OrderBy {
  AccountedInterest = 'accountedInterest',
  DomainEnd = 'domainEnd',
  DomainStart = 'domainStart',
  Id = 'id',
  IssuanceRate = 'issuanceRate',
  Pool = 'pool',
  PrincipalOut = 'principalOut',
  Version = 'version'
}

export type OpenTermLoanMap = {
  __typename?: 'OpenTermLoanMap';
  id: Scalars['ID']['output'];
  openTermLoan: OpenTermLoan;
};

export type OpenTermLoanMap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  openTermLoan?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_?: InputMaybe<OpenTermLoan_Filter>;
  openTermLoan_contains?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_ends_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_gt?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_gte?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  openTermLoan_lt?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_lte?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_contains?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  openTermLoan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_starts_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OpenTermLoanMap_OrderBy {
  Id = 'id',
  OpenTermLoan = 'openTermLoan'
}

export type OpenTermLoanRefinance = {
  __typename?: 'OpenTermLoanRefinance';
  calls: Array<Scalars['Bytes']['output']>;
  deadline: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  loan?: Maybe<OpenTermLoan>;
  loanHistory?: Maybe<OpenTermLoanHistory>;
  principalOwed: Scalars['BigInt']['output'];
  refinanceCalls: OtlRefinanceCalls;
  refinanceInterest: Scalars['BigInt']['output'];
  status: RefinanceStatus;
  updatedAt: Scalars['BigInt']['output'];
};

export type OpenTermLoanRefinance_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  calls?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  calls_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  calls_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  calls_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  calls_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  calls_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  deadline?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_gt?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_gte?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  deadline_lt?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_lte?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_not?: InputMaybe<Scalars['BigInt']['input']>;
  deadline_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loanHistory?: InputMaybe<Scalars['String']['input']>;
  loanHistory_?: InputMaybe<OpenTermLoanHistory_Filter>;
  loanHistory_contains?: InputMaybe<Scalars['String']['input']>;
  loanHistory_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loanHistory_ends_with?: InputMaybe<Scalars['String']['input']>;
  loanHistory_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanHistory_gt?: InputMaybe<Scalars['String']['input']>;
  loanHistory_gte?: InputMaybe<Scalars['String']['input']>;
  loanHistory_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loanHistory_lt?: InputMaybe<Scalars['String']['input']>;
  loanHistory_lte?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_contains?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loanHistory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loanHistory_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanHistory_starts_with?: InputMaybe<Scalars['String']['input']>;
  loanHistory_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<OpenTermLoan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  principalOwed?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  refinanceCalls?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_?: InputMaybe<OtlRefinanceCalls_Filter>;
  refinanceCalls_contains?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_ends_with?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_gt?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_gte?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_in?: InputMaybe<Array<Scalars['String']['input']>>;
  refinanceCalls_lt?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_lte?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_contains?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  refinanceCalls_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_starts_with?: InputMaybe<Scalars['String']['input']>;
  refinanceCalls_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  refinanceInterest?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  refinanceInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  status?: InputMaybe<RefinanceStatus>;
  status_in?: InputMaybe<Array<RefinanceStatus>>;
  status_not?: InputMaybe<RefinanceStatus>;
  status_not_in?: InputMaybe<Array<RefinanceStatus>>;
  updatedAt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum OpenTermLoanRefinance_OrderBy {
  Calls = 'calls',
  Deadline = 'deadline',
  Id = 'id',
  Loan = 'loan',
  LoanHistory = 'loanHistory',
  PrincipalOwed = 'principalOwed',
  RefinanceCalls = 'refinanceCalls',
  RefinanceInterest = 'refinanceInterest',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type OpenTermLoan_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountFunded?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountFunded_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_not?: InputMaybe<Scalars['BigInt']['input']>;
  amountFunded_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  borrower?: InputMaybe<Scalars['String']['input']>;
  borrower_?: InputMaybe<Account_Filter>;
  borrower_contains?: InputMaybe<Scalars['String']['input']>;
  borrower_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_ends_with?: InputMaybe<Scalars['String']['input']>;
  borrower_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_gt?: InputMaybe<Scalars['String']['input']>;
  borrower_gte?: InputMaybe<Scalars['String']['input']>;
  borrower_in?: InputMaybe<Array<Scalars['String']['input']>>;
  borrower_lt?: InputMaybe<Scalars['String']['input']>;
  borrower_lte?: InputMaybe<Scalars['String']['input']>;
  borrower_not?: InputMaybe<Scalars['String']['input']>;
  borrower_not_contains?: InputMaybe<Scalars['String']['input']>;
  borrower_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  borrower_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  borrower_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  borrower_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  borrower_starts_with?: InputMaybe<Scalars['String']['input']>;
  borrower_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  defaultDate?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  defaultDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultSuffered?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_gt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_gte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultSuffered_lt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_lte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_not?: InputMaybe<Scalars['BigInt']['input']>;
  defaultSuffered_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingDate?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  fundingDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  fundingPool?: InputMaybe<Scalars['String']['input']>;
  fundingPool_?: InputMaybe<PoolV2_Filter>;
  fundingPool_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_gt?: InputMaybe<Scalars['String']['input']>;
  fundingPool_gte?: InputMaybe<Scalars['String']['input']>;
  fundingPool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPool_lt?: InputMaybe<Scalars['String']['input']>;
  fundingPool_lte?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_contains?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingPool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingPool_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingPool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_?: InputMaybe<Transaction_Filter>;
  fundingTransaction_contains?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_gt?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_gte?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingTransaction_lt?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_lte?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  fundingTransaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  fundingTransaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  gracePeriodSeconds?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_gt?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_gte?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  gracePeriodSeconds_lt?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_lte?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_not?: InputMaybe<Scalars['BigInt']['input']>;
  gracePeriodSeconds_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  impairDate?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  impairDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  impairDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestPaid?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestPaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestPaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestRate?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  isCalled?: InputMaybe<Scalars['Boolean']['input']>;
  isCalled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isCalled_not?: InputMaybe<Scalars['Boolean']['input']>;
  isCalled_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isImpaired?: InputMaybe<Scalars['Boolean']['input']>;
  isImpaired_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isImpaired_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImpaired_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isRepossessed?: InputMaybe<Scalars['Boolean']['input']>;
  isRepossessed_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isRepossessed_not?: InputMaybe<Scalars['Boolean']['input']>;
  isRepossessed_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  lateFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPaid?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPremium?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterestPremium_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterestPremium_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lender?: InputMaybe<Scalars['String']['input']>;
  lender_?: InputMaybe<OpenTermLoanManager_Filter>;
  lender_contains?: InputMaybe<Scalars['String']['input']>;
  lender_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_ends_with?: InputMaybe<Scalars['String']['input']>;
  lender_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_gt?: InputMaybe<Scalars['String']['input']>;
  lender_gte?: InputMaybe<Scalars['String']['input']>;
  lender_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lender_lt?: InputMaybe<Scalars['String']['input']>;
  lender_lte?: InputMaybe<Scalars['String']['input']>;
  lender_not?: InputMaybe<Scalars['String']['input']>;
  lender_not_contains?: InputMaybe<Scalars['String']['input']>;
  lender_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lender_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lender_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lender_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lender_starts_with?: InputMaybe<Scalars['String']['input']>;
  lender_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_?: InputMaybe<Asset_Filter>;
  liquidityAsset_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_gt?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_gte?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityAsset_lt?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_lte?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanRefinances_?: InputMaybe<OpenTermLoanRefinance_Filter>;
  maturityDate?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maturityDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  maturityDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_?: InputMaybe<PaymentBreakdown_Filter>;
  nextPaymentBreakdown_contains?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_ends_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_gt?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_gte?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nextPaymentBreakdown_lt?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_lte?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_contains?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nextPaymentBreakdown_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_starts_with?: InputMaybe<Scalars['String']['input']>;
  nextPaymentBreakdown_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextPaymentDue?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_gt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_gte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  nextPaymentDue_lt?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_lte?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_not?: InputMaybe<Scalars['BigInt']['input']>;
  nextPaymentDue_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  noticePeriodSeconds?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_gt?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_gte?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  noticePeriodSeconds_lt?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_lte?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_not?: InputMaybe<Scalars['BigInt']['input']>;
  noticePeriodSeconds_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numPayments?: InputMaybe<Scalars['BigInt']['input']>;
  numPayments_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numPayments_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numPayments_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numPayments_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numPayments_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numPayments_not?: InputMaybe<Scalars['BigInt']['input']>;
  numPayments_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numRefinances?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numRefinances_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_not?: InputMaybe<Scalars['BigInt']['input']>;
  numRefinances_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentIntervalDays?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_gt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_gte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  paymentIntervalDays_lt?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_lte?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_not?: InputMaybe<Scalars['BigInt']['input']>;
  paymentIntervalDays_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalCalled?: InputMaybe<Scalars['BigInt']['input']>;
  principalCalled_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalCalled_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalCalled_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalCalled_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalCalled_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalCalled_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalCalled_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOwed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalOwed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  requestAmount?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  requestAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  requestAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startDate?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  startDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  state?: InputMaybe<LoanState>;
  state_in?: InputMaybe<Array<LoanState>>;
  state_not?: InputMaybe<LoanState>;
  state_not_in?: InputMaybe<Array<LoanState>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum OpenTermLoan_OrderBy {
  AmountFunded = 'amountFunded',
  Borrower = 'borrower',
  DefaultDate = 'defaultDate',
  DefaultSuffered = 'defaultSuffered',
  DelegateServiceFeeRate = 'delegateServiceFeeRate',
  FundingDate = 'fundingDate',
  FundingPool = 'fundingPool',
  FundingTransaction = 'fundingTransaction',
  GracePeriodSeconds = 'gracePeriodSeconds',
  Id = 'id',
  ImpairDate = 'impairDate',
  InterestPaid = 'interestPaid',
  InterestRate = 'interestRate',
  IsCalled = 'isCalled',
  IsImpaired = 'isImpaired',
  IsRepossessed = 'isRepossessed',
  LateFeeRate = 'lateFeeRate',
  LateInterestPaid = 'lateInterestPaid',
  LateInterestPremium = 'lateInterestPremium',
  Lender = 'lender',
  LiquidityAsset = 'liquidityAsset',
  LoanRefinances = 'loanRefinances',
  MaturityDate = 'maturityDate',
  Name = 'name',
  NextPaymentBreakdown = 'nextPaymentBreakdown',
  NextPaymentDue = 'nextPaymentDue',
  NoticePeriodSeconds = 'noticePeriodSeconds',
  NumPayments = 'numPayments',
  NumRefinances = 'numRefinances',
  PaymentIntervalDays = 'paymentIntervalDays',
  PlatformServiceFeeRate = 'platformServiceFeeRate',
  PrincipalCalled = 'principalCalled',
  PrincipalOwed = 'principalOwed',
  RequestAmount = 'requestAmount',
  StartDate = 'startDate',
  State = 'state',
  Symbol = 'symbol',
  Transaction = 'transaction',
  Version = 'version'
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Org = {
  __typename?: 'Org';
  countryCode?: Maybe<Scalars['String']['output']>;
  countryOfOperation?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lendingAppetite?: Maybe<Scalars['String']['output']>;
  lendingPools?: Maybe<Array<PoolVerificationStatus>>;
  members: Array<User>;
  name: Scalars['String']['output'];
  securitizeId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Source>;
  taxResidency?: Maybe<TaxResidency>;
  verification?: Maybe<UserVerification>;
  wallets?: Maybe<Array<Wallet>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageSize: Scalars['Int']['output'];
  totalNodes: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaymentBreakdown = {
  __typename?: 'PaymentBreakdown';
  delegateFee?: Maybe<Scalars['BigInt']['output']>;
  delegateServiceFee?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
  interest: Scalars['BigInt']['output'];
  lateInterest?: Maybe<Scalars['BigInt']['output']>;
  loan: Scalars['ID']['output'];
  platformServiceFee?: Maybe<Scalars['BigInt']['output']>;
  principal: Scalars['BigInt']['output'];
  refinanceInterest?: Maybe<Scalars['BigInt']['output']>;
  total: Scalars['BigInt']['output'];
  treasuryFee?: Maybe<Scalars['BigInt']['output']>;
};

export type PaymentBreakdown_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  delegateFee?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFee?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interest?: InputMaybe<Scalars['BigInt']['input']>;
  interest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interest_not?: InputMaybe<Scalars['BigInt']['input']>;
  interest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterest?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lateInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  lateInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  loan?: InputMaybe<Scalars['ID']['input']>;
  loan_gt?: InputMaybe<Scalars['ID']['input']>;
  loan_gte?: InputMaybe<Scalars['ID']['input']>;
  loan_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  loan_lt?: InputMaybe<Scalars['ID']['input']>;
  loan_lte?: InputMaybe<Scalars['ID']['input']>;
  loan_not?: InputMaybe<Scalars['ID']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  platformServiceFee?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principal?: InputMaybe<Scalars['BigInt']['input']>;
  principal_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principal_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principal_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principal_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principal_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principal_not?: InputMaybe<Scalars['BigInt']['input']>;
  principal_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  refinanceInterest?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  refinanceInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  refinanceInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  total?: InputMaybe<Scalars['BigInt']['input']>;
  total_gt?: InputMaybe<Scalars['BigInt']['input']>;
  total_gte?: InputMaybe<Scalars['BigInt']['input']>;
  total_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  total_lt?: InputMaybe<Scalars['BigInt']['input']>;
  total_lte?: InputMaybe<Scalars['BigInt']['input']>;
  total_not?: InputMaybe<Scalars['BigInt']['input']>;
  total_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  treasuryFee?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  treasuryFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum PaymentBreakdown_OrderBy {
  DelegateFee = 'delegateFee',
  DelegateServiceFee = 'delegateServiceFee',
  Id = 'id',
  Interest = 'interest',
  LateInterest = 'lateInterest',
  Loan = 'loan',
  PlatformServiceFee = 'platformServiceFee',
  Principal = 'principal',
  RefinanceInterest = 'refinanceInterest',
  Total = 'total',
  TreasuryFee = 'treasuryFee'
}

export enum Permission {
  MapleAdmin = 'MAPLE_ADMIN',
  OrgChangeOwner = 'ORG_CHANGE_OWNER',
  OrgRead = 'ORG_READ',
  OrgUpdate = 'ORG_UPDATE',
  PoolCreate = 'POOL_CREATE',
  PoolLender = 'POOL_LENDER',
  PoolRead = 'POOL_READ',
  PoolUpdate = 'POOL_UPDATE',
  Self = 'SELF',
  BypassKyc = 'bypass_kyc',
  CreateAllocation = 'create_allocation',
  CreateBanner = 'create_banner',
  CreateBond = 'create_bond',
  CreateBorrower = 'create_borrower',
  CreateBotConfigAutoRedeemer = 'create_bot_config_auto_redeemer',
  CreateBotConfigLiquidityManager = 'create_bot_config_liquidity_manager',
  CreateBotConfigPoolInjection = 'create_bot_config_pool_injection',
  CreateCollateralTx = 'create_collateral_tx',
  CreateCollateralType = 'create_collateral_type',
  CreateCommitment = 'create_commitment',
  CreateDelegate = 'create_delegate',
  CreateDeposit = 'create_deposit',
  CreateEntity = 'create_entity',
  CreateLendingEpochConfig = 'create_lending_epoch_config',
  CreateLoan = 'create_loan',
  CreateNativeAsset = 'create_native_asset',
  CreateNativeLoan = 'create_native_loan',
  CreateNativePool = 'create_native_pool',
  CreatePool = 'create_pool',
  CreatePoolCategory = 'create_pool_category',
  CreateReferralToken = 'create_referral_token',
  CreateSeason = 'create_season',
  CreateUploadUrl = 'create_upload_url',
  CreateUser = 'create_user',
  DeleteAllocation = 'delete_allocation',
  DeleteBond = 'delete_bond',
  DeleteBotConfigAutoRedeemer = 'delete_bot_config_auto_redeemer',
  DeleteBotConfigLiquidityManager = 'delete_bot_config_liquidity_manager',
  DeleteReferralToken = 'delete_referral_token',
  DeleteSyrupUser = 'delete_syrup_user',
  DeleteUser = 'delete_user',
  ReadAccountBitmap = 'read_account_bitmap',
  ReadAddressComplianceDetails = 'read_address_compliance_details',
  ReadAllBanners = 'read_all_banners',
  ReadAllBonds = 'read_all_bonds',
  ReadAllReferralTokens = 'read_all_referral_tokens',
  ReadAllUsersAllocations = 'read_all_users_allocations',
  ReadAllWallets = 'read_all_wallets',
  ReadBorrowerCompanyInfo = 'read_borrower_company_info',
  ReadBotConfigAutoRedeemer = 'read_bot_config_auto_redeemer',
  ReadBotConfigLiquidityManager = 'read_bot_config_liquidity_manager',
  ReadBotConfigPoolInjection = 'read_bot_config_pool_injection',
  ReadCollateralTx = 'read_collateral_tx',
  ReadCollateralizedLoan = 'read_collateralized_loan',
  ReadCommitmentConnector = 'read_commitment_connector',
  ReadFlaggedAddresses = 'read_flagged_addresses',
  ReadNativeLoanCompanyContact = 'read_native_loan_company_contact',
  ReadOperationsHistory = 'read_operations_history',
  ReadOperationsHistoryDetails = 'read_operations_history_details',
  ReadOrg = 'read_org',
  ReadOrgVerification = 'read_org_verification',
  ReadReferralTokenReferrer = 'read_referral_token_referrer',
  ReadRolePermissions = 'read_role_permissions',
  ReadS3Object = 'read_s3_object',
  ReadSyrupUser = 'read_syrup_user',
  ReadUser = 'read_user',
  ReadUserVerification = 'read_user_verification',
  UpdateAddressCompliance = 'update_address_compliance',
  UpdateAllocation = 'update_allocation',
  UpdateBanner = 'update_banner',
  UpdateBond = 'update_bond',
  UpdateBorrower = 'update_borrower',
  UpdateBotConfigAutoRedeemer = 'update_bot_config_auto_redeemer',
  UpdateBotConfigLiquidityManager = 'update_bot_config_liquidity_manager',
  UpdateBotConfigPoolInjection = 'update_bot_config_pool_injection',
  UpdateCollateral = 'update_collateral',
  UpdateCollateralType = 'update_collateral_type',
  UpdateCommitment = 'update_commitment',
  UpdateDelegate = 'update_delegate',
  UpdateDeposit = 'update_deposit',
  UpdateEntity = 'update_entity',
  UpdateLoan = 'update_loan',
  UpdateNativeAsset = 'update_native_asset',
  UpdateNativeLoan = 'update_native_loan',
  UpdateNativePool = 'update_native_pool',
  UpdateOrg = 'update_org',
  UpdateOrgPool = 'update_org_pool',
  UpdateOrgSecuritize = 'update_org_securitize',
  UpdateOrgWallet = 'update_org_wallet',
  UpdatePool = 'update_pool',
  UpdatePoolCategory = 'update_pool_category',
  UpdatePriceOverride = 'update_price_override',
  UpdateReferralToken = 'update_referral_token',
  UpdateRole = 'update_role',
  UpdateSeason = 'update_season',
  UpdateSyrupGlobals = 'update_syrup_globals',
  UpdateUser = 'update_user',
  UpdateUserPool = 'update_user_pool',
  UpdateUserSecuritize = 'update_user_securitize',
  UpdateUserWallet = 'update_user_wallet'
}

export type Pool = {
  __typename?: 'Pool';
  allowedLPs?: Maybe<Array<Scalars['String']['output']>>;
  allowedSLs?: Maybe<Array<Scalars['String']['output']>>;
  apyData: ApyData;
  balance: Scalars['BigInt']['output'];
  currentLoaned: Scalars['BigInt']['output'];
  defaultsTotal: Scalars['BigInt']['output'];
  delegateFee: Scalars['BigInt']['output'];
  farmingApy: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  isPendingPositionsUpdate: Scalars['Boolean']['output'];
  lastClaimableRewardsUpdate: Scalars['BigInt']['output'];
  lendingApy: Scalars['BigInt']['output'];
  liquidity: Scalars['BigInt']['output'];
  liquidityAsset: Asset;
  liquidityAssetRecoveredTotal: Scalars['BigInt']['output'];
  liquidityCap: Scalars['BigInt']['output'];
  liquidityLocker: Scalars['Bytes']['output'];
  lockupPeriod: Scalars['BigInt']['output'];
  lpApy: Scalars['BigInt']['output'];
  mplRewards: MplRewards;
  name: Scalars['String']['output'];
  numActiveLoans: Scalars['BigInt']['output'];
  numLoans: Scalars['BigInt']['output'];
  numPositions: Scalars['BigInt']['output'];
  ongoingFee: Scalars['BigInt']['output'];
  openToPublic: Scalars['Boolean']['output'];
  poolDelegate: Account;
  poolDelegateFees: Scalars['BigInt']['output'];
  poolName: Scalars['String']['output'];
  poolTokenTotalSupply: Scalars['BigInt']['output'];
  poolV2?: Maybe<PoolV2>;
  positions?: Maybe<Array<PoolPosition>>;
  stake: Scalars['BigInt']['output'];
  stakeAsset: Asset;
  stakeLocker: Scalars['Bytes']['output'];
  stakeLockerFees: Scalars['BigInt']['output'];
  stakeLockerLiquidity: Scalars['BigInt']['output'];
  stakeLockerOpenToPublic: Scalars['Boolean']['output'];
  stakeLockupPeriod: Scalars['BigInt']['output'];
  stakeRewards: MplRewards;
  stakeRewardsApy: Scalars['BigInt']['output'];
  stakingApy: Scalars['BigInt']['output'];
  stakingFee: Scalars['BigInt']['output'];
  state: PoolState;
  symbol: Scalars['String']['output'];
  totalFees: Scalars['BigInt']['output'];
  totalInterestEarned: Scalars['BigInt']['output'];
  totalLoanOriginations: Scalars['BigInt']['output'];
  totalLoaned: Scalars['BigInt']['output'];
  totalPoolTokensStaked: Scalars['BigInt']['output'];
  totalPrincipalRepaid: Scalars['BigInt']['output'];
  totalStakeLockerTokensStaked: Scalars['BigInt']['output'];
  transaction: Transaction;
  txCount: Scalars['Int']['output'];
};


export type PoolPositionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolPosition_Filter>;
};

export type PoolAccessRequested = {
  __typename?: 'PoolAccessRequested';
  requested: Scalars['Boolean']['output'];
  typeformResponse?: Maybe<TypeformResponse>;
};

export type PoolCategory = {
  __typename?: 'PoolCategory';
  _id: Scalars['ID']['output'];
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
};

export type PoolCollateral = {
  __typename?: 'PoolCollateral';
  addresses: Array<Scalars['String']['output']>;
  asset: CollateralAsset;
  assetAmount?: Maybe<Scalars['String']['output']>;
  assetDecimals: Scalars['Int']['output'];
  assetValueUsd?: Maybe<Scalars['String']['output']>;
};

export type PoolCollateralInput = {
  addresses: Array<Scalars['String']['input']>;
  asset: CollateralAsset;
};

export type PoolDelegateCover = {
  __typename?: 'PoolDelegateCover';
  id: Scalars['ID']['output'];
  pool: PoolV2;
};

export type PoolDelegateCover_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum PoolDelegateCover_OrderBy {
  Id = 'id',
  Pool = 'pool'
}

export type PoolHighlight = {
  __typename?: 'PoolHighlight';
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PoolHighlightInput = {
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type PoolInjection = {
  __typename?: 'PoolInjection';
  address: Scalars['String']['output'];
  asset: Scalars['String']['output'];
  decimals: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  injections: Array<Injection>;
  maxInjectionAmount: Scalars['String']['output'];
  minInjectionAmount: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nextInjectionDate?: Maybe<Scalars['String']['output']>;
  pool?: Maybe<PoolV2>;
  randomnessVariance: Scalars['Int']['output'];
  sourceWallet: Scalars['String']['output'];
  targetFrequency: Scalars['Int']['output'];
  targetYield: Scalars['Float']['output'];
  xirrPeriod: Scalars['Int']['output'];
};

export type PoolInterestRequested = {
  __typename?: 'PoolInterestRequested';
  requested: Scalars['Boolean']['output'];
  typeformResponse?: Maybe<TypeformResponse>;
};

export type PoolManager = {
  __typename?: 'PoolManager';
  id: Scalars['ID']['output'];
  pool: PoolV2;
  transaction: Transaction;
  version: Scalars['Int']['output'];
};

export type PoolManager_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum PoolManager_OrderBy {
  Id = 'id',
  Pool = 'pool',
  Transaction = 'transaction',
  Version = 'version'
}

export type PoolMap = {
  __typename?: 'PoolMap';
  id: Scalars['ID']['output'];
  pool: Pool;
};

export type PoolMap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<Pool_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum PoolMap_OrderBy {
  Id = 'id',
  Pool = 'pool'
}

export type PoolMetadata = {
  __typename?: 'PoolMetadata';
  _id: Scalars['String']['output'];
  asset?: Maybe<Scalars['String']['output']>;
  benchmarkApy?: Maybe<Scalars['String']['output']>;
  cardDescription?: Maybe<Scalars['String']['output']>;
  carouselPriority?: Maybe<Scalars['Int']['output']>;
  collateralApy?: Maybe<Scalars['String']['output']>;
  collateralType?: Maybe<CollateralType>;
  contractAddress?: Maybe<Scalars['String']['output']>;
  docSendUrl?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  highlights?: Maybe<Array<Maybe<PoolHighlight>>>;
  image?: Maybe<Scalars['String']['output']>;
  isACMPool?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isTreasuryPool?: Maybe<Scalars['Boolean']['output']>;
  isUpcoming?: Maybe<Scalars['Boolean']['output']>;
  lendReqs?: Maybe<Array<LendReq>>;
  lendingEpochConfiguration?: Maybe<LendingEpochConfiguration>;
  lendingEpochConfigurations?: Maybe<Array<LendingEpochConfiguration>>;
  overview?: Maybe<Scalars['String']['output']>;
  permittedAddresses?: Maybe<Array<Scalars['String']['output']>>;
  poolCategory?: Maybe<PoolCategory>;
  poolCollaterals?: Maybe<Array<PoolCollateral>>;
  poolDelegate: DelegateMetadata;
  poolName: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  reportFileName?: Maybe<Scalars['String']['output']>;
  reportFileUrl?: Maybe<Scalars['String']['output']>;
  state: PoolV2State;
  strategy: Scalars['String']['output'];
  targetYield?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Ununsed */
  transactionHash?: Maybe<Scalars['String']['output']>;
  underwritingBullets?: Maybe<Array<Scalars['String']['output']>>;
  withdrawalDays?: Maybe<Scalars['Int']['output']>;
  withdrawalHours?: Maybe<Scalars['Int']['output']>;
  xirrHistory?: Maybe<Array<XirrYearHistory>>;
  xirrPeriod?: Maybe<Scalars['Float']['output']>;
};

export type PoolPermissionManager = {
  __typename?: 'PoolPermissionManager';
  id: Scalars['ID']['output'];
  pools?: Maybe<Array<PoolV2>>;
  transaction: Transaction;
  version: Scalars['Int']['output'];
};


export type PoolPermissionManagerPoolsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolV2_Filter>;
};

export type PoolPermissionManager_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  pools_?: InputMaybe<PoolV2_Filter>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum PoolPermissionManager_OrderBy {
  Id = 'id',
  Pools = 'pools',
  Transaction = 'transaction',
  Version = 'version'
}

export type PoolPosition = {
  __typename?: 'PoolPosition';
  account: Account;
  claimableFees: Scalars['BigInt']['output'];
  claimableInterest: Scalars['BigInt']['output'];
  claimableReward: Scalars['BigInt']['output'];
  claimableStakeReward: Scalars['BigInt']['output'];
  custodyAllowance: Scalars['BigInt']['output'];
  depositDate: Scalars['BigInt']['output'];
  feesEarned: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  interestEarned: Scalars['BigInt']['output'];
  pool: Pool;
  poolTokenBalance: Scalars['BigInt']['output'];
  poolTokensStaked: Scalars['BigInt']['output'];
  recognizableCoverLosses: Scalars['BigInt']['output'];
  recognizableLendingLosses: Scalars['BigInt']['output'];
  recognizedCoverLosses: Scalars['BigInt']['output'];
  recognizedLendingLosses: Scalars['BigInt']['output'];
  rewardPaid: Scalars['BigInt']['output'];
  stake: Scalars['BigInt']['output'];
  stakeCustodyAllowance: Scalars['BigInt']['output'];
  stakeDate: Scalars['BigInt']['output'];
  stakeLockerTokensStaked: Scalars['BigInt']['output'];
  stakeRewardPaid: Scalars['BigInt']['output'];
  transaction: Transaction;
  unstakeCooldown: Scalars['BigInt']['output'];
  withdrawCooldown: Scalars['BigInt']['output'];
};

export type PoolPositionMap = {
  __typename?: 'PoolPositionMap';
  id: Scalars['ID']['output'];
  poolPosition: PoolPosition;
};

export type PoolPositionMap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  poolPosition?: InputMaybe<Scalars['String']['input']>;
  poolPosition_?: InputMaybe<PoolPosition_Filter>;
  poolPosition_contains?: InputMaybe<Scalars['String']['input']>;
  poolPosition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPosition_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolPosition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPosition_gt?: InputMaybe<Scalars['String']['input']>;
  poolPosition_gte?: InputMaybe<Scalars['String']['input']>;
  poolPosition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolPosition_lt?: InputMaybe<Scalars['String']['input']>;
  poolPosition_lte?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolPosition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPosition_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolPosition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum PoolPositionMap_OrderBy {
  Id = 'id',
  PoolPosition = 'poolPosition'
}

export type PoolPosition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  claimableFees?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  claimableFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableInterest?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  claimableInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableReward?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableReward_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_not?: InputMaybe<Scalars['BigInt']['input']>;
  claimableReward_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableStakeReward?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimableStakeReward_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_not?: InputMaybe<Scalars['BigInt']['input']>;
  claimableStakeReward_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  custodyAllowance?: InputMaybe<Scalars['BigInt']['input']>;
  custodyAllowance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  custodyAllowance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  custodyAllowance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  custodyAllowance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  custodyAllowance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  custodyAllowance_not?: InputMaybe<Scalars['BigInt']['input']>;
  custodyAllowance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositDate?: InputMaybe<Scalars['BigInt']['input']>;
  depositDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  depositDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  depositDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  depositDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  depositDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  depositDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feesEarned?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  feesEarned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_not?: InputMaybe<Scalars['BigInt']['input']>;
  feesEarned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interestEarned?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestEarned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  poolTokenBalance?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolTokenBalance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_not?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenBalance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolTokensStaked?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_gt?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_gte?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolTokensStaked_lt?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_lte?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_not?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokensStaked_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pool_?: InputMaybe<Pool_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  recognizableCoverLosses?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableCoverLosses_gt?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableCoverLosses_gte?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableCoverLosses_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  recognizableCoverLosses_lt?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableCoverLosses_lte?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableCoverLosses_not?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableCoverLosses_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  recognizableLendingLosses?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableLendingLosses_gt?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableLendingLosses_gte?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableLendingLosses_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  recognizableLendingLosses_lt?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableLendingLosses_lte?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableLendingLosses_not?: InputMaybe<Scalars['BigInt']['input']>;
  recognizableLendingLosses_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  recognizedCoverLosses?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedCoverLosses_gt?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedCoverLosses_gte?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedCoverLosses_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  recognizedCoverLosses_lt?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedCoverLosses_lte?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedCoverLosses_not?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedCoverLosses_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  recognizedLendingLosses?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedLendingLosses_gt?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedLendingLosses_gte?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedLendingLosses_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  recognizedLendingLosses_lt?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedLendingLosses_lte?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedLendingLosses_not?: InputMaybe<Scalars['BigInt']['input']>;
  recognizedLendingLosses_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  rewardPaid?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  rewardPaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  rewardPaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stake?: InputMaybe<Scalars['BigInt']['input']>;
  stakeCustodyAllowance?: InputMaybe<Scalars['BigInt']['input']>;
  stakeCustodyAllowance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeCustodyAllowance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeCustodyAllowance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeCustodyAllowance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeCustodyAllowance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeCustodyAllowance_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakeCustodyAllowance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeDate?: InputMaybe<Scalars['BigInt']['input']>;
  stakeDate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeDate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeDate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeDate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeDate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeDate_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakeDate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeLockerTokensStaked?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeLockerTokensStaked_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerTokensStaked_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeRewardPaid?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeRewardPaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardPaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stake_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stake_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stake_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stake_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stake_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stake_not?: InputMaybe<Scalars['BigInt']['input']>;
  stake_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  unstakeCooldown?: InputMaybe<Scalars['BigInt']['input']>;
  unstakeCooldown_gt?: InputMaybe<Scalars['BigInt']['input']>;
  unstakeCooldown_gte?: InputMaybe<Scalars['BigInt']['input']>;
  unstakeCooldown_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  unstakeCooldown_lt?: InputMaybe<Scalars['BigInt']['input']>;
  unstakeCooldown_lte?: InputMaybe<Scalars['BigInt']['input']>;
  unstakeCooldown_not?: InputMaybe<Scalars['BigInt']['input']>;
  unstakeCooldown_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawCooldown?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawCooldown_gt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawCooldown_gte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawCooldown_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawCooldown_lt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawCooldown_lte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawCooldown_not?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawCooldown_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum PoolPosition_OrderBy {
  Account = 'account',
  ClaimableFees = 'claimableFees',
  ClaimableInterest = 'claimableInterest',
  ClaimableReward = 'claimableReward',
  ClaimableStakeReward = 'claimableStakeReward',
  CustodyAllowance = 'custodyAllowance',
  DepositDate = 'depositDate',
  FeesEarned = 'feesEarned',
  Id = 'id',
  InterestEarned = 'interestEarned',
  Pool = 'pool',
  PoolTokenBalance = 'poolTokenBalance',
  PoolTokensStaked = 'poolTokensStaked',
  RecognizableCoverLosses = 'recognizableCoverLosses',
  RecognizableLendingLosses = 'recognizableLendingLosses',
  RecognizedCoverLosses = 'recognizedCoverLosses',
  RecognizedLendingLosses = 'recognizedLendingLosses',
  RewardPaid = 'rewardPaid',
  Stake = 'stake',
  StakeCustodyAllowance = 'stakeCustodyAllowance',
  StakeDate = 'stakeDate',
  StakeLockerTokensStaked = 'stakeLockerTokensStaked',
  StakeRewardPaid = 'stakeRewardPaid',
  Transaction = 'transaction',
  UnstakeCooldown = 'unstakeCooldown',
  WithdrawCooldown = 'withdrawCooldown'
}

export enum PoolState {
  Deactivated = 'Deactivated',
  Finalized = 'Finalized',
  Initialized = 'Initialized'
}

export type PoolV2 = {
  __typename?: 'PoolV2';
  aaveStrategies?: Maybe<Array<AaveStrategy>>;
  accountedInterest: Scalars['BigInt']['output'];
  activated: Scalars['Boolean']['output'];
  allowedLPs: Array<Scalars['String']['output']>;
  /** @deprecated Use weeklyApy instead */
  apy?: Maybe<Scalars['String']['output']>;
  apyData: ApyData;
  asset: Asset;
  assets: Scalars['BigInt']['output'];
  averageInterest?: Maybe<Scalars['String']['output']>;
  borrowerCollateral?: Maybe<Scalars['String']['output']>;
  collateralByAsset?: Maybe<Array<PoolV2Total>>;
  collateralRatio?: Maybe<Scalars['String']['output']>;
  collateralValue?: Maybe<Scalars['String']['output']>;
  coverDeposited: Scalars['BigInt']['output'];
  coverLiquidated: Scalars['BigInt']['output'];
  delegate: Account;
  delegateManagementFeeRate: Scalars['BigInt']['output'];
  depositedAssets: Scalars['BigInt']['output'];
  domainEnd: Scalars['BigInt']['output'];
  domainStart: Scalars['BigInt']['output'];
  functionLevelBitmaps?: Maybe<Array<FunctionLevelBitmap>>;
  id: Scalars['ID']['output'];
  initialSupply: Scalars['BigInt']['output'];
  issuanceRate: Scalars['BigInt']['output'];
  lastAssetsUpdate: Scalars['BigInt']['output'];
  /** @deprecated Use monthlyApy or weeklyApy instead */
  lifetimeApy?: Maybe<Scalars['String']['output']>;
  liquidityCap: Scalars['BigInt']['output'];
  liquidityProvided: Scalars['BigInt']['output'];
  loanManager?: Maybe<LoanManager>;
  loanManagerUpdatedTransaction?: Maybe<Transaction>;
  loans?: Maybe<Array<Loan>>;
  maxCoverLiquidationPercent: Scalars['BigInt']['output'];
  minCoverAmount: Scalars['BigInt']['output'];
  monthlyApy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numActiveBorrowers?: Maybe<Scalars['Int']['output']>;
  numActiveLoans: Scalars['BigInt']['output'];
  numDefaultedLoans?: Maybe<Scalars['Int']['output']>;
  numLoans: Scalars['BigInt']['output'];
  numOpenTermLoans: Scalars['BigInt']['output'];
  numPositions: Scalars['BigInt']['output'];
  numUniqueBorrowers?: Maybe<Scalars['Int']['output']>;
  openTermLoanManager?: Maybe<OpenTermLoanManager>;
  openTermLoanManagerUpdatedTransaction?: Maybe<Transaction>;
  openTermLoans?: Maybe<Array<OpenTermLoan>>;
  openToPublic: Scalars['Boolean']['output'];
  permissionLevel: Scalars['Int']['output'];
  platformManagementFeeRate: Scalars['BigInt']['output'];
  platformOriginationFeeRate: Scalars['BigInt']['output'];
  platformServiceFeeRate: Scalars['BigInt']['output'];
  poolBitmapFlags?: Maybe<BitmapFlags>;
  poolDelegateCover: PoolDelegateCover;
  poolLevelBitmap: Scalars['BigInt']['output'];
  poolManager: PoolManager;
  poolMeta?: Maybe<PoolMetadata>;
  poolPermissionManager?: Maybe<PoolPermissionManager>;
  poolV1?: Maybe<Pool>;
  positions?: Maybe<Array<PoolV2Position>>;
  previousUnrealizedLosses: Scalars['BigInt']['output'];
  principalOut: Scalars['BigInt']['output'];
  realizedLosses: Scalars['BigInt']['output'];
  shares: Scalars['BigInt']['output'];
  skyStrategy?: Maybe<SkyStrategy>;
  /** @deprecated Use weeklyApy instead */
  spotApy?: Maybe<Scalars['String']['output']>;
  strategiesDeployed: Scalars['BigInt']['output'];
  symbol: Scalars['String']['output'];
  syrupRouter?: Maybe<SyrupRouter>;
  totalDelegateManagementFees: Scalars['BigInt']['output'];
  totalDelegateOriginationFees: Scalars['BigInt']['output'];
  totalDelegateServiceFees: Scalars['BigInt']['output'];
  totalLoanOriginations: Scalars['BigInt']['output'];
  totalPlatformManagementFees: Scalars['BigInt']['output'];
  totalPlatformOriginationsFees: Scalars['BigInt']['output'];
  totalPlatformServiceFees: Scalars['BigInt']['output'];
  transaction: Transaction;
  tvl?: Maybe<Scalars['String']['output']>;
  txCount: Scalars['Int']['output'];
  unrealizedLosses: Scalars['BigInt']['output'];
  weeklyApy?: Maybe<Scalars['String']['output']>;
  withdrawalManager?: Maybe<WithdrawalManager>;
  withdrawalManagerQueue?: Maybe<WithdrawalManagerQueue>;
  withdrawalManagerQueueUpdatedTransaction?: Maybe<Transaction>;
  withdrawalManagerUpdatedTransaction?: Maybe<Transaction>;
  withdrawnAssets: Scalars['BigInt']['output'];
};


export type PoolV2AaveStrategiesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AaveStrategy_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AaveStrategy_Filter>;
};


export type PoolV2CollateralByAssetArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2Total_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolV2Total_Filter>;
};


export type PoolV2FunctionLevelBitmapsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FunctionLevelBitmap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FunctionLevelBitmap_Filter>;
};


export type PoolV2LoansArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Loan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Loan_Filter>;
};


export type PoolV2OpenTermLoansArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OpenTermLoan_Filter>;
};


export type PoolV2PositionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2Position_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolV2Position_Filter>;
};

export type PoolV2Map = {
  __typename?: 'PoolV2Map';
  id: Scalars['ID']['output'];
  pool: PoolV2;
};

export type PoolV2Map_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum PoolV2Map_OrderBy {
  Id = 'id',
  Pool = 'pool'
}

export type PoolV2Position = {
  __typename?: 'PoolV2Position';
  account: Account;
  availableBalance?: Maybe<Scalars['String']['output']>;
  availableShares?: Maybe<Scalars['String']['output']>;
  commitments?: Maybe<Array<Commitment>>;
  depositedAssets: Scalars['BigInt']['output'];
  dripsEarned?: Maybe<Scalars['Float']['output']>;
  exitCycle: ExitCycle;
  id: Scalars['ID']['output'];
  interestEarned?: Maybe<Scalars['String']['output']>;
  lendingBalance?: Maybe<Scalars['String']['output']>;
  liquidityProvided: Scalars['BigInt']['output'];
  lockedShares: Scalars['BigInt']['output'];
  losses: Scalars['BigInt']['output'];
  pool: PoolV2;
  redeemRequested: Scalars['Boolean']['output'];
  shares: Scalars['BigInt']['output'];
  totalShares: Scalars['BigInt']['output'];
  transaction: Transaction;
  unrealizedLosses: Scalars['BigInt']['output'];
  withdrawnAssets: Scalars['BigInt']['output'];
};

export type PoolV2PositionMap = {
  __typename?: 'PoolV2PositionMap';
  id: Scalars['ID']['output'];
  poolPosition: PoolPosition;
};

export type PoolV2PositionMap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  poolPosition?: InputMaybe<Scalars['String']['input']>;
  poolPosition_?: InputMaybe<PoolPosition_Filter>;
  poolPosition_contains?: InputMaybe<Scalars['String']['input']>;
  poolPosition_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPosition_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolPosition_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPosition_gt?: InputMaybe<Scalars['String']['input']>;
  poolPosition_gte?: InputMaybe<Scalars['String']['input']>;
  poolPosition_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolPosition_lt?: InputMaybe<Scalars['String']['input']>;
  poolPosition_lte?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolPosition_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolPosition_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPosition_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolPosition_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum PoolV2PositionMap_OrderBy {
  Id = 'id',
  PoolPosition = 'poolPosition'
}

export type PoolV2Position_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositedAssets?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositedAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  exitCycle?: InputMaybe<Scalars['String']['input']>;
  exitCycle_?: InputMaybe<ExitCycle_Filter>;
  exitCycle_contains?: InputMaybe<Scalars['String']['input']>;
  exitCycle_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  exitCycle_ends_with?: InputMaybe<Scalars['String']['input']>;
  exitCycle_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  exitCycle_gt?: InputMaybe<Scalars['String']['input']>;
  exitCycle_gte?: InputMaybe<Scalars['String']['input']>;
  exitCycle_in?: InputMaybe<Array<Scalars['String']['input']>>;
  exitCycle_lt?: InputMaybe<Scalars['String']['input']>;
  exitCycle_lte?: InputMaybe<Scalars['String']['input']>;
  exitCycle_not?: InputMaybe<Scalars['String']['input']>;
  exitCycle_not_contains?: InputMaybe<Scalars['String']['input']>;
  exitCycle_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  exitCycle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  exitCycle_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  exitCycle_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  exitCycle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  exitCycle_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  exitCycle_starts_with?: InputMaybe<Scalars['String']['input']>;
  exitCycle_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  liquidityProvided?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityProvided_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lockedShares?: InputMaybe<Scalars['BigInt']['input']>;
  lockedShares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lockedShares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lockedShares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lockedShares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lockedShares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lockedShares_not?: InputMaybe<Scalars['BigInt']['input']>;
  lockedShares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  losses?: InputMaybe<Scalars['BigInt']['input']>;
  losses_gt?: InputMaybe<Scalars['BigInt']['input']>;
  losses_gte?: InputMaybe<Scalars['BigInt']['input']>;
  losses_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  losses_lt?: InputMaybe<Scalars['BigInt']['input']>;
  losses_lte?: InputMaybe<Scalars['BigInt']['input']>;
  losses_not?: InputMaybe<Scalars['BigInt']['input']>;
  losses_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  redeemRequested?: InputMaybe<Scalars['Boolean']['input']>;
  redeemRequested_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  redeemRequested_not?: InputMaybe<Scalars['Boolean']['input']>;
  redeemRequested_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  shares?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalShares?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalShares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  unrealizedLosses?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_gt?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_gte?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  unrealizedLosses_lt?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_lte?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_not?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawnAssets?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawnAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum PoolV2Position_OrderBy {
  Account = 'account',
  DepositedAssets = 'depositedAssets',
  ExitCycle = 'exitCycle',
  Id = 'id',
  LiquidityProvided = 'liquidityProvided',
  LockedShares = 'lockedShares',
  Losses = 'losses',
  Pool = 'pool',
  RedeemRequested = 'redeemRequested',
  Shares = 'shares',
  TotalShares = 'totalShares',
  Transaction = 'transaction',
  UnrealizedLosses = 'unrealizedLosses',
  WithdrawnAssets = 'withdrawnAssets'
}

export enum PoolV2State {
  Active = 'Active',
  Hidden = 'Hidden',
  Inactive = 'Inactive'
}

export type PoolV2Total = {
  __typename?: 'PoolV2Total';
  asset: Asset;
  id: Scalars['ID']['output'];
  pool: PoolV2;
  totalCollateral: Scalars['BigInt']['output'];
};

export type PoolV2Total_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<Asset_Filter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  totalCollateral?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalCollateral_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalCollateral_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum PoolV2Total_OrderBy {
  Asset = 'asset',
  Id = 'id',
  Pool = 'pool',
  TotalCollateral = 'totalCollateral'
}

export type PoolV2_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  aaveStrategies_?: InputMaybe<AaveStrategy_Filter>;
  accountedInterest?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  accountedInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  accountedInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  activated_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  activated_not?: InputMaybe<Scalars['Boolean']['input']>;
  activated_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  allowedLPs?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLPs_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLPs_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLPs_not?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLPs_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLPs_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  apyData_?: InputMaybe<ApyData_Filter>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<Asset_Filter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assets?: InputMaybe<Scalars['BigInt']['input']>;
  assets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  assets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  assets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  assets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  assets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  assets_not?: InputMaybe<Scalars['BigInt']['input']>;
  assets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  collateralByAsset_?: InputMaybe<PoolV2Total_Filter>;
  coverDeposited?: InputMaybe<Scalars['BigInt']['input']>;
  coverDeposited_gt?: InputMaybe<Scalars['BigInt']['input']>;
  coverDeposited_gte?: InputMaybe<Scalars['BigInt']['input']>;
  coverDeposited_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  coverDeposited_lt?: InputMaybe<Scalars['BigInt']['input']>;
  coverDeposited_lte?: InputMaybe<Scalars['BigInt']['input']>;
  coverDeposited_not?: InputMaybe<Scalars['BigInt']['input']>;
  coverDeposited_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  coverLiquidated?: InputMaybe<Scalars['BigInt']['input']>;
  coverLiquidated_gt?: InputMaybe<Scalars['BigInt']['input']>;
  coverLiquidated_gte?: InputMaybe<Scalars['BigInt']['input']>;
  coverLiquidated_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  coverLiquidated_lt?: InputMaybe<Scalars['BigInt']['input']>;
  coverLiquidated_lte?: InputMaybe<Scalars['BigInt']['input']>;
  coverLiquidated_not?: InputMaybe<Scalars['BigInt']['input']>;
  coverLiquidated_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegate?: InputMaybe<Scalars['String']['input']>;
  delegateManagementFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateManagementFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegate_?: InputMaybe<Account_Filter>;
  delegate_contains?: InputMaybe<Scalars['String']['input']>;
  delegate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  delegate_ends_with?: InputMaybe<Scalars['String']['input']>;
  delegate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  delegate_gt?: InputMaybe<Scalars['String']['input']>;
  delegate_gte?: InputMaybe<Scalars['String']['input']>;
  delegate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  delegate_lt?: InputMaybe<Scalars['String']['input']>;
  delegate_lte?: InputMaybe<Scalars['String']['input']>;
  delegate_not?: InputMaybe<Scalars['String']['input']>;
  delegate_not_contains?: InputMaybe<Scalars['String']['input']>;
  delegate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  delegate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  delegate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  delegate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  delegate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  delegate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  delegate_starts_with?: InputMaybe<Scalars['String']['input']>;
  delegate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositedAssets?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositedAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainEnd?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_gt?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_gte?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainEnd_lt?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_lte?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_not?: InputMaybe<Scalars['BigInt']['input']>;
  domainEnd_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainStart?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_gt?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_gte?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  domainStart_lt?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_lte?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_not?: InputMaybe<Scalars['BigInt']['input']>;
  domainStart_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  functionLevelBitmaps_?: InputMaybe<FunctionLevelBitmap_Filter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  initialSupply?: InputMaybe<Scalars['BigInt']['input']>;
  initialSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  issuanceRate?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  issuanceRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastAssetsUpdate?: InputMaybe<Scalars['BigInt']['input']>;
  lastAssetsUpdate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastAssetsUpdate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastAssetsUpdate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastAssetsUpdate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastAssetsUpdate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastAssetsUpdate_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastAssetsUpdate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityCap?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityCap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityProvided?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityProvided_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  loanManager?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_?: InputMaybe<Transaction_Filter>;
  loanManagerUpdatedTransaction_contains?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_gt?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_gte?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loanManagerUpdatedTransaction_lt?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_lte?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_not?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loanManagerUpdatedTransaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  loanManagerUpdatedTransaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanManager_?: InputMaybe<LoanManager_Filter>;
  loanManager_contains?: InputMaybe<Scalars['String']['input']>;
  loanManager_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loanManager_ends_with?: InputMaybe<Scalars['String']['input']>;
  loanManager_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanManager_gt?: InputMaybe<Scalars['String']['input']>;
  loanManager_gte?: InputMaybe<Scalars['String']['input']>;
  loanManager_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loanManager_lt?: InputMaybe<Scalars['String']['input']>;
  loanManager_lte?: InputMaybe<Scalars['String']['input']>;
  loanManager_not?: InputMaybe<Scalars['String']['input']>;
  loanManager_not_contains?: InputMaybe<Scalars['String']['input']>;
  loanManager_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loanManager_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loanManager_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanManager_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loanManager_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loanManager_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loanManager_starts_with?: InputMaybe<Scalars['String']['input']>;
  loanManager_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loans_?: InputMaybe<Loan_Filter>;
  maxCoverLiquidationPercent?: InputMaybe<Scalars['BigInt']['input']>;
  maxCoverLiquidationPercent_gt?: InputMaybe<Scalars['BigInt']['input']>;
  maxCoverLiquidationPercent_gte?: InputMaybe<Scalars['BigInt']['input']>;
  maxCoverLiquidationPercent_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  maxCoverLiquidationPercent_lt?: InputMaybe<Scalars['BigInt']['input']>;
  maxCoverLiquidationPercent_lte?: InputMaybe<Scalars['BigInt']['input']>;
  maxCoverLiquidationPercent_not?: InputMaybe<Scalars['BigInt']['input']>;
  maxCoverLiquidationPercent_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  minCoverAmount?: InputMaybe<Scalars['BigInt']['input']>;
  minCoverAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  minCoverAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  minCoverAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  minCoverAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  minCoverAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  minCoverAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  minCoverAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  numActiveLoans?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numActiveLoans_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_not?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numLoans?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numLoans_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_not?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numOpenTermLoans?: InputMaybe<Scalars['BigInt']['input']>;
  numOpenTermLoans_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numOpenTermLoans_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numOpenTermLoans_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numOpenTermLoans_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numOpenTermLoans_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numOpenTermLoans_not?: InputMaybe<Scalars['BigInt']['input']>;
  numOpenTermLoans_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numPositions?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numPositions_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_not?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  openTermLoanManager?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_?: InputMaybe<Transaction_Filter>;
  openTermLoanManagerUpdatedTransaction_contains?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_gt?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_gte?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  openTermLoanManagerUpdatedTransaction_lt?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_lte?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_not?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  openTermLoanManagerUpdatedTransaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManagerUpdatedTransaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_?: InputMaybe<OpenTermLoanManager_Filter>;
  openTermLoanManager_contains?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_ends_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_gt?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_gte?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_in?: InputMaybe<Array<Scalars['String']['input']>>;
  openTermLoanManager_lt?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_lte?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_not?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_not_contains?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  openTermLoanManager_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_starts_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoanManager_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoans_?: InputMaybe<OpenTermLoan_Filter>;
  openToPublic?: InputMaybe<Scalars['Boolean']['input']>;
  openToPublic_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  openToPublic_not?: InputMaybe<Scalars['Boolean']['input']>;
  openToPublic_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  permissionLevel?: InputMaybe<Scalars['Int']['input']>;
  permissionLevel_gt?: InputMaybe<Scalars['Int']['input']>;
  permissionLevel_gte?: InputMaybe<Scalars['Int']['input']>;
  permissionLevel_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  permissionLevel_lt?: InputMaybe<Scalars['Int']['input']>;
  permissionLevel_lte?: InputMaybe<Scalars['Int']['input']>;
  permissionLevel_not?: InputMaybe<Scalars['Int']['input']>;
  permissionLevel_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  platformManagementFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformManagementFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformOriginationFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformOriginationFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformOriginationFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolDelegateCover?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_?: InputMaybe<PoolDelegateCover_Filter>;
  poolDelegateCover_contains?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_gt?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_gte?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolDelegateCover_lt?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_lte?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_not?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolDelegateCover_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolDelegateCover_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolLevelBitmap?: InputMaybe<Scalars['BigInt']['input']>;
  poolLevelBitmap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  poolLevelBitmap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  poolLevelBitmap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolLevelBitmap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  poolLevelBitmap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  poolLevelBitmap_not?: InputMaybe<Scalars['BigInt']['input']>;
  poolLevelBitmap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolManager?: InputMaybe<Scalars['String']['input']>;
  poolManager_?: InputMaybe<PoolManager_Filter>;
  poolManager_contains?: InputMaybe<Scalars['String']['input']>;
  poolManager_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolManager_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolManager_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolManager_gt?: InputMaybe<Scalars['String']['input']>;
  poolManager_gte?: InputMaybe<Scalars['String']['input']>;
  poolManager_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolManager_lt?: InputMaybe<Scalars['String']['input']>;
  poolManager_lte?: InputMaybe<Scalars['String']['input']>;
  poolManager_not?: InputMaybe<Scalars['String']['input']>;
  poolManager_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolManager_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolManager_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolManager_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolManager_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolManager_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolManager_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolManager_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolManager_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_?: InputMaybe<PoolPermissionManager_Filter>;
  poolPermissionManager_contains?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_gt?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_gte?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolPermissionManager_lt?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_lte?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_not?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolPermissionManager_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolPermissionManager_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV1?: InputMaybe<Scalars['String']['input']>;
  poolV1_?: InputMaybe<Pool_Filter>;
  poolV1_contains?: InputMaybe<Scalars['String']['input']>;
  poolV1_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV1_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolV1_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV1_gt?: InputMaybe<Scalars['String']['input']>;
  poolV1_gte?: InputMaybe<Scalars['String']['input']>;
  poolV1_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolV1_lt?: InputMaybe<Scalars['String']['input']>;
  poolV1_lte?: InputMaybe<Scalars['String']['input']>;
  poolV1_not?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolV1_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolV1_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV1_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolV1_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  positions_?: InputMaybe<PoolV2Position_Filter>;
  previousUnrealizedLosses?: InputMaybe<Scalars['BigInt']['input']>;
  previousUnrealizedLosses_gt?: InputMaybe<Scalars['BigInt']['input']>;
  previousUnrealizedLosses_gte?: InputMaybe<Scalars['BigInt']['input']>;
  previousUnrealizedLosses_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  previousUnrealizedLosses_lt?: InputMaybe<Scalars['BigInt']['input']>;
  previousUnrealizedLosses_lte?: InputMaybe<Scalars['BigInt']['input']>;
  previousUnrealizedLosses_not?: InputMaybe<Scalars['BigInt']['input']>;
  previousUnrealizedLosses_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOut?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principalOut_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_not?: InputMaybe<Scalars['BigInt']['input']>;
  principalOut_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  realizedLosses?: InputMaybe<Scalars['BigInt']['input']>;
  realizedLosses_gt?: InputMaybe<Scalars['BigInt']['input']>;
  realizedLosses_gte?: InputMaybe<Scalars['BigInt']['input']>;
  realizedLosses_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  realizedLosses_lt?: InputMaybe<Scalars['BigInt']['input']>;
  realizedLosses_lte?: InputMaybe<Scalars['BigInt']['input']>;
  realizedLosses_not?: InputMaybe<Scalars['BigInt']['input']>;
  realizedLosses_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  skyStrategy?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_?: InputMaybe<SkyStrategy_Filter>;
  skyStrategy_contains?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_ends_with?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_gt?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_gte?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_in?: InputMaybe<Array<Scalars['String']['input']>>;
  skyStrategy_lt?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_lte?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_not?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_not_contains?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  skyStrategy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_starts_with?: InputMaybe<Scalars['String']['input']>;
  skyStrategy_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  strategiesDeployed?: InputMaybe<Scalars['BigInt']['input']>;
  strategiesDeployed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  strategiesDeployed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  strategiesDeployed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strategiesDeployed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  strategiesDeployed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  strategiesDeployed_not?: InputMaybe<Scalars['BigInt']['input']>;
  strategiesDeployed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  syrupRouter?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_?: InputMaybe<SyrupRouter_Filter>;
  syrupRouter_contains?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_ends_with?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_gt?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_gte?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_in?: InputMaybe<Array<Scalars['String']['input']>>;
  syrupRouter_lt?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_lte?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_not?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_not_contains?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  syrupRouter_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_starts_with?: InputMaybe<Scalars['String']['input']>;
  syrupRouter_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  totalDelegateManagementFees?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateManagementFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateManagementFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateManagementFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalDelegateManagementFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateManagementFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateManagementFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateManagementFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalDelegateOriginationFees?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateOriginationFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateOriginationFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateOriginationFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalDelegateOriginationFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateOriginationFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateOriginationFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateOriginationFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalDelegateServiceFees?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateServiceFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateServiceFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateServiceFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalDelegateServiceFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateServiceFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateServiceFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalDelegateServiceFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLoanOriginations?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLoanOriginations_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPlatformManagementFees?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformManagementFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformManagementFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformManagementFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPlatformManagementFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformManagementFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformManagementFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformManagementFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPlatformOriginationsFees?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformOriginationsFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformOriginationsFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformOriginationsFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPlatformOriginationsFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformOriginationsFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformOriginationsFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformOriginationsFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPlatformServiceFees?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformServiceFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformServiceFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformServiceFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPlatformServiceFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformServiceFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformServiceFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalPlatformServiceFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  txCount?: InputMaybe<Scalars['Int']['input']>;
  txCount_gt?: InputMaybe<Scalars['Int']['input']>;
  txCount_gte?: InputMaybe<Scalars['Int']['input']>;
  txCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  txCount_lt?: InputMaybe<Scalars['Int']['input']>;
  txCount_lte?: InputMaybe<Scalars['Int']['input']>;
  txCount_not?: InputMaybe<Scalars['Int']['input']>;
  txCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  unrealizedLosses?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_gt?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_gte?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  unrealizedLosses_lt?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_lte?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_not?: InputMaybe<Scalars['BigInt']['input']>;
  unrealizedLosses_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawalManager?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_?: InputMaybe<Transaction_Filter>;
  withdrawalManagerQueueUpdatedTransaction_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_gt?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_gte?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalManagerQueueUpdatedTransaction_lt?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_lte?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_not?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalManagerQueueUpdatedTransaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueueUpdatedTransaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_?: InputMaybe<WithdrawalManagerQueue_Filter>;
  withdrawalManagerQueue_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_gt?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_gte?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalManagerQueue_lt?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_lte?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_not?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_not_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalManagerQueue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerQueue_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_?: InputMaybe<Transaction_Filter>;
  withdrawalManagerUpdatedTransaction_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_gt?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_gte?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalManagerUpdatedTransaction_lt?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_lte?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_not?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalManagerUpdatedTransaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManagerUpdatedTransaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_?: InputMaybe<WithdrawalManager_Filter>;
  withdrawalManager_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_gt?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_gte?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalManager_lt?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_lte?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_not?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_not_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalManager_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalManager_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawnAssets?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawnAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum PoolV2_OrderBy {
  AaveStrategies = 'aaveStrategies',
  AccountedInterest = 'accountedInterest',
  Activated = 'activated',
  AllowedLPs = 'allowedLPs',
  ApyData = 'apyData',
  Asset = 'asset',
  Assets = 'assets',
  CollateralByAsset = 'collateralByAsset',
  CoverDeposited = 'coverDeposited',
  CoverLiquidated = 'coverLiquidated',
  Delegate = 'delegate',
  DelegateManagementFeeRate = 'delegateManagementFeeRate',
  DepositedAssets = 'depositedAssets',
  DomainEnd = 'domainEnd',
  DomainStart = 'domainStart',
  FunctionLevelBitmaps = 'functionLevelBitmaps',
  Id = 'id',
  InitialSupply = 'initialSupply',
  IssuanceRate = 'issuanceRate',
  LastAssetsUpdate = 'lastAssetsUpdate',
  LiquidityCap = 'liquidityCap',
  LiquidityProvided = 'liquidityProvided',
  LoanManager = 'loanManager',
  LoanManagerUpdatedTransaction = 'loanManagerUpdatedTransaction',
  Loans = 'loans',
  MaxCoverLiquidationPercent = 'maxCoverLiquidationPercent',
  MinCoverAmount = 'minCoverAmount',
  Name = 'name',
  NumActiveLoans = 'numActiveLoans',
  NumLoans = 'numLoans',
  NumOpenTermLoans = 'numOpenTermLoans',
  NumPositions = 'numPositions',
  OpenTermLoanManager = 'openTermLoanManager',
  OpenTermLoanManagerUpdatedTransaction = 'openTermLoanManagerUpdatedTransaction',
  OpenTermLoans = 'openTermLoans',
  OpenToPublic = 'openToPublic',
  PermissionLevel = 'permissionLevel',
  PlatformManagementFeeRate = 'platformManagementFeeRate',
  PlatformOriginationFeeRate = 'platformOriginationFeeRate',
  PlatformServiceFeeRate = 'platformServiceFeeRate',
  PoolDelegateCover = 'poolDelegateCover',
  PoolLevelBitmap = 'poolLevelBitmap',
  PoolManager = 'poolManager',
  PoolPermissionManager = 'poolPermissionManager',
  PoolV1 = 'poolV1',
  Positions = 'positions',
  PreviousUnrealizedLosses = 'previousUnrealizedLosses',
  PrincipalOut = 'principalOut',
  RealizedLosses = 'realizedLosses',
  Shares = 'shares',
  SkyStrategy = 'skyStrategy',
  StrategiesDeployed = 'strategiesDeployed',
  Symbol = 'symbol',
  SyrupRouter = 'syrupRouter',
  TotalDelegateManagementFees = 'totalDelegateManagementFees',
  TotalDelegateOriginationFees = 'totalDelegateOriginationFees',
  TotalDelegateServiceFees = 'totalDelegateServiceFees',
  TotalLoanOriginations = 'totalLoanOriginations',
  TotalPlatformManagementFees = 'totalPlatformManagementFees',
  TotalPlatformOriginationsFees = 'totalPlatformOriginationsFees',
  TotalPlatformServiceFees = 'totalPlatformServiceFees',
  Transaction = 'transaction',
  TxCount = 'txCount',
  UnrealizedLosses = 'unrealizedLosses',
  WithdrawalManager = 'withdrawalManager',
  WithdrawalManagerQueue = 'withdrawalManagerQueue',
  WithdrawalManagerQueueUpdatedTransaction = 'withdrawalManagerQueueUpdatedTransaction',
  WithdrawalManagerUpdatedTransaction = 'withdrawalManagerUpdatedTransaction',
  WithdrawnAssets = 'withdrawnAssets'
}

export type PoolVerificationStatus = {
  __typename?: 'PoolVerificationStatus';
  lendReqs?: Maybe<Array<LendReqStatus>>;
  poolId: Scalars['String']['output'];
};

export type Pool_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  allowedLPs?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLPs_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLPs_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLPs_not?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLPs_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLPs_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedSLs?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedSLs_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedSLs_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedSLs_not?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedSLs_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedSLs_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  apyData_?: InputMaybe<ApyData_Filter>;
  balance?: InputMaybe<Scalars['BigInt']['input']>;
  balance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  balance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  balance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  balance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  balance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  balance_not?: InputMaybe<Scalars['BigInt']['input']>;
  balance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  currentLoaned?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  currentLoaned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_not?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultsTotal?: InputMaybe<Scalars['BigInt']['input']>;
  defaultsTotal_gt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultsTotal_gte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultsTotal_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  defaultsTotal_lt?: InputMaybe<Scalars['BigInt']['input']>;
  defaultsTotal_lte?: InputMaybe<Scalars['BigInt']['input']>;
  defaultsTotal_not?: InputMaybe<Scalars['BigInt']['input']>;
  defaultsTotal_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateFee?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  farmingApy?: InputMaybe<Scalars['BigInt']['input']>;
  farmingApy_gt?: InputMaybe<Scalars['BigInt']['input']>;
  farmingApy_gte?: InputMaybe<Scalars['BigInt']['input']>;
  farmingApy_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  farmingApy_lt?: InputMaybe<Scalars['BigInt']['input']>;
  farmingApy_lte?: InputMaybe<Scalars['BigInt']['input']>;
  farmingApy_not?: InputMaybe<Scalars['BigInt']['input']>;
  farmingApy_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPendingPositionsUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  isPendingPositionsUpdate_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isPendingPositionsUpdate_not?: InputMaybe<Scalars['Boolean']['input']>;
  isPendingPositionsUpdate_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  lastClaimableRewardsUpdate?: InputMaybe<Scalars['BigInt']['input']>;
  lastClaimableRewardsUpdate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastClaimableRewardsUpdate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastClaimableRewardsUpdate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastClaimableRewardsUpdate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastClaimableRewardsUpdate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastClaimableRewardsUpdate_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastClaimableRewardsUpdate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lendingApy?: InputMaybe<Scalars['BigInt']['input']>;
  lendingApy_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lendingApy_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lendingApy_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lendingApy_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lendingApy_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lendingApy_not?: InputMaybe<Scalars['BigInt']['input']>;
  lendingApy_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAsset?: InputMaybe<Scalars['String']['input']>;
  liquidityAssetRecoveredTotal?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetRecoveredTotal_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetRecoveredTotal_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetRecoveredTotal_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityAssetRecoveredTotal_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetRecoveredTotal_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetRecoveredTotal_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityAssetRecoveredTotal_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityAsset_?: InputMaybe<Asset_Filter>;
  liquidityAsset_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_gt?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_gte?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityAsset_lt?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_lte?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityCap?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityCap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityLocker?: InputMaybe<Scalars['Bytes']['input']>;
  liquidityLocker_contains?: InputMaybe<Scalars['Bytes']['input']>;
  liquidityLocker_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  liquidityLocker_not?: InputMaybe<Scalars['Bytes']['input']>;
  liquidityLocker_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  liquidityLocker_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  liquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lockupPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  lockupPeriod_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lockupPeriod_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lockupPeriod_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lockupPeriod_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lockupPeriod_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lockupPeriod_not?: InputMaybe<Scalars['BigInt']['input']>;
  lockupPeriod_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpApy?: InputMaybe<Scalars['BigInt']['input']>;
  lpApy_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lpApy_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lpApy_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lpApy_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lpApy_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lpApy_not?: InputMaybe<Scalars['BigInt']['input']>;
  lpApy_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  mplRewards?: InputMaybe<Scalars['String']['input']>;
  mplRewards_?: InputMaybe<MplRewards_Filter>;
  mplRewards_contains?: InputMaybe<Scalars['String']['input']>;
  mplRewards_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  mplRewards_ends_with?: InputMaybe<Scalars['String']['input']>;
  mplRewards_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  mplRewards_gt?: InputMaybe<Scalars['String']['input']>;
  mplRewards_gte?: InputMaybe<Scalars['String']['input']>;
  mplRewards_in?: InputMaybe<Array<Scalars['String']['input']>>;
  mplRewards_lt?: InputMaybe<Scalars['String']['input']>;
  mplRewards_lte?: InputMaybe<Scalars['String']['input']>;
  mplRewards_not?: InputMaybe<Scalars['String']['input']>;
  mplRewards_not_contains?: InputMaybe<Scalars['String']['input']>;
  mplRewards_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  mplRewards_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  mplRewards_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  mplRewards_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  mplRewards_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  mplRewards_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  mplRewards_starts_with?: InputMaybe<Scalars['String']['input']>;
  mplRewards_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  numActiveLoans?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numActiveLoans_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_not?: InputMaybe<Scalars['BigInt']['input']>;
  numActiveLoans_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numLoans?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numLoans_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_not?: InputMaybe<Scalars['BigInt']['input']>;
  numLoans_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numPositions?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_gt?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_gte?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  numPositions_lt?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_lte?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_not?: InputMaybe<Scalars['BigInt']['input']>;
  numPositions_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  ongoingFee?: InputMaybe<Scalars['BigInt']['input']>;
  ongoingFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  ongoingFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  ongoingFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  ongoingFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  ongoingFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  ongoingFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  ongoingFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  openToPublic?: InputMaybe<Scalars['Boolean']['input']>;
  openToPublic_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  openToPublic_not?: InputMaybe<Scalars['Boolean']['input']>;
  openToPublic_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  poolDelegate?: InputMaybe<Scalars['String']['input']>;
  poolDelegateFees?: InputMaybe<Scalars['BigInt']['input']>;
  poolDelegateFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  poolDelegateFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  poolDelegateFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolDelegateFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  poolDelegateFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  poolDelegateFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  poolDelegateFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolDelegate_?: InputMaybe<Account_Filter>;
  poolDelegate_contains?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_gt?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_gte?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolDelegate_lt?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_lte?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_not?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolDelegate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolDelegate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolName?: InputMaybe<Scalars['String']['input']>;
  poolName_contains?: InputMaybe<Scalars['String']['input']>;
  poolName_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolName_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolName_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolName_gt?: InputMaybe<Scalars['String']['input']>;
  poolName_gte?: InputMaybe<Scalars['String']['input']>;
  poolName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolName_lt?: InputMaybe<Scalars['String']['input']>;
  poolName_lte?: InputMaybe<Scalars['String']['input']>;
  poolName_not?: InputMaybe<Scalars['String']['input']>;
  poolName_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolName_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolName_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolName_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolName_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolName_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolName_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolTokenTotalSupply?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenTotalSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenTotalSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenTotalSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolTokenTotalSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenTotalSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenTotalSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  poolTokenTotalSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  poolV2_?: InputMaybe<PoolV2_Filter>;
  positions_?: InputMaybe<PoolPosition_Filter>;
  stake?: InputMaybe<Scalars['BigInt']['input']>;
  stakeAsset?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_?: InputMaybe<Asset_Filter>;
  stakeAsset_contains?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_gt?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_gte?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  stakeAsset_lt?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_lte?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_not?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  stakeAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  stakeAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stakeLocker?: InputMaybe<Scalars['Bytes']['input']>;
  stakeLockerFees?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeLockerFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeLockerLiquidity?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerLiquidity_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerLiquidity_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerLiquidity_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeLockerLiquidity_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerLiquidity_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerLiquidity_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockerLiquidity_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeLockerOpenToPublic?: InputMaybe<Scalars['Boolean']['input']>;
  stakeLockerOpenToPublic_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  stakeLockerOpenToPublic_not?: InputMaybe<Scalars['Boolean']['input']>;
  stakeLockerOpenToPublic_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  stakeLocker_contains?: InputMaybe<Scalars['Bytes']['input']>;
  stakeLocker_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  stakeLocker_not?: InputMaybe<Scalars['Bytes']['input']>;
  stakeLocker_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  stakeLocker_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  stakeLockupPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockupPeriod_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockupPeriod_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockupPeriod_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeLockupPeriod_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockupPeriod_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockupPeriod_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakeLockupPeriod_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeRewards?: InputMaybe<Scalars['String']['input']>;
  stakeRewardsApy?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardsApy_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardsApy_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardsApy_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeRewardsApy_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardsApy_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardsApy_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakeRewardsApy_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakeRewards_?: InputMaybe<MplRewards_Filter>;
  stakeRewards_contains?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_ends_with?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_gt?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_gte?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_in?: InputMaybe<Array<Scalars['String']['input']>>;
  stakeRewards_lt?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_lte?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_not?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_not_contains?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  stakeRewards_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_starts_with?: InputMaybe<Scalars['String']['input']>;
  stakeRewards_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stake_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stake_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stake_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stake_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stake_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stake_not?: InputMaybe<Scalars['BigInt']['input']>;
  stake_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakingApy?: InputMaybe<Scalars['BigInt']['input']>;
  stakingApy_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakingApy_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakingApy_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakingApy_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakingApy_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakingApy_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakingApy_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakingFee?: InputMaybe<Scalars['BigInt']['input']>;
  stakingFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  stakingFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  stakingFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  stakingFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  stakingFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  stakingFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  stakingFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  state?: InputMaybe<PoolState>;
  state_in?: InputMaybe<Array<PoolState>>;
  state_not?: InputMaybe<PoolState>;
  state_not_in?: InputMaybe<Array<PoolState>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  totalFees?: InputMaybe<Scalars['BigInt']['input']>;
  totalFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalInterestEarned?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalInterestEarned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalInterestEarned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLoanOriginations?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLoanOriginations_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoanOriginations_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLoaned?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoaned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoaned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoaned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalLoaned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoaned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoaned_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoaned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPoolTokensStaked?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPoolTokensStaked_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalPoolTokensStaked_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPrincipalRepaid?: InputMaybe<Scalars['BigInt']['input']>;
  totalPrincipalRepaid_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPrincipalRepaid_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPrincipalRepaid_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalPrincipalRepaid_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalPrincipalRepaid_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalPrincipalRepaid_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalPrincipalRepaid_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalStakeLockerTokensStaked?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalStakeLockerTokensStaked_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalStakeLockerTokensStaked_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  txCount?: InputMaybe<Scalars['Int']['input']>;
  txCount_gt?: InputMaybe<Scalars['Int']['input']>;
  txCount_gte?: InputMaybe<Scalars['Int']['input']>;
  txCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  txCount_lt?: InputMaybe<Scalars['Int']['input']>;
  txCount_lte?: InputMaybe<Scalars['Int']['input']>;
  txCount_not?: InputMaybe<Scalars['Int']['input']>;
  txCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum Pool_OrderBy {
  AllowedLPs = 'allowedLPs',
  AllowedSLs = 'allowedSLs',
  ApyData = 'apyData',
  Balance = 'balance',
  CurrentLoaned = 'currentLoaned',
  DefaultsTotal = 'defaultsTotal',
  DelegateFee = 'delegateFee',
  FarmingApy = 'farmingApy',
  Id = 'id',
  IsPendingPositionsUpdate = 'isPendingPositionsUpdate',
  LastClaimableRewardsUpdate = 'lastClaimableRewardsUpdate',
  LendingApy = 'lendingApy',
  Liquidity = 'liquidity',
  LiquidityAsset = 'liquidityAsset',
  LiquidityAssetRecoveredTotal = 'liquidityAssetRecoveredTotal',
  LiquidityCap = 'liquidityCap',
  LiquidityLocker = 'liquidityLocker',
  LockupPeriod = 'lockupPeriod',
  LpApy = 'lpApy',
  MplRewards = 'mplRewards',
  Name = 'name',
  NumActiveLoans = 'numActiveLoans',
  NumLoans = 'numLoans',
  NumPositions = 'numPositions',
  OngoingFee = 'ongoingFee',
  OpenToPublic = 'openToPublic',
  PoolDelegate = 'poolDelegate',
  PoolDelegateFees = 'poolDelegateFees',
  PoolName = 'poolName',
  PoolTokenTotalSupply = 'poolTokenTotalSupply',
  PoolV2 = 'poolV2',
  Positions = 'positions',
  Stake = 'stake',
  StakeAsset = 'stakeAsset',
  StakeLocker = 'stakeLocker',
  StakeLockerFees = 'stakeLockerFees',
  StakeLockerLiquidity = 'stakeLockerLiquidity',
  StakeLockerOpenToPublic = 'stakeLockerOpenToPublic',
  StakeLockupPeriod = 'stakeLockupPeriod',
  StakeRewards = 'stakeRewards',
  StakeRewardsApy = 'stakeRewardsApy',
  StakingApy = 'stakingApy',
  StakingFee = 'stakingFee',
  State = 'state',
  Symbol = 'symbol',
  TotalFees = 'totalFees',
  TotalInterestEarned = 'totalInterestEarned',
  TotalLoanOriginations = 'totalLoanOriginations',
  TotalLoaned = 'totalLoaned',
  TotalPoolTokensStaked = 'totalPoolTokensStaked',
  TotalPrincipalRepaid = 'totalPrincipalRepaid',
  TotalStakeLockerTokensStaked = 'totalStakeLockerTokensStaked',
  Transaction = 'transaction',
  TxCount = 'txCount'
}

export type PriceFeedAssetMap = {
  __typename?: 'PriceFeedAssetMap';
  asset: Asset;
  id: Scalars['ID']['output'];
};

export type PriceFeedAssetMap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<Asset_Filter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum PriceFeedAssetMap_OrderBy {
  Asset = 'asset',
  Id = 'id'
}

export type PriceOverride = {
  __typename?: 'PriceOverride';
  enabled: Scalars['Boolean']['output'];
  price: Scalars['Float']['output'];
  symbol: Scalars['String']['output'];
};

export type Privilege = {
  __typename?: 'Privilege';
  permission: Permission;
  resources: Array<Scalars['ID']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  aavestrategies: Array<AaveStrategy>;
  aavestrategy?: Maybe<AaveStrategy>;
  account?: Maybe<Account>;
  accountById?: Maybe<Account>;
  accountTotal?: Maybe<AccountTotal>;
  accountTotals: Array<AccountTotal>;
  accounts: Array<Account>;
  activeBanner?: Maybe<Banner>;
  activePools: Array<Maybe<PoolV2>>;
  addressCompliance: AddressCompliance;
  aggregatorAssetMap?: Maybe<AggregatorAssetMap>;
  aggregatorAssetMaps: Array<AggregatorAssetMap>;
  allBondPositions?: Maybe<Array<BondPosition>>;
  allCollateralTypes?: Maybe<Array<CollateralType>>;
  allDeposits?: Maybe<Array<Deposit>>;
  allLendingEpochConfigurations?: Maybe<Array<LendingEpochConfiguration>>;
  allOrgs?: Maybe<Array<Org>>;
  allPoolCategories?: Maybe<Array<PoolCategory>>;
  allPriceOverrides?: Maybe<Array<PriceOverride>>;
  allReferralTokens?: Maybe<Array<ReferralToken>>;
  allSyrupUsers?: Maybe<Array<SyrupUser>>;
  allUsers?: Maybe<Array<User>>;
  allWallets: Array<Wallet>;
  allocation?: Maybe<Allocation>;
  allocations: Array<Allocation>;
  apyData?: Maybe<ApyData>;
  apyDatas: Array<ApyData>;
  asset?: Maybe<Asset>;
  assetById?: Maybe<Asset>;
  assetMap?: Maybe<AssetMap>;
  assetMaps: Array<AssetMap>;
  assets: Array<Asset>;
  availableInterestStatements?: Maybe<Array<AvailableInterestStatement>>;
  banners?: Maybe<Array<Banner>>;
  bondPositionsByPoolId?: Maybe<Array<BondPosition>>;
  bondsMaturityByPoolId: BondMaturity;
  borrowerAccessRequested?: Maybe<BorrowerAccessRequested>;
  borrowerMeta?: Maybe<BorrowerMetadata>;
  borrowerPoolStats?: Maybe<Array<BorrowerPoolStats>>;
  bpool?: Maybe<BPool>;
  bpools: Array<BPool>;
  collateralTxs: Array<CollateralTx>;
  collateralTypeById?: Maybe<CollateralType>;
  collateralizedLoans: CollateralizedLoanConnection;
  commitmentById?: Maybe<Commitment>;
  commitments?: Maybe<Array<Commitment>>;
  delegateMeta?: Maybe<DelegateMetadata>;
  depositBySymbol?: Maybe<Deposit>;
  estimateWithdrawal: Scalars['Int']['output'];
  exitCycle?: Maybe<ExitCycle>;
  exitCycles: Array<ExitCycle>;
  feeManager?: Maybe<FeeManager>;
  feeManagers: Array<FeeManager>;
  flaggedAddresses?: Maybe<Array<AddressCompliance>>;
  functionLevelBitmap?: Maybe<FunctionLevelBitmap>;
  functionLevelBitmaps: Array<FunctionLevelBitmap>;
  getAllAutoRedeemerConfigs: Array<AutoRedeemerConfig>;
  getAllLiquidityManagerConfigs: Array<LiquidityManagerConfig>;
  getAutoRedeemerConfig?: Maybe<AutoRedeemerConfig>;
  getLiquidityManagerConfig?: Maybe<LiquidityManagerConfig>;
  getOrgPoolVerificationStatus?: Maybe<PoolVerificationStatus>;
  getPoolSignature: DepositSignature;
  getPoolVerificationStatus?: Maybe<PoolVerificationStatus>;
  getReferralToken: ReferralToken;
  getWalletReferralToken?: Maybe<ReferralToken>;
  getWalletsByReferralExternalTokenId: Array<ExternalWallet>;
  global?: Maybe<Global>;
  globalAllocations: Array<GlobalAllocation>;
  globalV2?: Maybe<GlobalV2>;
  globalV2S: Array<GlobalV2>;
  globals: Array<Global>;
  history?: Maybe<Array<ChangeHistory>>;
  interestStatement?: Maybe<InterestStatement>;
  isRestricted: Scalars['Boolean']['output'];
  lendingEpochConfiguration?: Maybe<LendingEpochConfiguration>;
  lendingEpochConfigurationRevisions?: Maybe<Array<LendingEpochConfiguration>>;
  lendingEpochs?: Maybe<Array<LendingEpoch>>;
  liquidationInfo?: Maybe<LiquidationInfo>;
  liquidationInfos: Array<LiquidationInfo>;
  listS3Objects?: Maybe<Array<S3Object>>;
  loan?: Maybe<Loan>;
  loanById?: Maybe<Loan>;
  loanHistories: Array<LoanHistory>;
  loanHistory?: Maybe<LoanHistory>;
  loanManager?: Maybe<LoanManager>;
  loanManagers: Array<LoanManager>;
  loanMap?: Maybe<LoanMap>;
  loanMaps: Array<LoanMap>;
  loanPosition?: Maybe<LoanPosition>;
  loanPositionMap?: Maybe<LoanPositionMap>;
  loanPositionMaps: Array<LoanPositionMap>;
  loanPositions: Array<LoanPosition>;
  loanRefinance?: Maybe<LoanRefinance>;
  loanRefinances: Array<LoanRefinance>;
  loans: Array<Loan>;
  maple?: Maybe<Maple>;
  mapleById?: Maybe<Maple>;
  maples: Array<Maple>;
  mplRewards: Array<MplRewards>;
  mpltx?: Maybe<MplTx>;
  mpltxes: Array<MplTx>;
  myPermissions?: Maybe<Array<ResourcePermission>>;
  nativeAsset?: Maybe<NativeAsset>;
  nativeAssets?: Maybe<Array<Maybe<NativeAsset>>>;
  nativeLoanById?: Maybe<NativeLoan>;
  nativeLoans?: Maybe<Array<NativeLoan>>;
  nativeLoansSnapshot?: Maybe<Array<NativeLoanSnapshot>>;
  nativePoolById?: Maybe<NativePool>;
  openTermLoan?: Maybe<OpenTermLoan>;
  openTermLoanById?: Maybe<OpenTermLoan>;
  openTermLoanHistories: Array<OpenTermLoanHistory>;
  openTermLoanHistory?: Maybe<OpenTermLoanHistory>;
  openTermLoanManager?: Maybe<OpenTermLoanManager>;
  openTermLoanManagers: Array<OpenTermLoanManager>;
  openTermLoanMap?: Maybe<OpenTermLoanMap>;
  openTermLoanMaps: Array<OpenTermLoanMap>;
  openTermLoanRefinance?: Maybe<OpenTermLoanRefinance>;
  openTermLoanRefinances: Array<OpenTermLoanRefinance>;
  openTermLoans: Array<OpenTermLoan>;
  orgById?: Maybe<Org>;
  otlrefinanceCalls: Array<OtlRefinanceCalls>;
  otlrepayment?: Maybe<OtlRepayment>;
  otlrepayments: Array<OtlRepayment>;
  paymentBreakdown?: Maybe<PaymentBreakdown>;
  paymentBreakdowns: Array<PaymentBreakdown>;
  pool?: Maybe<Pool>;
  poolAccessRequested?: Maybe<PoolAccessRequested>;
  poolById?: Maybe<PoolV2>;
  poolCategoryById?: Maybe<PoolCategory>;
  poolDelegateCover?: Maybe<PoolDelegateCover>;
  poolDelegateCovers: Array<PoolDelegateCover>;
  poolInjectionById?: Maybe<PoolInjection>;
  poolInjections: Array<PoolInjection>;
  poolInterestRequested?: Maybe<PoolInterestRequested>;
  poolManager?: Maybe<PoolManager>;
  poolManagers: Array<PoolManager>;
  poolMap?: Maybe<PoolMap>;
  poolMaps: Array<PoolMap>;
  poolMeta?: Maybe<PoolMetadata>;
  poolPermissionManager?: Maybe<PoolPermissionManager>;
  poolPermissionManagers: Array<PoolPermissionManager>;
  poolPosition?: Maybe<PoolPosition>;
  poolPositionMap?: Maybe<PoolPositionMap>;
  poolPositionMaps: Array<PoolPositionMap>;
  poolPositions: Array<PoolPosition>;
  poolV2?: Maybe<PoolV2>;
  poolV2Map?: Maybe<PoolV2Map>;
  poolV2Maps: Array<PoolV2Map>;
  poolV2Position?: Maybe<PoolV2Position>;
  poolV2PositionById?: Maybe<PoolV2Position>;
  poolV2PositionMap?: Maybe<PoolV2PositionMap>;
  poolV2PositionMaps: Array<PoolV2PositionMap>;
  poolV2Positions: Array<PoolV2Position>;
  poolV2S: Array<PoolV2>;
  poolV2Total?: Maybe<PoolV2Total>;
  poolV2Totals: Array<PoolV2Total>;
  pools: Array<Pool>;
  poolsMeta: Array<PoolMetadata>;
  priceFeedAssetMap?: Maybe<PriceFeedAssetMap>;
  priceFeedAssetMaps: Array<PriceFeedAssetMap>;
  priceOverride?: Maybe<PriceOverride>;
  recapitalizationWindow?: Maybe<RecapitalizationWindow>;
  recapitalizationWindows: Array<RecapitalizationWindow>;
  referralToken: ReferralToken;
  refinanceCalls: Array<RefinanceCalls>;
  repayment?: Maybe<Repayment>;
  repayments: Array<Repayment>;
  rewardMap?: Maybe<RewardMap>;
  rewardMaps: Array<RewardMap>;
  rolePermissions: Array<RolePermissions>;
  seasonScoresSnapshot: Array<SeasonScore>;
  seasons: Array<Season>;
  skyStrategies: Array<SkyStrategy>;
  skyStrategy?: Maybe<SkyStrategy>;
  solCompliance: AddressCompliance;
  solanaGlobals: SolanaGlobals;
  stSyrup?: Maybe<StSyrup>;
  stSyrupTx?: Maybe<StSyrupTx>;
  stSyrupTxes: Array<StSyrupTx>;
  stSyrups: Array<StSyrup>;
  stakeLockerPoolMap?: Maybe<StakeLockerPoolMap>;
  stakeLockerPoolMaps: Array<StakeLockerPoolMap>;
  /** @deprecated Unsupported */
  syrupApy: Scalars['String']['output'];
  syrupDrip?: Maybe<SyrupDrip>;
  syrupDripTx?: Maybe<SyrupDripTx>;
  syrupDripTxes: Array<SyrupDripTx>;
  syrupDrips: Array<SyrupDrip>;
  syrupGlobals: SyrupGlobals;
  syrupRouter?: Maybe<SyrupRouter>;
  syrupRouters: Array<SyrupRouter>;
  syrupToken?: Maybe<SyrupToken>;
  syrupTokens: Array<SyrupToken>;
  syrupTx?: Maybe<SyrupTx>;
  syrupTxes: Array<SyrupTx>;
  syrupUser: SyrupUser;
  total?: Maybe<Total>;
  totals: Array<Total>;
  transaction?: Maybe<Transaction>;
  transactions: Array<Transaction>;
  tx?: Maybe<Tx>;
  txes: Array<Tx>;
  userAllocations?: Maybe<Array<UserAllocation>>;
  userById?: Maybe<User>;
  usersAllocations: Array<UserAllocation>;
  withdrawalManager?: Maybe<WithdrawalManager>;
  withdrawalManagerQueue?: Maybe<WithdrawalManagerQueue>;
  withdrawalManagerQueues: Array<WithdrawalManagerQueue>;
  withdrawalManagers: Array<WithdrawalManager>;
  withdrawalRequest?: Maybe<WithdrawalRequest>;
  withdrawalRequestById?: Maybe<WithdrawalRequest>;
  withdrawalRequests: Array<WithdrawalRequest>;
  xMPL?: Maybe<XMpl>;
  xMPLMigrationTxesById?: Maybe<Array<XmplMigrationTx>>;
  xMPLTx?: Maybe<XMplTx>;
  xMPLTxes: Array<XMplTx>;
  xMPLs: Array<XMpl>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryAavestrategiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AaveStrategy_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<AaveStrategy_Filter>;
};


export type QueryAavestrategyArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryAccountArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryAccountByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountTotalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryAccountTotalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountTotal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<AccountTotal_Filter>;
};


export type QueryAccountsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Account_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Account_Filter>;
};


export type QueryAddressComplianceArgs = {
  address: Scalars['String']['input'];
};


export type QueryAggregatorAssetMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryAggregatorAssetMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AggregatorAssetMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<AggregatorAssetMap_Filter>;
};


export type QueryAllocationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryAllocationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Allocation_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Allocation_Filter>;
};


export type QueryApyDataArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryApyDatasArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ApyData_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ApyData_Filter>;
};


export type QueryAssetArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryAssetByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssetMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryAssetMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<AssetMap_Filter>;
};


export type QueryAssetsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Asset_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Asset_Filter>;
};


export type QueryAvailableInterestStatementsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBondPositionsByPoolIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBondsMaturityByPoolIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBorrowerAccessRequestedArgs = {
  account: Scalars['String']['input'];
  formId: Scalars['String']['input'];
};


export type QueryBorrowerMetaArgs = {
  ethereumAddress: Scalars['String']['input'];
};


export type QueryBorrowerPoolStatsArgs = {
  poolId: Scalars['String']['input'];
};


export type QueryBpoolArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryBpoolsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BPool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<BPool_Filter>;
};


export type QueryCollateralTxsArgs = {
  loanId: Scalars['String']['input'];
};


export type QueryCollateralTypeByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommitmentByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommitmentsArgs = {
  pool?: InputMaybe<Scalars['String']['input']>;
  wallet?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDelegateMetaArgs = {
  id: Scalars['String']['input'];
};


export type QueryDepositBySymbolArgs = {
  symbol: CollateralAsset;
};


export type QueryEstimateWithdrawalArgs = {
  id: Scalars['ID']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
  shares: Scalars['String']['input'];
};


export type QueryExitCycleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryExitCyclesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExitCycle_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ExitCycle_Filter>;
};


export type QueryFeeManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryFeeManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FeeManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<FeeManager_Filter>;
};


export type QueryFunctionLevelBitmapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryFunctionLevelBitmapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FunctionLevelBitmap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<FunctionLevelBitmap_Filter>;
};


export type QueryGetAutoRedeemerConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLiquidityManagerConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrgPoolVerificationStatusArgs = {
  orgId: Scalars['String']['input'];
  poolId: Scalars['String']['input'];
};


export type QueryGetPoolSignatureArgs = {
  lender: Scalars['String']['input'];
  poolId: Scalars['String']['input'];
};


export type QueryGetPoolVerificationStatusArgs = {
  poolId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetReferralTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetWalletReferralTokenArgs = {
  address: Scalars['String']['input'];
};


export type QueryGetWalletsByReferralExternalTokenIdArgs = {
  referralExternalTokenId: Scalars['String']['input'];
};


export type QueryGlobalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryGlobalAllocationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGlobalV2Args = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryGlobalV2SArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GlobalV2_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<GlobalV2_Filter>;
};


export type QueryGlobalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Global_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Global_Filter>;
};


export type QueryHistoryArgs = {
  collectionName: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
};


export type QueryInterestStatementArgs = {
  id: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryLendingEpochConfigurationArgs = {
  pool: Scalars['String']['input'];
};


export type QueryLendingEpochConfigurationRevisionsArgs = {
  pool: Scalars['String']['input'];
};


export type QueryLendingEpochsArgs = {
  pool: Scalars['String']['input'];
};


export type QueryLiquidationInfoArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLiquidationInfosArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LiquidationInfo_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LiquidationInfo_Filter>;
};


export type QueryListS3ObjectsArgs = {
  directory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLoanArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLoanByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLoanHistoriesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanHistory_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanHistory_Filter>;
};


export type QueryLoanHistoryArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLoanManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLoanManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanManager_Filter>;
};


export type QueryLoanMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLoanMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanMap_Filter>;
};


export type QueryLoanPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLoanPositionMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLoanPositionMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanPositionMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanPositionMap_Filter>;
};


export type QueryLoanPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanPosition_Filter>;
};


export type QueryLoanRefinanceArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLoanRefinancesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanRefinance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanRefinance_Filter>;
};


export type QueryLoansArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Loan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Loan_Filter>;
};


export type QueryMapleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMapleByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryMaplesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Maple_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Maple_Filter>;
};


export type QueryMplRewardsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MplRewards_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MplRewards_Filter>;
};


export type QueryMpltxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMpltxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MplTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MplTx_Filter>;
};


export type QueryNativeAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNativeLoanByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNativeLoansSnapshotArgs = {
  timestamp: Scalars['Float']['input'];
};


export type QueryNativePoolByIdArgs = {
  nativePoolId: Scalars['String']['input'];
};


export type QueryOpenTermLoanArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOpenTermLoanByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOpenTermLoanHistoriesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoanHistory_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OpenTermLoanHistory_Filter>;
};


export type QueryOpenTermLoanHistoryArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOpenTermLoanManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOpenTermLoanManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoanManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OpenTermLoanManager_Filter>;
};


export type QueryOpenTermLoanMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOpenTermLoanMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoanMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OpenTermLoanMap_Filter>;
};


export type QueryOpenTermLoanRefinanceArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOpenTermLoanRefinancesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoanRefinance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OpenTermLoanRefinance_Filter>;
};


export type QueryOpenTermLoansArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OpenTermLoan_Filter>;
};


export type QueryOrgByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOtlrefinanceCallsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OtlRefinanceCalls_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OtlRefinanceCalls_Filter>;
};


export type QueryOtlrepaymentArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryOtlrepaymentsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OtlRepayment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OtlRepayment_Filter>;
};


export type QueryPaymentBreakdownArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPaymentBreakdownsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PaymentBreakdown_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PaymentBreakdown_Filter>;
};


export type QueryPoolArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolAccessRequestedArgs = {
  account: Scalars['String']['input'];
  formId: Scalars['String']['input'];
  poolAddress: Scalars['String']['input'];
};


export type QueryPoolByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPoolCategoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPoolDelegateCoverArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolDelegateCoversArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolDelegateCover_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolDelegateCover_Filter>;
};


export type QueryPoolInjectionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPoolInterestRequestedArgs = {
  email: Scalars['String']['input'];
  formId: Scalars['String']['input'];
  poolId: Scalars['String']['input'];
};


export type QueryPoolManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolManager_Filter>;
};


export type QueryPoolMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolMap_Filter>;
};


export type QueryPoolMetaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPoolPermissionManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolPermissionManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolPermissionManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolPermissionManager_Filter>;
};


export type QueryPoolPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolPositionMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolPositionMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolPositionMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolPositionMap_Filter>;
};


export type QueryPoolPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolPosition_Filter>;
};


export type QueryPoolV2Args = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolV2MapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolV2MapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2Map_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolV2Map_Filter>;
};


export type QueryPoolV2PositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolV2PositionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPoolV2PositionMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolV2PositionMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2PositionMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolV2PositionMap_Filter>;
};


export type QueryPoolV2PositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2Position_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolV2Position_Filter>;
};


export type QueryPoolV2SArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolV2_Filter>;
};


export type QueryPoolV2TotalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolV2TotalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2Total_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolV2Total_Filter>;
};


export type QueryPoolsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Pool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Pool_Filter>;
};


export type QueryPriceFeedAssetMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPriceFeedAssetMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PriceFeedAssetMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PriceFeedAssetMap_Filter>;
};


export type QueryPriceOverrideArgs = {
  symbol: Scalars['String']['input'];
};


export type QueryRecapitalizationWindowArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRecapitalizationWindowsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RecapitalizationWindow_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RecapitalizationWindow_Filter>;
};


export type QueryReferralTokenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRefinanceCallsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RefinanceCalls_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RefinanceCalls_Filter>;
};


export type QueryRepaymentArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRepaymentsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Repayment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Repayment_Filter>;
};


export type QueryRewardMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryRewardMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RewardMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RewardMap_Filter>;
};


export type QueryRolePermissionsArgs = {
  roles: Array<Role>;
};


export type QuerySeasonScoresSnapshotArgs = {
  lender: Scalars['String']['input'];
};


export type QuerySeasonsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySkyStrategiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SkyStrategy_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SkyStrategy_Filter>;
};


export type QuerySkyStrategyArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySolComplianceArgs = {
  address: Scalars['String']['input'];
};


export type QueryStSyrupArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryStSyrupTxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryStSyrupTxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StSyrupTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<StSyrupTx_Filter>;
};


export type QueryStSyrupsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StSyrup_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<StSyrup_Filter>;
};


export type QueryStakeLockerPoolMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryStakeLockerPoolMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StakeLockerPoolMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<StakeLockerPoolMap_Filter>;
};


export type QuerySyrupDripArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySyrupDripTxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySyrupDripTxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SyrupDripTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SyrupDripTx_Filter>;
};


export type QuerySyrupDripsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SyrupDrip_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SyrupDrip_Filter>;
};


export type QuerySyrupRouterArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySyrupRoutersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SyrupRouter_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SyrupRouter_Filter>;
};


export type QuerySyrupTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySyrupTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SyrupToken_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SyrupToken_Filter>;
};


export type QuerySyrupTxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySyrupTxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SyrupTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SyrupTx_Filter>;
};


export type QuerySyrupUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTotalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTotalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Total_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Total_Filter>;
};


export type QueryTransactionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTransactionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Transaction_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Transaction_Filter>;
};


export type QueryTxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Tx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Tx_Filter>;
};


export type QueryUserAllocationsArgs = {
  address: Scalars['String']['input'];
};


export type QueryUserByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersAllocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWithdrawalManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryWithdrawalManagerQueueArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryWithdrawalManagerQueuesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WithdrawalManagerQueue_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<WithdrawalManagerQueue_Filter>;
};


export type QueryWithdrawalManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WithdrawalManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<WithdrawalManager_Filter>;
};


export type QueryWithdrawalRequestArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryWithdrawalRequestByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWithdrawalRequestsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WithdrawalRequest_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<WithdrawalRequest_Filter>;
};


export type QueryXMplArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryXMplMigrationTxesByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryXMplTxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryXMplTxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<XMplTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<XMplTx_Filter>;
};


export type QueryXMpLsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<XMpl_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<XMpl_Filter>;
};

export type RecapitalizationWindow = {
  __typename?: 'RecapitalizationWindow';
  id: Scalars['ID']['output'];
  issuanceRate: Scalars['BigInt']['output'];
  windowStart: Scalars['BigInt']['output'];
};

export type RecapitalizationWindow_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  issuanceRate?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  issuanceRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  windowStart?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_gt?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_gte?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  windowStart_lt?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_lte?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_not?: InputMaybe<Scalars['BigInt']['input']>;
  windowStart_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum RecapitalizationWindow_OrderBy {
  Id = 'id',
  IssuanceRate = 'issuanceRate',
  WindowStart = 'windowStart'
}

export type ReferralToken = {
  __typename?: 'ReferralToken';
  alias: Scalars['String']['output'];
  boost: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  referrerAddress?: Maybe<Scalars['String']['output']>;
  referrerRate: Scalars['Float']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ReferralTokenInput = {
  alias: Scalars['String']['input'];
  boost: Scalars['Float']['input'];
  isActive: Scalars['Boolean']['input'];
  referrerAddress?: InputMaybe<Scalars['String']['input']>;
  referrerRate: Scalars['Float']['input'];
};

export type ReferralTokenUpdate = {
  alias?: InputMaybe<Scalars['String']['input']>;
  boost?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  referrerAddress?: InputMaybe<Scalars['String']['input']>;
  referrerRate?: InputMaybe<Scalars['Float']['input']>;
};

export type RefinanceCalls = {
  __typename?: 'RefinanceCalls';
  id: Scalars['ID']['output'];
  increasePrincipal?: Maybe<Scalars['String']['output']>;
  setClosingRate?: Maybe<Scalars['String']['output']>;
  setCollateralRequired?: Maybe<Scalars['String']['output']>;
  setEarlyFeeRate?: Maybe<Scalars['String']['output']>;
  setEndingPrincipal?: Maybe<Scalars['String']['output']>;
  setGracePeriod?: Maybe<Scalars['String']['output']>;
  setInterestRate?: Maybe<Scalars['String']['output']>;
  setLateFeeRate?: Maybe<Scalars['String']['output']>;
  setLateInterestPremium?: Maybe<Scalars['String']['output']>;
  setPaymentInterval?: Maybe<Scalars['String']['output']>;
  setPaymentsRemaining?: Maybe<Scalars['String']['output']>;
  updateDelegateFeeTerms?: Maybe<Scalars['String']['output']>;
};

export type RefinanceCalls_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  increasePrincipal?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_contains?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_ends_with?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_gt?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_gte?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  increasePrincipal_lt?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_lte?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_contains?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  increasePrincipal_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_starts_with?: InputMaybe<Scalars['String']['input']>;
  increasePrincipal_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setClosingRate?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_contains?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_ends_with?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_gt?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_gte?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setClosingRate_lt?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_lte?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_not?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_not_contains?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setClosingRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_starts_with?: InputMaybe<Scalars['String']['input']>;
  setClosingRate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_contains?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_ends_with?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_gt?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_gte?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setCollateralRequired_lt?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_lte?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_not?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_not_contains?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setCollateralRequired_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_starts_with?: InputMaybe<Scalars['String']['input']>;
  setCollateralRequired_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_contains?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_ends_with?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_gt?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_gte?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setEarlyFeeRate_lt?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_lte?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_not?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_not_contains?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setEarlyFeeRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_starts_with?: InputMaybe<Scalars['String']['input']>;
  setEarlyFeeRate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_contains?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_ends_with?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_gt?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_gte?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setEndingPrincipal_lt?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_lte?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_not?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_not_contains?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setEndingPrincipal_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_starts_with?: InputMaybe<Scalars['String']['input']>;
  setEndingPrincipal_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_contains?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_ends_with?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_gt?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_gte?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setGracePeriod_lt?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_lte?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_contains?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setGracePeriod_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_starts_with?: InputMaybe<Scalars['String']['input']>;
  setGracePeriod_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_contains?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_ends_with?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_gt?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_gte?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setInterestRate_lt?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_lte?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_contains?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setInterestRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_starts_with?: InputMaybe<Scalars['String']['input']>;
  setInterestRate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_contains?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_ends_with?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_gt?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_gte?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setLateFeeRate_lt?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_lte?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_contains?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setLateFeeRate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_starts_with?: InputMaybe<Scalars['String']['input']>;
  setLateFeeRate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_contains?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_ends_with?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_gt?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_gte?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setLateInterestPremium_lt?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_lte?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_not?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_not_contains?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setLateInterestPremium_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_starts_with?: InputMaybe<Scalars['String']['input']>;
  setLateInterestPremium_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_contains?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_ends_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_gt?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_gte?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setPaymentInterval_lt?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_lte?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_contains?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setPaymentInterval_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_starts_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentInterval_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_contains?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_ends_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_gt?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_gte?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setPaymentsRemaining_lt?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_lte?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_not?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_not_contains?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  setPaymentsRemaining_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_starts_with?: InputMaybe<Scalars['String']['input']>;
  setPaymentsRemaining_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_contains?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_ends_with?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_gt?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_gte?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_in?: InputMaybe<Array<Scalars['String']['input']>>;
  updateDelegateFeeTerms_lt?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_lte?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_not?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_not_contains?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  updateDelegateFeeTerms_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_starts_with?: InputMaybe<Scalars['String']['input']>;
  updateDelegateFeeTerms_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum RefinanceCalls_OrderBy {
  Id = 'id',
  IncreasePrincipal = 'increasePrincipal',
  SetClosingRate = 'setClosingRate',
  SetCollateralRequired = 'setCollateralRequired',
  SetEarlyFeeRate = 'setEarlyFeeRate',
  SetEndingPrincipal = 'setEndingPrincipal',
  SetGracePeriod = 'setGracePeriod',
  SetInterestRate = 'setInterestRate',
  SetLateFeeRate = 'setLateFeeRate',
  SetLateInterestPremium = 'setLateInterestPremium',
  SetPaymentInterval = 'setPaymentInterval',
  SetPaymentsRemaining = 'setPaymentsRemaining',
  UpdateDelegateFeeTerms = 'updateDelegateFeeTerms'
}

export enum RefinanceStatus {
  Accepted = 'accepted',
  Proposed = 'proposed',
  Rejected = 'rejected'
}

export type RemoveMemberFromEntityInput = {
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type Repayment = {
  __typename?: 'Repayment';
  account: Account;
  delegateManagementFee?: Maybe<Scalars['BigInt']['output']>;
  delegateServiceFee?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
  interest?: Maybe<Scalars['BigInt']['output']>;
  late?: Maybe<Scalars['Boolean']['output']>;
  loan: Loan;
  netInterest?: Maybe<Scalars['BigInt']['output']>;
  platformManagementFee?: Maybe<Scalars['BigInt']['output']>;
  platformServiceFee?: Maybe<Scalars['BigInt']['output']>;
  principal?: Maybe<Scalars['BigInt']['output']>;
  total?: Maybe<Scalars['BigInt']['output']>;
  transaction: Transaction;
};

export type Repayment_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  delegateManagementFee?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateManagementFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateManagementFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFee?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  delegateServiceFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  delegateServiceFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interest?: InputMaybe<Scalars['BigInt']['input']>;
  interest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interest_not?: InputMaybe<Scalars['BigInt']['input']>;
  interest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  late?: InputMaybe<Scalars['Boolean']['input']>;
  late_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  late_not?: InputMaybe<Scalars['Boolean']['input']>;
  late_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  netInterest?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_gt?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_gte?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  netInterest_lt?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_lte?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_not?: InputMaybe<Scalars['BigInt']['input']>;
  netInterest_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformManagementFee?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformManagementFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformManagementFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFee?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_gt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_gte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  platformServiceFee_lt?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_lte?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_not?: InputMaybe<Scalars['BigInt']['input']>;
  platformServiceFee_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principal?: InputMaybe<Scalars['BigInt']['input']>;
  principal_gt?: InputMaybe<Scalars['BigInt']['input']>;
  principal_gte?: InputMaybe<Scalars['BigInt']['input']>;
  principal_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  principal_lt?: InputMaybe<Scalars['BigInt']['input']>;
  principal_lte?: InputMaybe<Scalars['BigInt']['input']>;
  principal_not?: InputMaybe<Scalars['BigInt']['input']>;
  principal_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  total?: InputMaybe<Scalars['BigInt']['input']>;
  total_gt?: InputMaybe<Scalars['BigInt']['input']>;
  total_gte?: InputMaybe<Scalars['BigInt']['input']>;
  total_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  total_lt?: InputMaybe<Scalars['BigInt']['input']>;
  total_lte?: InputMaybe<Scalars['BigInt']['input']>;
  total_not?: InputMaybe<Scalars['BigInt']['input']>;
  total_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Repayment_OrderBy {
  Account = 'account',
  DelegateManagementFee = 'delegateManagementFee',
  DelegateServiceFee = 'delegateServiceFee',
  Id = 'id',
  Interest = 'interest',
  Late = 'late',
  Loan = 'loan',
  NetInterest = 'netInterest',
  PlatformManagementFee = 'platformManagementFee',
  PlatformServiceFee = 'platformServiceFee',
  Principal = 'principal',
  Total = 'total',
  Transaction = 'transaction'
}

export type ResourcePermission = {
  __typename?: 'ResourcePermission';
  permission: Permission;
  resourceId?: Maybe<Scalars['ID']['output']>;
};

export type ResourceRole = {
  __typename?: 'ResourceRole';
  resourceId?: Maybe<Scalars['ID']['output']>;
  role: Role;
};

export type RewardMap = {
  __typename?: 'RewardMap';
  id: Scalars['ID']['output'];
  voided: Scalars['Boolean']['output'];
};

export type RewardMap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  voided?: InputMaybe<Scalars['Boolean']['input']>;
  voided_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  voided_not?: InputMaybe<Scalars['Boolean']['input']>;
  voided_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export enum RewardMap_OrderBy {
  Id = 'id',
  Voided = 'voided'
}

export type RiskIndicators = {
  __typename?: 'RiskIndicators';
  category: Scalars['String']['output'];
  payload: Scalars['String']['output'];
  severity: RiskThresholds;
};

export enum RiskThresholds {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Severe = 'SEVERE'
}

export enum Role {
  Admin = 'ADMIN',
  Delegate = 'DELEGATE',
  OrgAdmin = 'ORG_ADMIN',
  OrgMember = 'ORG_MEMBER',
  OrgOwner = 'ORG_OWNER',
  AppMetadataManager = 'app_metadata_manager',
  AssetManager = 'asset_manager',
  AuditHistoryViewer = 'audit_history_viewer',
  BondsManager = 'bonds_manager',
  BorrowersManager = 'borrowers_manager',
  BotsManager = 'bots_manager',
  CollateralsManager = 'collaterals_manager',
  DelegatesManager = 'delegates_manager',
  DepositsManager = 'deposits_manager',
  EntitiesManager = 'entities_manager',
  GlobalViewer = 'global_viewer',
  LoansManager = 'loans_manager',
  NativeLoansManager = 'native_loans_manager',
  PoolsMetadataManager = 'pools_metadata_manager',
  SyrupManager = 'syrup_manager',
  SyrupReferralTokensManager = 'syrup_referral_tokens_manager',
  UsersManager = 'users_manager',
  WalletsManager = 'wallets_manager'
}

export type RoleInput = {
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  role: Role;
};

export type RolePermissions = {
  __typename?: 'RolePermissions';
  permissions?: Maybe<Array<Permission>>;
  role: Role;
};

export type S3Object = {
  __typename?: 'S3Object';
  key: Scalars['String']['output'];
  lastModified: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type Season = {
  __typename?: 'Season';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  dripsConversionRate?: Maybe<Scalars['Int']['output']>;
  end: Scalars['String']['output'];
  endBlock?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  start: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type SeasonDrips = {
  __typename?: 'SeasonDrips';
  drips: Scalars['Float']['output'];
  seasonId: Scalars['String']['output'];
};

export type SeasonScore = {
  __typename?: 'SeasonScore';
  boosts?: Maybe<Array<SyrupBoost>>;
  currentDripsPerDay: Scalars['Float']['output'];
  season: Season;
  seasonDrips: Scalars['Float']['output'];
  syrupEarned: Scalars['Float']['output'];
  syrupEarnedUsd: Scalars['Float']['output'];
  totalRewardsYield: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  wallet: Scalars['String']['output'];
};

export type SkyStrategy = {
  __typename?: 'SkyStrategy';
  currentlyDeployed: Scalars['BigInt']['output'];
  depositedAssets: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  pool: PoolV2;
  state: StrategyState;
  strategyFeeRate: Scalars['BigInt']['output'];
  totalFeesCollected: Scalars['BigInt']['output'];
  transaction?: Maybe<Transaction>;
  version: Scalars['Int']['output'];
  withdrawnAssets: Scalars['BigInt']['output'];
};

export type SkyStrategy_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  currentlyDeployed?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  currentlyDeployed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_not?: InputMaybe<Scalars['BigInt']['input']>;
  currentlyDeployed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositedAssets?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositedAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  depositedAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<StrategyState>;
  state_in?: InputMaybe<Array<StrategyState>>;
  state_not?: InputMaybe<StrategyState>;
  state_not_in?: InputMaybe<Array<StrategyState>>;
  strategyFeeRate?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strategyFeeRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  strategyFeeRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalFeesCollected?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalFeesCollected_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalFeesCollected_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  withdrawnAssets?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawnAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  withdrawnAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum SkyStrategy_OrderBy {
  CurrentlyDeployed = 'currentlyDeployed',
  DepositedAssets = 'depositedAssets',
  Id = 'id',
  Pool = 'pool',
  State = 'state',
  StrategyFeeRate = 'strategyFeeRate',
  TotalFeesCollected = 'totalFeesCollected',
  Transaction = 'transaction',
  Version = 'version',
  WithdrawnAssets = 'withdrawnAssets'
}

export type SolanaGlobals = {
  __typename?: 'SolanaGlobals';
  totalInterestEarned: Scalars['String']['output'];
  totalLiquidityProvided: Scalars['String']['output'];
  totalLoanOriginations: Scalars['String']['output'];
};

export enum SortOptions {
  Asc = 'asc',
  Desc = 'desc'
}

export enum Source {
  App = 'app',
  Dashboard = 'dashboard',
  Hubspot = 'hubspot'
}

export enum StablecoinAsset {
  Usdc = 'USDC',
  Usdt = 'USDT'
}

export type StakeLockerPoolMap = {
  __typename?: 'StakeLockerPoolMap';
  id: Scalars['ID']['output'];
  pool: Pool;
};

export type StakeLockerPoolMap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<Pool_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum StakeLockerPoolMap_OrderBy {
  Id = 'id',
  Pool = 'pool'
}

export enum StrategyState {
  Active = 'Active',
  Impaired = 'Impaired',
  Inactive = 'Inactive'
}

export enum SubmissionStatus {
  Failed = 'FAILED',
  Incomplete = 'INCOMPLETE',
  NotSubmitted = 'NOT_SUBMITTED',
  Passed = 'PASSED',
  Submitted = 'SUBMITTED'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  aavestrategies: Array<AaveStrategy>;
  aavestrategy?: Maybe<AaveStrategy>;
  account?: Maybe<Account>;
  accountTotal?: Maybe<AccountTotal>;
  accountTotals: Array<AccountTotal>;
  accounts: Array<Account>;
  aggregatorAssetMap?: Maybe<AggregatorAssetMap>;
  aggregatorAssetMaps: Array<AggregatorAssetMap>;
  allocation?: Maybe<Allocation>;
  allocations: Array<Allocation>;
  apyData?: Maybe<ApyData>;
  apyDatas: Array<ApyData>;
  asset?: Maybe<Asset>;
  assetMap?: Maybe<AssetMap>;
  assetMaps: Array<AssetMap>;
  assets: Array<Asset>;
  bpool?: Maybe<BPool>;
  bpools: Array<BPool>;
  exitCycle?: Maybe<ExitCycle>;
  exitCycles: Array<ExitCycle>;
  feeManager?: Maybe<FeeManager>;
  feeManagers: Array<FeeManager>;
  functionLevelBitmap?: Maybe<FunctionLevelBitmap>;
  functionLevelBitmaps: Array<FunctionLevelBitmap>;
  global?: Maybe<Global>;
  globalV2?: Maybe<GlobalV2>;
  globalV2S: Array<GlobalV2>;
  globals: Array<Global>;
  liquidationInfo?: Maybe<LiquidationInfo>;
  liquidationInfos: Array<LiquidationInfo>;
  loan?: Maybe<Loan>;
  loanHistories: Array<LoanHistory>;
  loanHistory?: Maybe<LoanHistory>;
  loanManager?: Maybe<LoanManager>;
  loanManagers: Array<LoanManager>;
  loanMap?: Maybe<LoanMap>;
  loanMaps: Array<LoanMap>;
  loanPosition?: Maybe<LoanPosition>;
  loanPositionMap?: Maybe<LoanPositionMap>;
  loanPositionMaps: Array<LoanPositionMap>;
  loanPositions: Array<LoanPosition>;
  loanRefinance?: Maybe<LoanRefinance>;
  loanRefinances: Array<LoanRefinance>;
  loans: Array<Loan>;
  maple?: Maybe<Maple>;
  maples: Array<Maple>;
  mplRewards: Array<MplRewards>;
  mpltx?: Maybe<MplTx>;
  mpltxes: Array<MplTx>;
  openTermLoan?: Maybe<OpenTermLoan>;
  openTermLoanHistories: Array<OpenTermLoanHistory>;
  openTermLoanHistory?: Maybe<OpenTermLoanHistory>;
  openTermLoanManager?: Maybe<OpenTermLoanManager>;
  openTermLoanManagers: Array<OpenTermLoanManager>;
  openTermLoanMap?: Maybe<OpenTermLoanMap>;
  openTermLoanMaps: Array<OpenTermLoanMap>;
  openTermLoanRefinance?: Maybe<OpenTermLoanRefinance>;
  openTermLoanRefinances: Array<OpenTermLoanRefinance>;
  openTermLoans: Array<OpenTermLoan>;
  otlrefinanceCalls: Array<OtlRefinanceCalls>;
  otlrepayment?: Maybe<OtlRepayment>;
  otlrepayments: Array<OtlRepayment>;
  paymentBreakdown?: Maybe<PaymentBreakdown>;
  paymentBreakdowns: Array<PaymentBreakdown>;
  pool?: Maybe<Pool>;
  poolDelegateCover?: Maybe<PoolDelegateCover>;
  poolDelegateCovers: Array<PoolDelegateCover>;
  poolManager?: Maybe<PoolManager>;
  poolManagers: Array<PoolManager>;
  poolMap?: Maybe<PoolMap>;
  poolMaps: Array<PoolMap>;
  poolPermissionManager?: Maybe<PoolPermissionManager>;
  poolPermissionManagers: Array<PoolPermissionManager>;
  poolPosition?: Maybe<PoolPosition>;
  poolPositionMap?: Maybe<PoolPositionMap>;
  poolPositionMaps: Array<PoolPositionMap>;
  poolPositions: Array<PoolPosition>;
  poolV2?: Maybe<PoolV2>;
  poolV2Map?: Maybe<PoolV2Map>;
  poolV2Maps: Array<PoolV2Map>;
  poolV2Position?: Maybe<PoolV2Position>;
  poolV2PositionMap?: Maybe<PoolV2PositionMap>;
  poolV2PositionMaps: Array<PoolV2PositionMap>;
  poolV2Positions: Array<PoolV2Position>;
  poolV2S: Array<PoolV2>;
  poolV2Total?: Maybe<PoolV2Total>;
  poolV2Totals: Array<PoolV2Total>;
  pools: Array<Pool>;
  priceFeedAssetMap?: Maybe<PriceFeedAssetMap>;
  priceFeedAssetMaps: Array<PriceFeedAssetMap>;
  recapitalizationWindow?: Maybe<RecapitalizationWindow>;
  recapitalizationWindows: Array<RecapitalizationWindow>;
  refinanceCalls: Array<RefinanceCalls>;
  repayment?: Maybe<Repayment>;
  repayments: Array<Repayment>;
  rewardMap?: Maybe<RewardMap>;
  rewardMaps: Array<RewardMap>;
  skyStrategies: Array<SkyStrategy>;
  skyStrategy?: Maybe<SkyStrategy>;
  stSyrup?: Maybe<StSyrup>;
  stSyrupTx?: Maybe<StSyrupTx>;
  stSyrupTxes: Array<StSyrupTx>;
  stSyrups: Array<StSyrup>;
  stakeLockerPoolMap?: Maybe<StakeLockerPoolMap>;
  stakeLockerPoolMaps: Array<StakeLockerPoolMap>;
  syrupDrip?: Maybe<SyrupDrip>;
  syrupDripTx?: Maybe<SyrupDripTx>;
  syrupDripTxes: Array<SyrupDripTx>;
  syrupDrips: Array<SyrupDrip>;
  syrupRouter?: Maybe<SyrupRouter>;
  syrupRouters: Array<SyrupRouter>;
  syrupToken?: Maybe<SyrupToken>;
  syrupTokens: Array<SyrupToken>;
  syrupTx?: Maybe<SyrupTx>;
  syrupTxes: Array<SyrupTx>;
  total?: Maybe<Total>;
  totals: Array<Total>;
  transaction?: Maybe<Transaction>;
  transactions: Array<Transaction>;
  tx?: Maybe<Tx>;
  txes: Array<Tx>;
  withdrawalManager?: Maybe<WithdrawalManager>;
  withdrawalManagerQueue?: Maybe<WithdrawalManagerQueue>;
  withdrawalManagerQueues: Array<WithdrawalManagerQueue>;
  withdrawalManagers: Array<WithdrawalManager>;
  withdrawalRequest?: Maybe<WithdrawalRequest>;
  withdrawalRequests: Array<WithdrawalRequest>;
  xMPL?: Maybe<XMpl>;
  xMPLTx?: Maybe<XMplTx>;
  xMPLTxes: Array<XMplTx>;
  xMPLs: Array<XMpl>;
};


export type Subscription_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type SubscriptionAavestrategiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AaveStrategy_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<AaveStrategy_Filter>;
};


export type SubscriptionAavestrategyArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionAccountArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionAccountTotalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionAccountTotalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountTotal_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<AccountTotal_Filter>;
};


export type SubscriptionAccountsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Account_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Account_Filter>;
};


export type SubscriptionAggregatorAssetMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionAggregatorAssetMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AggregatorAssetMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<AggregatorAssetMap_Filter>;
};


export type SubscriptionAllocationArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionAllocationsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Allocation_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Allocation_Filter>;
};


export type SubscriptionApyDataArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionApyDatasArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ApyData_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ApyData_Filter>;
};


export type SubscriptionAssetArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionAssetMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionAssetMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<AssetMap_Filter>;
};


export type SubscriptionAssetsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Asset_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Asset_Filter>;
};


export type SubscriptionBpoolArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionBpoolsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BPool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<BPool_Filter>;
};


export type SubscriptionExitCycleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionExitCyclesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExitCycle_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ExitCycle_Filter>;
};


export type SubscriptionFeeManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionFeeManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FeeManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<FeeManager_Filter>;
};


export type SubscriptionFunctionLevelBitmapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionFunctionLevelBitmapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FunctionLevelBitmap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<FunctionLevelBitmap_Filter>;
};


export type SubscriptionGlobalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionGlobalV2Args = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionGlobalV2SArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GlobalV2_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<GlobalV2_Filter>;
};


export type SubscriptionGlobalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Global_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Global_Filter>;
};


export type SubscriptionLiquidationInfoArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLiquidationInfosArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LiquidationInfo_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LiquidationInfo_Filter>;
};


export type SubscriptionLoanArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLoanHistoriesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanHistory_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanHistory_Filter>;
};


export type SubscriptionLoanHistoryArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLoanManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLoanManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanManager_Filter>;
};


export type SubscriptionLoanMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLoanMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanMap_Filter>;
};


export type SubscriptionLoanPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLoanPositionMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLoanPositionMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanPositionMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanPositionMap_Filter>;
};


export type SubscriptionLoanPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanPosition_Filter>;
};


export type SubscriptionLoanRefinanceArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLoanRefinancesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanRefinance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LoanRefinance_Filter>;
};


export type SubscriptionLoansArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Loan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Loan_Filter>;
};


export type SubscriptionMapleArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionMaplesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Maple_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Maple_Filter>;
};


export type SubscriptionMplRewardsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MplRewards_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MplRewards_Filter>;
};


export type SubscriptionMpltxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionMpltxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MplTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MplTx_Filter>;
};


export type SubscriptionOpenTermLoanArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOpenTermLoanHistoriesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoanHistory_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OpenTermLoanHistory_Filter>;
};


export type SubscriptionOpenTermLoanHistoryArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOpenTermLoanManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOpenTermLoanManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoanManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OpenTermLoanManager_Filter>;
};


export type SubscriptionOpenTermLoanMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOpenTermLoanMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoanMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OpenTermLoanMap_Filter>;
};


export type SubscriptionOpenTermLoanRefinanceArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOpenTermLoanRefinancesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoanRefinance_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OpenTermLoanRefinance_Filter>;
};


export type SubscriptionOpenTermLoansArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenTermLoan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OpenTermLoan_Filter>;
};


export type SubscriptionOtlrefinanceCallsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OtlRefinanceCalls_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OtlRefinanceCalls_Filter>;
};


export type SubscriptionOtlrepaymentArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionOtlrepaymentsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OtlRepayment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<OtlRepayment_Filter>;
};


export type SubscriptionPaymentBreakdownArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPaymentBreakdownsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PaymentBreakdown_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PaymentBreakdown_Filter>;
};


export type SubscriptionPoolArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolDelegateCoverArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolDelegateCoversArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolDelegateCover_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolDelegateCover_Filter>;
};


export type SubscriptionPoolManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolManager_Filter>;
};


export type SubscriptionPoolMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolMap_Filter>;
};


export type SubscriptionPoolPermissionManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolPermissionManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolPermissionManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolPermissionManager_Filter>;
};


export type SubscriptionPoolPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolPositionMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolPositionMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolPositionMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolPositionMap_Filter>;
};


export type SubscriptionPoolPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolPosition_Filter>;
};


export type SubscriptionPoolV2Args = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolV2MapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolV2MapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2Map_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolV2Map_Filter>;
};


export type SubscriptionPoolV2PositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolV2PositionMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolV2PositionMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2PositionMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolV2PositionMap_Filter>;
};


export type SubscriptionPoolV2PositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2Position_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolV2Position_Filter>;
};


export type SubscriptionPoolV2SArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolV2_Filter>;
};


export type SubscriptionPoolV2TotalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPoolV2TotalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolV2Total_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolV2Total_Filter>;
};


export type SubscriptionPoolsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Pool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Pool_Filter>;
};


export type SubscriptionPriceFeedAssetMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionPriceFeedAssetMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PriceFeedAssetMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PriceFeedAssetMap_Filter>;
};


export type SubscriptionRecapitalizationWindowArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionRecapitalizationWindowsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RecapitalizationWindow_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RecapitalizationWindow_Filter>;
};


export type SubscriptionRefinanceCallsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RefinanceCalls_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RefinanceCalls_Filter>;
};


export type SubscriptionRepaymentArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionRepaymentsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Repayment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Repayment_Filter>;
};


export type SubscriptionRewardMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionRewardMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RewardMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<RewardMap_Filter>;
};


export type SubscriptionSkyStrategiesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SkyStrategy_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SkyStrategy_Filter>;
};


export type SubscriptionSkyStrategyArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionStSyrupArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionStSyrupTxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionStSyrupTxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StSyrupTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<StSyrupTx_Filter>;
};


export type SubscriptionStSyrupsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StSyrup_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<StSyrup_Filter>;
};


export type SubscriptionStakeLockerPoolMapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionStakeLockerPoolMapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StakeLockerPoolMap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<StakeLockerPoolMap_Filter>;
};


export type SubscriptionSyrupDripArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionSyrupDripTxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionSyrupDripTxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SyrupDripTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SyrupDripTx_Filter>;
};


export type SubscriptionSyrupDripsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SyrupDrip_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SyrupDrip_Filter>;
};


export type SubscriptionSyrupRouterArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionSyrupRoutersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SyrupRouter_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SyrupRouter_Filter>;
};


export type SubscriptionSyrupTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionSyrupTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SyrupToken_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SyrupToken_Filter>;
};


export type SubscriptionSyrupTxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionSyrupTxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SyrupTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SyrupTx_Filter>;
};


export type SubscriptionTotalArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTotalsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Total_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Total_Filter>;
};


export type SubscriptionTransactionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTransactionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Transaction_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Transaction_Filter>;
};


export type SubscriptionTxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionTxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Tx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Tx_Filter>;
};


export type SubscriptionWithdrawalManagerArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionWithdrawalManagerQueueArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionWithdrawalManagerQueuesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WithdrawalManagerQueue_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<WithdrawalManagerQueue_Filter>;
};


export type SubscriptionWithdrawalManagersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WithdrawalManager_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<WithdrawalManager_Filter>;
};


export type SubscriptionWithdrawalRequestArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionWithdrawalRequestsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WithdrawalRequest_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<WithdrawalRequest_Filter>;
};


export type SubscriptionXMplArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionXMplTxArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID']['input'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionXMplTxesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<XMplTx_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<XMplTx_Filter>;
};


export type SubscriptionXMpLsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<XMpl_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<XMpl_Filter>;
};

export type SyrupBoost = {
  __typename?: 'SyrupBoost';
  dripsEarned: Scalars['Float']['output'];
  dripsPerDay: Scalars['Float']['output'];
  type: SyrupBoostType;
};

export enum SyrupBoostType {
  CampaignJanW3 = 'CAMPAIGN_JAN_W3',
  EthCc = 'ETH_CC',
  IntegrationBinance = 'INTEGRATION_BINANCE',
  IntegrationExodus = 'INTEGRATION_EXODUS',
  IntegrationOkx = 'INTEGRATION_OKX',
  Morpho = 'MORPHO',
  Pendle = 'PENDLE',
  SeedAllocator = 'SEED_ALLOCATOR',
  SeedAllocatorUsdt = 'SEED_ALLOCATOR_USDT',
  UsdtBeta = 'USDT_BETA',
  WalletReferral = 'WALLET_REFERRAL'
}

export type SyrupDrip = {
  __typename?: 'SyrupDrip';
  allocation: Allocation;
  id: Scalars['ID']['output'];
  txCount: Scalars['Int']['output'];
};

export type SyrupDripTx = {
  __typename?: 'SyrupDripTx';
  account: Account;
  amount: Scalars['BigInt']['output'];
  claimId: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  timestamp: Scalars['BigInt']['output'];
  transaction: Transaction;
  type: SyrupDripTxType;
};

export type SyrupDripTx_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimId?: InputMaybe<Scalars['BigInt']['input']>;
  claimId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  claimId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  claimId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  claimId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  claimId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  claimId_not?: InputMaybe<Scalars['BigInt']['input']>;
  claimId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SyrupDripTxType>;
  type_in?: InputMaybe<Array<SyrupDripTxType>>;
  type_not?: InputMaybe<SyrupDripTxType>;
  type_not_in?: InputMaybe<Array<SyrupDripTxType>>;
};

export enum SyrupDripTx_OrderBy {
  Account = 'account',
  Amount = 'amount',
  ClaimId = 'claimId',
  Id = 'id',
  Timestamp = 'timestamp',
  Transaction = 'transaction',
  Type = 'type'
}

export type SyrupDrip_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  allocation?: InputMaybe<Scalars['String']['input']>;
  allocation_?: InputMaybe<Allocation_Filter>;
  allocation_contains?: InputMaybe<Scalars['String']['input']>;
  allocation_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  allocation_ends_with?: InputMaybe<Scalars['String']['input']>;
  allocation_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  allocation_gt?: InputMaybe<Scalars['String']['input']>;
  allocation_gte?: InputMaybe<Scalars['String']['input']>;
  allocation_in?: InputMaybe<Array<Scalars['String']['input']>>;
  allocation_lt?: InputMaybe<Scalars['String']['input']>;
  allocation_lte?: InputMaybe<Scalars['String']['input']>;
  allocation_not?: InputMaybe<Scalars['String']['input']>;
  allocation_not_contains?: InputMaybe<Scalars['String']['input']>;
  allocation_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  allocation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  allocation_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  allocation_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  allocation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  allocation_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  allocation_starts_with?: InputMaybe<Scalars['String']['input']>;
  allocation_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  txCount?: InputMaybe<Scalars['Int']['input']>;
  txCount_gt?: InputMaybe<Scalars['Int']['input']>;
  txCount_gte?: InputMaybe<Scalars['Int']['input']>;
  txCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  txCount_lt?: InputMaybe<Scalars['Int']['input']>;
  txCount_lte?: InputMaybe<Scalars['Int']['input']>;
  txCount_not?: InputMaybe<Scalars['Int']['input']>;
  txCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum SyrupDrip_OrderBy {
  Allocation = 'allocation',
  Id = 'id',
  TxCount = 'txCount'
}

export type SyrupGlobals = {
  __typename?: 'SyrupGlobals';
  apy: Scalars['String']['output'];
  collateralApy: Scalars['String']['output'];
  collateralRatio: Scalars['String']['output'];
  dripsIssued: Scalars['String']['output'];
  dripsYieldBoost: Scalars['String']['output'];
  poolApy: Scalars['String']['output'];
  recommitEnd: Scalars['String']['output'];
  tvl: Scalars['String']['output'];
};

export type SyrupRouter = {
  __typename?: 'SyrupRouter';
  id: Scalars['ID']['output'];
  pool: PoolV2;
};

export type SyrupRouter_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum SyrupRouter_OrderBy {
  Id = 'id',
  Pool = 'pool'
}

export type SyrupToken = {
  __typename?: 'SyrupToken';
  amountClaimed: Scalars['BigInt']['output'];
  asset: Asset;
  id: Scalars['ID']['output'];
  issuanceRates: Array<RecapitalizationWindow>;
  tokensMigrated: Scalars['BigInt']['output'];
  totalSupply: Scalars['BigInt']['output'];
  txCount: Scalars['Int']['output'];
};


export type SyrupTokenIssuanceRatesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RecapitalizationWindow_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecapitalizationWindow_Filter>;
};

export type SyrupToken_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountClaimed?: InputMaybe<Scalars['BigInt']['input']>;
  amountClaimed_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amountClaimed_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amountClaimed_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amountClaimed_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amountClaimed_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amountClaimed_not?: InputMaybe<Scalars['BigInt']['input']>;
  amountClaimed_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<Asset_Filter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  issuanceRates?: InputMaybe<Array<Scalars['String']['input']>>;
  issuanceRates_?: InputMaybe<RecapitalizationWindow_Filter>;
  issuanceRates_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  issuanceRates_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  issuanceRates_not?: InputMaybe<Array<Scalars['String']['input']>>;
  issuanceRates_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  issuanceRates_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensMigrated?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokensMigrated_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_not?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  txCount?: InputMaybe<Scalars['Int']['input']>;
  txCount_gt?: InputMaybe<Scalars['Int']['input']>;
  txCount_gte?: InputMaybe<Scalars['Int']['input']>;
  txCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  txCount_lt?: InputMaybe<Scalars['Int']['input']>;
  txCount_lte?: InputMaybe<Scalars['Int']['input']>;
  txCount_not?: InputMaybe<Scalars['Int']['input']>;
  txCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum SyrupToken_OrderBy {
  AmountClaimed = 'amountClaimed',
  Asset = 'asset',
  Id = 'id',
  IssuanceRates = 'issuanceRates',
  TokensMigrated = 'tokensMigrated',
  TotalSupply = 'totalSupply',
  TxCount = 'txCount'
}

export type SyrupTx = {
  __typename?: 'SyrupTx';
  account: Account;
  id: Scalars['ID']['output'];
  timestamp: Scalars['BigInt']['output'];
  tokensMigrated: Scalars['BigInt']['output'];
  transaction: Transaction;
};

export type SyrupTx_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokensMigrated?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokensMigrated_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_not?: InputMaybe<Scalars['BigInt']['input']>;
  tokensMigrated_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum SyrupTx_OrderBy {
  Account = 'account',
  Id = 'id',
  Timestamp = 'timestamp',
  TokensMigrated = 'tokensMigrated',
  Transaction = 'transaction'
}

export type SyrupUsdcFormInput = {
  email: Scalars['EmailAddress']['input'];
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  walletAddress?: InputMaybe<Scalars['EthereumAddress']['input']>;
};

export type SyrupUser = {
  __typename?: 'SyrupUser';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type SyrupUserInput = {
  email: Scalars['String']['input'];
};

export enum TaxResidency {
  Usa = 'USA',
  NonUsa = 'nonUSA'
}

export type TokenStats = {
  __typename?: 'TokenStats';
  circulatingSupply?: Maybe<Scalars['String']['output']>;
  marketCap?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  stakedSupply?: Maybe<Scalars['String']['output']>;
};

export type Total = {
  __typename?: 'Total';
  aggregateLpApy: Scalars['BigInt']['output'];
  currentLoaned: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  interestEarned: Scalars['BigInt']['output'];
  liquidityCap: Scalars['BigInt']['output'];
  liquidityProvided: Scalars['BigInt']['output'];
  loanOriginations: Scalars['BigInt']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
  treasuryFees: Scalars['BigInt']['output'];
};

export type Total_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  aggregateLpApy?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_gt?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_gte?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  aggregateLpApy_lt?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_lte?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_not?: InputMaybe<Scalars['BigInt']['input']>;
  aggregateLpApy_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  currentLoaned?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  currentLoaned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_not?: InputMaybe<Scalars['BigInt']['input']>;
  currentLoaned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interestEarned?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_gt?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_gte?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  interestEarned_lt?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_lte?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_not?: InputMaybe<Scalars['BigInt']['input']>;
  interestEarned_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityCap?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityCap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityCap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityProvided?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_gt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_gte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidityProvided_lt?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_lte?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_not?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProvided_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  loanOriginations?: InputMaybe<Scalars['BigInt']['input']>;
  loanOriginations_gt?: InputMaybe<Scalars['BigInt']['input']>;
  loanOriginations_gte?: InputMaybe<Scalars['BigInt']['input']>;
  loanOriginations_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  loanOriginations_lt?: InputMaybe<Scalars['BigInt']['input']>;
  loanOriginations_lte?: InputMaybe<Scalars['BigInt']['input']>;
  loanOriginations_not?: InputMaybe<Scalars['BigInt']['input']>;
  loanOriginations_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  treasuryFees?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_gt?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_gte?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  treasuryFees_lt?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_lte?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_not?: InputMaybe<Scalars['BigInt']['input']>;
  treasuryFees_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Total_OrderBy {
  AggregateLpApy = 'aggregateLpApy',
  CurrentLoaned = 'currentLoaned',
  Id = 'id',
  InterestEarned = 'interestEarned',
  LiquidityCap = 'liquidityCap',
  LiquidityProvided = 'liquidityProvided',
  LoanOriginations = 'loanOriginations',
  Symbol = 'symbol',
  TreasuryFees = 'treasuryFees'
}

export type Transaction = {
  __typename?: 'Transaction';
  block: Scalars['BigInt']['output'];
  gasLimit: Scalars['BigInt']['output'];
  gasPrice: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  timestamp: Scalars['BigInt']['output'];
};

export type Transaction_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  block?: InputMaybe<Scalars['BigInt']['input']>;
  block_gt?: InputMaybe<Scalars['BigInt']['input']>;
  block_gte?: InputMaybe<Scalars['BigInt']['input']>;
  block_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  block_lt?: InputMaybe<Scalars['BigInt']['input']>;
  block_lte?: InputMaybe<Scalars['BigInt']['input']>;
  block_not?: InputMaybe<Scalars['BigInt']['input']>;
  block_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  gasLimit?: InputMaybe<Scalars['BigInt']['input']>;
  gasLimit_gt?: InputMaybe<Scalars['BigInt']['input']>;
  gasLimit_gte?: InputMaybe<Scalars['BigInt']['input']>;
  gasLimit_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  gasLimit_lt?: InputMaybe<Scalars['BigInt']['input']>;
  gasLimit_lte?: InputMaybe<Scalars['BigInt']['input']>;
  gasLimit_not?: InputMaybe<Scalars['BigInt']['input']>;
  gasLimit_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  gasPrice?: InputMaybe<Scalars['BigInt']['input']>;
  gasPrice_gt?: InputMaybe<Scalars['BigInt']['input']>;
  gasPrice_gte?: InputMaybe<Scalars['BigInt']['input']>;
  gasPrice_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  gasPrice_lt?: InputMaybe<Scalars['BigInt']['input']>;
  gasPrice_lte?: InputMaybe<Scalars['BigInt']['input']>;
  gasPrice_not?: InputMaybe<Scalars['BigInt']['input']>;
  gasPrice_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum Transaction_OrderBy {
  Block = 'block',
  GasLimit = 'gasLimit',
  GasPrice = 'gasPrice',
  Id = 'id',
  Timestamp = 'timestamp'
}

export enum TrmChains {
  Ethereum = 'ethereum',
  Solana = 'solana'
}

export type Tx = {
  __typename?: 'Tx';
  account: Account;
  amount: Scalars['BigInt']['output'];
  decimals: Scalars['Int']['output'];
  depositData?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  loan?: Maybe<Loan>;
  openTermLoan?: Maybe<OpenTermLoan>;
  pool?: Maybe<Pool>;
  poolV2?: Maybe<PoolV2>;
  shares?: Maybe<Scalars['BigInt']['output']>;
  symbol: Scalars['String']['output'];
  timestamp: Scalars['BigInt']['output'];
  transaction: Transaction;
  type: TxType;
  value: Scalars['BigInt']['output'];
  withdrawalRequest?: Maybe<WithdrawalRequest>;
};

export enum TxType {
  LendingRewardsGetReward = 'lendingRewardsGetReward',
  LendingRewardsReceived = 'lendingRewardsReceived',
  LendingRewardsStake = 'lendingRewardsStake',
  LendingRewardsVoided = 'lendingRewardsVoided',
  LendingRewardsWithdraw = 'lendingRewardsWithdraw',
  PoolDeposit = 'poolDeposit',
  PoolIntendToWithdraw = 'poolIntendToWithdraw',
  PoolMigrateBalance = 'poolMigrateBalance',
  PoolMoveToNextWindow = 'poolMoveToNextWindow',
  PoolRecognizeImpairment = 'poolRecognizeImpairment',
  PoolRecognizeLosses = 'poolRecognizeLosses',
  PoolRecognizeUnimpairment = 'poolRecognizeUnimpairment',
  PoolReinvestInterest = 'poolReinvestInterest',
  PoolRemoveShares = 'poolRemoveShares',
  PoolRemoveSharesPartial = 'poolRemoveSharesPartial',
  PoolTransferIn = 'poolTransferIn',
  PoolTransferOut = 'poolTransferOut',
  PoolWithdraw = 'poolWithdraw',
  PoolWithdrawFunds = 'poolWithdrawFunds',
  PoolWithdrawPartial = 'poolWithdrawPartial',
  StakeLockerIntendToUnstake = 'stakeLockerIntendToUnstake',
  StakeLockerRecognizeLosses = 'stakeLockerRecognizeLosses',
  StakeLockerStake = 'stakeLockerStake',
  StakeLockerUnstake = 'stakeLockerUnstake',
  StakeLockerWithdrawFunds = 'stakeLockerWithdrawFunds',
  StakingRewardsGetReward = 'stakingRewardsGetReward',
  StakingRewardsStake = 'stakingRewardsStake',
  StakingRewardsWithdraw = 'stakingRewardsWithdraw'
}

export type Tx_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  amount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not?: InputMaybe<Scalars['BigInt']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  depositData?: InputMaybe<Scalars['String']['input']>;
  depositData_contains?: InputMaybe<Scalars['String']['input']>;
  depositData_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  depositData_ends_with?: InputMaybe<Scalars['String']['input']>;
  depositData_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositData_gt?: InputMaybe<Scalars['String']['input']>;
  depositData_gte?: InputMaybe<Scalars['String']['input']>;
  depositData_in?: InputMaybe<Array<Scalars['String']['input']>>;
  depositData_lt?: InputMaybe<Scalars['String']['input']>;
  depositData_lte?: InputMaybe<Scalars['String']['input']>;
  depositData_not?: InputMaybe<Scalars['String']['input']>;
  depositData_not_contains?: InputMaybe<Scalars['String']['input']>;
  depositData_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  depositData_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  depositData_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositData_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  depositData_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  depositData_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositData_starts_with?: InputMaybe<Scalars['String']['input']>;
  depositData_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  loan?: InputMaybe<Scalars['String']['input']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']['input']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_gt?: InputMaybe<Scalars['String']['input']>;
  loan_gte?: InputMaybe<Scalars['String']['input']>;
  loan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_lt?: InputMaybe<Scalars['String']['input']>;
  loan_lte?: InputMaybe<Scalars['String']['input']>;
  loan_not?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains?: InputMaybe<Scalars['String']['input']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with?: InputMaybe<Scalars['String']['input']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoan?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_?: InputMaybe<OpenTermLoan_Filter>;
  openTermLoan_contains?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_ends_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_gt?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_gte?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_in?: InputMaybe<Array<Scalars['String']['input']>>;
  openTermLoan_lt?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_lte?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_contains?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  openTermLoan_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_starts_with?: InputMaybe<Scalars['String']['input']>;
  openTermLoan_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool?: InputMaybe<Scalars['String']['input']>;
  poolV2?: InputMaybe<Scalars['String']['input']>;
  poolV2_?: InputMaybe<PoolV2_Filter>;
  poolV2_contains?: InputMaybe<Scalars['String']['input']>;
  poolV2_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV2_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolV2_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV2_gt?: InputMaybe<Scalars['String']['input']>;
  poolV2_gte?: InputMaybe<Scalars['String']['input']>;
  poolV2_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolV2_lt?: InputMaybe<Scalars['String']['input']>;
  poolV2_lte?: InputMaybe<Scalars['String']['input']>;
  poolV2_not?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolV2_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolV2_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolV2_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolV2_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<Pool_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  shares?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TxType>;
  type_in?: InputMaybe<Array<TxType>>;
  type_not?: InputMaybe<TxType>;
  type_not_in?: InputMaybe<Array<TxType>>;
  value?: InputMaybe<Scalars['BigInt']['input']>;
  value_gt?: InputMaybe<Scalars['BigInt']['input']>;
  value_gte?: InputMaybe<Scalars['BigInt']['input']>;
  value_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  value_lt?: InputMaybe<Scalars['BigInt']['input']>;
  value_lte?: InputMaybe<Scalars['BigInt']['input']>;
  value_not?: InputMaybe<Scalars['BigInt']['input']>;
  value_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawalRequest?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_?: InputMaybe<WithdrawalRequest_Filter>;
  withdrawalRequest_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_gt?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_gte?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalRequest_lt?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_lte?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_not?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_not_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalRequest_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalRequest_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum Tx_OrderBy {
  Account = 'account',
  Amount = 'amount',
  Decimals = 'decimals',
  DepositData = 'depositData',
  Id = 'id',
  Loan = 'loan',
  OpenTermLoan = 'openTermLoan',
  Pool = 'pool',
  PoolV2 = 'poolV2',
  Shares = 'shares',
  Symbol = 'symbol',
  Timestamp = 'timestamp',
  Transaction = 'transaction',
  Type = 'type',
  Value = 'value',
  WithdrawalRequest = 'withdrawalRequest'
}

export type TypeformResponse = {
  __typename?: 'TypeformResponse';
  response_id: Scalars['String']['output'];
};

export type UpdateAutoRedeemerConfig = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  lockupAmount?: InputMaybe<Scalars['String']['input']>;
  maxGasPriceGwei?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBannerInput = {
  active: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  type: BannerType;
};

export type UpdateBondInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  parAmount?: InputMaybe<Scalars['Float']['input']>;
  yieldCoupon?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBorrowerInput = {
  aboutCeoName?: InputMaybe<Scalars['String']['input']>;
  aboutFoundedDate?: InputMaybe<Scalars['String']['input']>;
  aboutInfo?: InputMaybe<Scalars['String']['input']>;
  aboutNumEmployees?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPublicName?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  revenueUsage?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<BorrowerState>;
  telegram?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCollateralInput = {
  asset?: InputMaybe<CollateralAsset>;
  assetAmount?: InputMaybe<Scalars['String']['input']>;
  bitgoWalletId?: InputMaybe<Scalars['String']['input']>;
  custodian?: InputMaybe<Custodian>;
  initialLevel?: InputMaybe<Scalars['Int']['input']>;
  liquidationLevel?: InputMaybe<Scalars['Int']['input']>;
  liquidationThreshold?: InputMaybe<Scalars['Int']['input']>;
  marginCallLevel?: InputMaybe<Scalars['Int']['input']>;
  marginCallNoticePeriodHours?: InputMaybe<Scalars['Int']['input']>;
  marginCallThreshold?: InputMaybe<Scalars['Int']['input']>;
  refundLevel?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCollateralTypeInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommitmentInput = {
  connector?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  depositTxes?: InputMaybe<Array<Scalars['String']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  shares?: InputMaybe<Scalars['String']['input']>;
  wallet?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDelegateInput = {
  aboutBusiness?: InputMaybe<Scalars['String']['input']>;
  allowList?: InputMaybe<Scalars['Boolean']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<Scalars['Int']['input']>;
  deckFileName?: InputMaybe<Scalars['String']['input']>;
  deckFileUrl?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profileUrl?: InputMaybe<Scalars['String']['input']>;
  telegram?: InputMaybe<Scalars['String']['input']>;
  totalAssetsUnderManagement?: InputMaybe<Scalars['Int']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDepositInput = {
  symbol: CollateralAsset;
  totalDeposits?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLegalEntityInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryOfOperation?: InputMaybe<Scalars['String']['input']>;
  lendingAppetite?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  taxResidency?: InputMaybe<TaxResidency>;
};

export type UpdateLiquidityManagerConfig = {
  botEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dryrunMode?: InputMaybe<Scalars['Boolean']['input']>;
  gasThreshold?: InputMaybe<Scalars['String']['input']>;
  maxGasPrice?: InputMaybe<Scalars['String']['input']>;
  reservedAssets?: InputMaybe<Scalars['String']['input']>;
  strategies?: InputMaybe<Array<LiquidityManagerStrategyConfigInput>>;
  strategiesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  withdrawalsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLoanInput = {
  nextCallDate?: InputMaybe<Scalars['String']['input']>;
  nonRecallPeriodDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMemberRoleInput = {
  orgId: Scalars['ID']['input'];
  role: MembershipRole;
  userId: Scalars['ID']['input'];
};

export type UpdateNativeAssetInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  collateralYield?: InputMaybe<Scalars['Int']['input']>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNativePoolInput = {
  decimals?: InputMaybe<Scalars['Int']['input']>;
  nativePoolId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePoolCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePoolInjectionInput = {
  dryRun: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  maxInjectionAmount: Scalars['String']['input'];
  minInjectionAmount: Scalars['String']['input'];
  randomnessVariance: Scalars['Int']['input'];
  targetFrequency: Scalars['Int']['input'];
  targetYield: Scalars['Float']['input'];
  xirrPeriod: Scalars['Int']['input'];
};

export type UpdatePoolInput = {
  asset?: InputMaybe<Scalars['String']['input']>;
  benchmarkApy?: InputMaybe<Scalars['String']['input']>;
  cardDescription?: InputMaybe<Scalars['String']['input']>;
  carouselPriority?: InputMaybe<Scalars['Int']['input']>;
  collateralApy?: InputMaybe<Scalars['String']['input']>;
  collateralType?: InputMaybe<Scalars['String']['input']>;
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  docSendUrl?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  highlights?: InputMaybe<Array<InputMaybe<PoolHighlightInput>>>;
  image?: InputMaybe<Scalars['String']['input']>;
  isACMPool?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isTreasuryPool?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  lendReqs?: InputMaybe<Array<LendReq>>;
  overview?: InputMaybe<Scalars['String']['input']>;
  permittedAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  poolCategory?: InputMaybe<Scalars['String']['input']>;
  poolCollaterals?: InputMaybe<Array<PoolCollateralInput>>;
  poolDelegate?: InputMaybe<Scalars['String']['input']>;
  poolName?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  reportFileName?: InputMaybe<Scalars['String']['input']>;
  reportFileUrl?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<PoolV2State>;
  strategy?: InputMaybe<Scalars['String']['input']>;
  underwritingBullets?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalDays?: InputMaybe<Scalars['Int']['input']>;
  withdrawalHours?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSeasonInput = {
  dripsConversionRate?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  endBlock?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSyrupGlobalsInput = {
  dripsYieldBoost?: InputMaybe<Scalars['Float']['input']>;
  recommitEnd?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUpcomingAllocationInput = {
  start?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  accountType?: InputMaybe<AccountType>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  depositDuration?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lendingAppetite?: InputMaybe<Scalars['String']['input']>;
  taxResidency?: InputMaybe<TaxResidency>;
};

export type User = {
  __typename?: 'User';
  accountType?: Maybe<AccountType>;
  countryCode?: Maybe<Scalars['String']['output']>;
  courierAuth?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  depositDuration?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lendingAppetite?: Maybe<Scalars['String']['output']>;
  lendingPools?: Maybe<Array<PoolVerificationStatus>>;
  org?: Maybe<Org>;
  orgRole?: Maybe<MembershipRole>;
  permissions?: Maybe<Array<ResourcePermission>>;
  privileges: Array<Privilege>;
  roles?: Maybe<Array<ResourceRole>>;
  securitizeId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Source>;
  taxResidency?: Maybe<TaxResidency>;
  verification?: Maybe<UserVerification>;
  wallets?: Maybe<Array<Wallet>>;
};

export type UserAllocation = {
  __typename?: 'UserAllocation';
  address: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  claimTxes?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['String']['output'];
  globalAllocation: GlobalAllocation;
  hasClaimed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  proofs?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['String']['output'];
};

export type UserVerification = {
  __typename?: 'UserVerification';
  accountMLA: SubmissionStatus;
  accountMLAUpdatedAt: Scalars['String']['output'];
  accreditedInvestor: SubmissionStatus;
  accreditedInvestorSource: VerificationSource;
  accreditedInvestorUpdatedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kyc: SubmissionStatus;
  kycSource: VerificationSource;
  kycUpdatedAt: Scalars['String']['output'];
  org?: Maybe<Org>;
  tax: SubmissionStatus;
  taxUpdatedAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type VerificationInput = {
  accountMLA?: InputMaybe<SubmissionStatus>;
  accreditedInvestor?: InputMaybe<SubmissionStatus>;
  kyc?: InputMaybe<SubmissionStatus>;
  tax?: InputMaybe<SubmissionStatus>;
};

export enum VerificationSource {
  Maple = 'MAPLE',
  None = 'NONE',
  Securitize = 'SECURITIZE'
}

export type Wm = {
  __typename?: 'WM';
  address: Scalars['String']['output'];
};

export type Wallet = {
  __typename?: 'Wallet';
  addedByUser?: Maybe<User>;
  address: Scalars['EthereumAddress']['output'];
  addressScreeningId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSyrup: Scalars['Boolean']['output'];
  org?: Maybe<Org>;
  referralToken?: Maybe<ReferralToken>;
  status: WalletStatus;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum WalletStatus {
  Fail = 'FAIL',
  Pass = 'PASS'
}

export type WithdrawalManager = {
  __typename?: 'WithdrawalManager';
  cycleDuration: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  initialCycleId: Scalars['BigInt']['output'];
  initialCycleTime: Scalars['BigInt']['output'];
  pool: PoolV2;
  version: Scalars['Int']['output'];
  windowDuration: Scalars['BigInt']['output'];
};

export type WithdrawalManagerQueue = {
  __typename?: 'WithdrawalManagerQueue';
  id: Scalars['ID']['output'];
  lastRequest?: Maybe<WithdrawalRequest>;
  nextRequest?: Maybe<WithdrawalRequest>;
  pool: PoolV2;
  requests?: Maybe<Array<WithdrawalRequest>>;
  totalShares: Scalars['BigInt']['output'];
  version: Scalars['Int']['output'];
};


export type WithdrawalManagerQueueRequestsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WithdrawalRequest_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WithdrawalRequest_Filter>;
};

export type WithdrawalManagerQueue_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastRequest?: InputMaybe<Scalars['String']['input']>;
  lastRequest_?: InputMaybe<WithdrawalRequest_Filter>;
  lastRequest_contains?: InputMaybe<Scalars['String']['input']>;
  lastRequest_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lastRequest_ends_with?: InputMaybe<Scalars['String']['input']>;
  lastRequest_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lastRequest_gt?: InputMaybe<Scalars['String']['input']>;
  lastRequest_gte?: InputMaybe<Scalars['String']['input']>;
  lastRequest_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lastRequest_lt?: InputMaybe<Scalars['String']['input']>;
  lastRequest_lte?: InputMaybe<Scalars['String']['input']>;
  lastRequest_not?: InputMaybe<Scalars['String']['input']>;
  lastRequest_not_contains?: InputMaybe<Scalars['String']['input']>;
  lastRequest_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  lastRequest_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lastRequest_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lastRequest_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  lastRequest_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lastRequest_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lastRequest_starts_with?: InputMaybe<Scalars['String']['input']>;
  lastRequest_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextRequest?: InputMaybe<Scalars['String']['input']>;
  nextRequest_?: InputMaybe<WithdrawalRequest_Filter>;
  nextRequest_contains?: InputMaybe<Scalars['String']['input']>;
  nextRequest_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  nextRequest_ends_with?: InputMaybe<Scalars['String']['input']>;
  nextRequest_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextRequest_gt?: InputMaybe<Scalars['String']['input']>;
  nextRequest_gte?: InputMaybe<Scalars['String']['input']>;
  nextRequest_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nextRequest_lt?: InputMaybe<Scalars['String']['input']>;
  nextRequest_lte?: InputMaybe<Scalars['String']['input']>;
  nextRequest_not?: InputMaybe<Scalars['String']['input']>;
  nextRequest_not_contains?: InputMaybe<Scalars['String']['input']>;
  nextRequest_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  nextRequest_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  nextRequest_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextRequest_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nextRequest_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  nextRequest_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  nextRequest_starts_with?: InputMaybe<Scalars['String']['input']>;
  nextRequest_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  requests?: InputMaybe<Array<Scalars['String']['input']>>;
  requests_?: InputMaybe<WithdrawalRequest_Filter>;
  requests_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  requests_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  requests_not?: InputMaybe<Array<Scalars['String']['input']>>;
  requests_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  requests_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  totalShares?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalShares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalShares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum WithdrawalManagerQueue_OrderBy {
  Id = 'id',
  LastRequest = 'lastRequest',
  NextRequest = 'nextRequest',
  Pool = 'pool',
  Requests = 'requests',
  TotalShares = 'totalShares',
  Version = 'version'
}

export type WithdrawalManager_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  cycleDuration?: InputMaybe<Scalars['BigInt']['input']>;
  cycleDuration_gt?: InputMaybe<Scalars['BigInt']['input']>;
  cycleDuration_gte?: InputMaybe<Scalars['BigInt']['input']>;
  cycleDuration_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  cycleDuration_lt?: InputMaybe<Scalars['BigInt']['input']>;
  cycleDuration_lte?: InputMaybe<Scalars['BigInt']['input']>;
  cycleDuration_not?: InputMaybe<Scalars['BigInt']['input']>;
  cycleDuration_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  initialCycleId?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleId_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleId_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleId_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialCycleId_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleId_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleId_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleId_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialCycleTime?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleTime_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleTime_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleTime_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialCycleTime_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleTime_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleTime_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialCycleTime_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolV2_Filter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_gt?: InputMaybe<Scalars['Int']['input']>;
  version_gte?: InputMaybe<Scalars['Int']['input']>;
  version_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_lt?: InputMaybe<Scalars['Int']['input']>;
  version_lte?: InputMaybe<Scalars['Int']['input']>;
  version_not?: InputMaybe<Scalars['Int']['input']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  windowDuration?: InputMaybe<Scalars['BigInt']['input']>;
  windowDuration_gt?: InputMaybe<Scalars['BigInt']['input']>;
  windowDuration_gte?: InputMaybe<Scalars['BigInt']['input']>;
  windowDuration_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  windowDuration_lt?: InputMaybe<Scalars['BigInt']['input']>;
  windowDuration_lte?: InputMaybe<Scalars['BigInt']['input']>;
  windowDuration_not?: InputMaybe<Scalars['BigInt']['input']>;
  windowDuration_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum WithdrawalManager_OrderBy {
  CycleDuration = 'cycleDuration',
  Id = 'id',
  InitialCycleId = 'initialCycleId',
  InitialCycleTime = 'initialCycleTime',
  Pool = 'pool',
  Version = 'version',
  WindowDuration = 'windowDuration'
}

export type WithdrawalRequest = {
  __typename?: 'WithdrawalRequest';
  cancelledAt: Scalars['BigInt']['output'];
  createdAt: Scalars['BigInt']['output'];
  estimate?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  initialShares: Scalars['BigInt']['output'];
  isCancelable?: Maybe<Scalars['Boolean']['output']>;
  owner: Scalars['Bytes']['output'];
  processedAt: Scalars['BigInt']['output'];
  processedShares: Scalars['BigInt']['output'];
  shares: Scalars['BigInt']['output'];
  status: WithdrawalRequestStatus;
};

export enum WithdrawalRequestStatus {
  Cancelled = 'Cancelled',
  Pending = 'Pending',
  Processed = 'Processed',
  ProcessedPartial = 'ProcessedPartial'
}

export type WithdrawalRequest_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  cancelledAt?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  cancelledAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  cancelledAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  initialShares?: InputMaybe<Scalars['BigInt']['input']>;
  initialShares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  initialShares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  initialShares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  initialShares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  initialShares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  initialShares_not?: InputMaybe<Scalars['BigInt']['input']>;
  initialShares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  owner?: InputMaybe<Scalars['Bytes']['input']>;
  owner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  owner_not?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  processedAt?: InputMaybe<Scalars['BigInt']['input']>;
  processedAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  processedAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  processedAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  processedAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  processedAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  processedAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  processedAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  processedShares?: InputMaybe<Scalars['BigInt']['input']>;
  processedShares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  processedShares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  processedShares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  processedShares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  processedShares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  processedShares_not?: InputMaybe<Scalars['BigInt']['input']>;
  processedShares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_gte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  shares_lt?: InputMaybe<Scalars['BigInt']['input']>;
  shares_lte?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not?: InputMaybe<Scalars['BigInt']['input']>;
  shares_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  status?: InputMaybe<WithdrawalRequestStatus>;
  status_in?: InputMaybe<Array<WithdrawalRequestStatus>>;
  status_not?: InputMaybe<WithdrawalRequestStatus>;
  status_not_in?: InputMaybe<Array<WithdrawalRequestStatus>>;
};

export enum WithdrawalRequest_OrderBy {
  CancelledAt = 'cancelledAt',
  CreatedAt = 'createdAt',
  Id = 'id',
  InitialShares = 'initialShares',
  Owner = 'owner',
  ProcessedAt = 'processedAt',
  ProcessedShares = 'processedShares',
  Shares = 'shares',
  Status = 'status'
}

export enum WithdrawalStatus {
  Lapsed = 'LAPSED',
  Pending = 'PENDING',
  Withdrawn = 'WITHDRAWN'
}

export type XmplMigrationTx = {
  __typename?: 'XMPLMigrationTx';
  assetsAmount: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sharesAmount: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  type: XmplMigrationTxType;
};

export enum XmplMigrationTxType {
  Migrate = 'migrate'
}

export type XirrMonthlyHistory = {
  __typename?: 'XirrMonthlyHistory';
  exchangeRate: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  xirr: Scalars['String']['output'];
};

export type XirrYearHistory = {
  __typename?: 'XirrYearHistory';
  exchangeRate: Scalars['String']['output'];
  monthly: Array<XirrMonthlyHistory>;
  xirr: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>;
  /** The block number */
  number: Scalars['Int']['output'];
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String']['output'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

export type StSyrup = {
  __typename?: 'stSyrup';
  asset: Asset;
  freeAssets: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  issuanceRate: Scalars['BigInt']['output'];
  lastUpdated: Scalars['BigInt']['output'];
  owner: Scalars['Bytes']['output'];
  pendingOwner: Scalars['Bytes']['output'];
  precision: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
  totalSupply: Scalars['BigInt']['output'];
  transaction?: Maybe<Transaction>;
  txCount: Scalars['Int']['output'];
  vestedAssetsPriorPeriods: Scalars['BigInt']['output'];
  vestingPeriodFinish: Scalars['BigInt']['output'];
  vestingPeriodStart: Scalars['BigInt']['output'];
};

export type StSyrupTx = {
  __typename?: 'stSyrupTx';
  account: Account;
  assetsAmount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  sharesAmount: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  transaction: Transaction;
  type: StakingTxType;
};

export type StSyrupTx_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetsAmount?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  assetsAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharesAmount?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sharesAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StakingTxType>;
  type_in?: InputMaybe<Array<StakingTxType>>;
  type_not?: InputMaybe<StakingTxType>;
  type_not_in?: InputMaybe<Array<StakingTxType>>;
};

export enum StSyrupTx_OrderBy {
  Account = 'account',
  AssetsAmount = 'assetsAmount',
  Id = 'id',
  SharesAmount = 'sharesAmount',
  Timestamp = 'timestamp',
  Transaction = 'transaction',
  Type = 'type'
}

export type StSyrup_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<Asset_Filter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  freeAssets?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  freeAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  issuanceRate?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  issuanceRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdated?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdated_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  owner?: InputMaybe<Scalars['Bytes']['input']>;
  owner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  owner_not?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  pendingOwner?: InputMaybe<Scalars['Bytes']['input']>;
  pendingOwner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  pendingOwner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  pendingOwner_not?: InputMaybe<Scalars['Bytes']['input']>;
  pendingOwner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  pendingOwner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  precision?: InputMaybe<Scalars['Int']['input']>;
  precision_gt?: InputMaybe<Scalars['Int']['input']>;
  precision_gte?: InputMaybe<Scalars['Int']['input']>;
  precision_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  precision_lt?: InputMaybe<Scalars['Int']['input']>;
  precision_lte?: InputMaybe<Scalars['Int']['input']>;
  precision_not?: InputMaybe<Scalars['Int']['input']>;
  precision_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  totalSupply?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  txCount?: InputMaybe<Scalars['Int']['input']>;
  txCount_gt?: InputMaybe<Scalars['Int']['input']>;
  txCount_gte?: InputMaybe<Scalars['Int']['input']>;
  txCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  txCount_lt?: InputMaybe<Scalars['Int']['input']>;
  txCount_lte?: InputMaybe<Scalars['Int']['input']>;
  txCount_not?: InputMaybe<Scalars['Int']['input']>;
  txCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  vestedAssetsPriorPeriods?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_gt?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_gte?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vestedAssetsPriorPeriods_lt?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_lte?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_not?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vestingPeriodFinish?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_gt?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_gte?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vestingPeriodFinish_lt?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_lte?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_not?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vestingPeriodStart?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_gt?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_gte?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vestingPeriodStart_lt?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_lte?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_not?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum StSyrup_OrderBy {
  Asset = 'asset',
  FreeAssets = 'freeAssets',
  Id = 'id',
  IssuanceRate = 'issuanceRate',
  LastUpdated = 'lastUpdated',
  Owner = 'owner',
  PendingOwner = 'pendingOwner',
  Precision = 'precision',
  Symbol = 'symbol',
  TotalSupply = 'totalSupply',
  Transaction = 'transaction',
  TxCount = 'txCount',
  VestedAssetsPriorPeriods = 'vestedAssetsPriorPeriods',
  VestingPeriodFinish = 'vestingPeriodFinish',
  VestingPeriodStart = 'vestingPeriodStart'
}

export enum StakingTxType {
  Deposit = 'deposit',
  Withdraw = 'withdraw'
}

export enum SyrupDripTxType {
  Claim = 'claim'
}

export type XMpl = {
  __typename?: 'xMPL';
  asset: Asset;
  freeAssets: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  issuanceRate: Scalars['BigInt']['output'];
  lastUpdated: Scalars['BigInt']['output'];
  owner: Scalars['Bytes']['output'];
  pendingOwner: Scalars['Bytes']['output'];
  precision: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
  totalSupply: Scalars['BigInt']['output'];
  transaction?: Maybe<Transaction>;
  txCount: Scalars['Int']['output'];
  vestedAssetsPriorPeriods: Scalars['BigInt']['output'];
  vestingPeriodFinish: Scalars['BigInt']['output'];
  vestingPeriodStart: Scalars['BigInt']['output'];
};

export type XMplTx = {
  __typename?: 'xMPLTx';
  account: Account;
  assetsAmount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  sharesAmount: Scalars['BigInt']['output'];
  timestamp: Scalars['BigInt']['output'];
  transaction: Transaction;
  type: StakingTxType;
};

export enum XMplTxType {
  Deposit = 'deposit',
  Withdraw = 'withdraw'
}

export type XMplTx_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  account?: InputMaybe<Scalars['String']['input']>;
  account_?: InputMaybe<Account_Filter>;
  account_contains?: InputMaybe<Scalars['String']['input']>;
  account_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_gt?: InputMaybe<Scalars['String']['input']>;
  account_gte?: InputMaybe<Scalars['String']['input']>;
  account_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_lt?: InputMaybe<Scalars['String']['input']>;
  account_lte?: InputMaybe<Scalars['String']['input']>;
  account_not?: InputMaybe<Scalars['String']['input']>;
  account_not_contains?: InputMaybe<Scalars['String']['input']>;
  account_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  account_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  account_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  account_starts_with?: InputMaybe<Scalars['String']['input']>;
  account_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetsAmount?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  assetsAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  assetsAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharesAmount?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  sharesAmount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_not?: InputMaybe<Scalars['BigInt']['input']>;
  sharesAmount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StakingTxType>;
  type_in?: InputMaybe<Array<StakingTxType>>;
  type_not?: InputMaybe<StakingTxType>;
  type_not_in?: InputMaybe<Array<StakingTxType>>;
};

export enum XMplTx_OrderBy {
  Account = 'account',
  AssetsAmount = 'assetsAmount',
  Id = 'id',
  SharesAmount = 'sharesAmount',
  Timestamp = 'timestamp',
  Transaction = 'transaction',
  Type = 'type'
}

export type XMpl_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  asset?: InputMaybe<Scalars['String']['input']>;
  asset_?: InputMaybe<Asset_Filter>;
  asset_contains?: InputMaybe<Scalars['String']['input']>;
  asset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_gt?: InputMaybe<Scalars['String']['input']>;
  asset_gte?: InputMaybe<Scalars['String']['input']>;
  asset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_lt?: InputMaybe<Scalars['String']['input']>;
  asset_lte?: InputMaybe<Scalars['String']['input']>;
  asset_not?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains?: InputMaybe<Scalars['String']['input']>;
  asset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  asset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with?: InputMaybe<Scalars['String']['input']>;
  asset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  freeAssets?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_gt?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_gte?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  freeAssets_lt?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_lte?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_not?: InputMaybe<Scalars['BigInt']['input']>;
  freeAssets_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  issuanceRate?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  issuanceRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  issuanceRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdated?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdated_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastUpdated_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  owner?: InputMaybe<Scalars['Bytes']['input']>;
  owner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  owner_not?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  owner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  pendingOwner?: InputMaybe<Scalars['Bytes']['input']>;
  pendingOwner_contains?: InputMaybe<Scalars['Bytes']['input']>;
  pendingOwner_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  pendingOwner_not?: InputMaybe<Scalars['Bytes']['input']>;
  pendingOwner_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  pendingOwner_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  precision?: InputMaybe<Scalars['Int']['input']>;
  precision_gt?: InputMaybe<Scalars['Int']['input']>;
  precision_gte?: InputMaybe<Scalars['Int']['input']>;
  precision_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  precision_lt?: InputMaybe<Scalars['Int']['input']>;
  precision_lte?: InputMaybe<Scalars['Int']['input']>;
  precision_not?: InputMaybe<Scalars['Int']['input']>;
  precision_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  totalSupply?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_gte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  totalSupply_lt?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_lte?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not?: InputMaybe<Scalars['BigInt']['input']>;
  totalSupply_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  transaction?: InputMaybe<Scalars['String']['input']>;
  transaction_?: InputMaybe<Transaction_Filter>;
  transaction_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_gt?: InputMaybe<Scalars['String']['input']>;
  transaction_gte?: InputMaybe<Scalars['String']['input']>;
  transaction_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_lt?: InputMaybe<Scalars['String']['input']>;
  transaction_lte?: InputMaybe<Scalars['String']['input']>;
  transaction_not?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains?: InputMaybe<Scalars['String']['input']>;
  transaction_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  transaction_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with?: InputMaybe<Scalars['String']['input']>;
  transaction_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  txCount?: InputMaybe<Scalars['Int']['input']>;
  txCount_gt?: InputMaybe<Scalars['Int']['input']>;
  txCount_gte?: InputMaybe<Scalars['Int']['input']>;
  txCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  txCount_lt?: InputMaybe<Scalars['Int']['input']>;
  txCount_lte?: InputMaybe<Scalars['Int']['input']>;
  txCount_not?: InputMaybe<Scalars['Int']['input']>;
  txCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  vestedAssetsPriorPeriods?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_gt?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_gte?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vestedAssetsPriorPeriods_lt?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_lte?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_not?: InputMaybe<Scalars['BigInt']['input']>;
  vestedAssetsPriorPeriods_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vestingPeriodFinish?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_gt?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_gte?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vestingPeriodFinish_lt?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_lte?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_not?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodFinish_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vestingPeriodStart?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_gt?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_gte?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  vestingPeriodStart_lt?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_lte?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_not?: InputMaybe<Scalars['BigInt']['input']>;
  vestingPeriodStart_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum XMpl_OrderBy {
  Asset = 'asset',
  FreeAssets = 'freeAssets',
  Id = 'id',
  IssuanceRate = 'issuanceRate',
  LastUpdated = 'lastUpdated',
  Owner = 'owner',
  PendingOwner = 'pendingOwner',
  Precision = 'precision',
  Symbol = 'symbol',
  TotalSupply = 'totalSupply',
  Transaction = 'transaction',
  TxCount = 'txCount',
  VestedAssetsPriorPeriods = 'vestedAssetsPriorPeriods',
  VestingPeriodFinish = 'vestingPeriodFinish',
  VestingPeriodStart = 'vestingPeriodStart'
}

export type AssetFragment = { __typename?: 'Asset', decimals: number, id: string, symbol: string };

export type SyrupUserFragment = { __typename?: 'SyrupUser', id: string, email: string, createdAt: string, updatedAt: string };

export type SyrupRouterFragment = { __typename?: 'SyrupRouter', id: string };

export type AccountFragment = { __typename?: 'Account', id: string, isSyrupLender: boolean, permissionsBitmap: any };

export type FunctionLevelBitmapFragment = { __typename?: 'FunctionLevelBitmap', id: string, functionId: string, bitmap: any };

export type PoolApyCachedFragment = { __typename?: 'PoolV2', id: string, monthlyApy?: string | null };

export type PoolFragment = { __typename?: 'PoolV2', id: string, tvl?: string | null, permissionLevel: number, syrupRouter?: { __typename?: 'SyrupRouter', id: string } | null, asset: { __typename?: 'Asset', decimals: number, id: string, symbol: string }, functionLevelBitmaps?: Array<{ __typename?: 'FunctionLevelBitmap', id: string, functionId: string, bitmap: any }> | null, poolMeta?: { __typename?: 'PoolMetadata', targetYield?: number | null } | null };

export type PoolCollateralFragment = { __typename?: 'PoolCollateral', addresses: Array<string>, asset: CollateralAsset, assetAmount?: string | null, assetDecimals: number, assetValueUsd?: string | null };

export type LoanManagerFragment = { __typename?: 'LoanManager', id: string, issuanceRate: any, accountedInterest: any, domainStart: any, domainEnd: any, principalOut: any };

export type OpenTermLoanManagerFragment = { __typename?: 'OpenTermLoanManager', id: string, issuanceRate: any, accountedInterest: any, domainStart: any, domainEnd: any, principalOut: any };

export type WithdrawalManagerQueueFragment = { __typename?: 'WithdrawalManagerQueue', id: string, version: number, totalShares: any, pool: { __typename?: 'PoolV2', id: string }, requests?: Array<{ __typename?: 'WithdrawalRequest', id: string, owner: any, initialShares: any, processedShares: any, shares: any, status: WithdrawalRequestStatus, createdAt: any, processedAt: any, cancelledAt: any, isCancelable?: boolean | null }> | null, lastRequest?: { __typename?: 'WithdrawalRequest', id: string, owner: any, initialShares: any, processedShares: any, shares: any, status: WithdrawalRequestStatus, createdAt: any, processedAt: any, cancelledAt: any, isCancelable?: boolean | null } | null, nextRequest?: { __typename?: 'WithdrawalRequest', id: string, owner: any, initialShares: any, processedShares: any, shares: any, status: WithdrawalRequestStatus, createdAt: any, processedAt: any, cancelledAt: any, isCancelable?: boolean | null } | null };

export type WithdrawalRequestFragment = { __typename?: 'WithdrawalRequest', id: string, owner: any, initialShares: any, processedShares: any, shares: any, status: WithdrawalRequestStatus, createdAt: any, processedAt: any, cancelledAt: any, isCancelable?: boolean | null };

export type PoolWithdrawalFragment = { __typename?: 'PoolV2', id: string, name: string, accountedInterest: any, assets: any, domainEnd: any, domainStart: any, issuanceRate: any, principalOut: any, shares: any, unrealizedLosses: any, asset: { __typename?: 'Asset', decimals: number, id: string, symbol: string }, loanManager?: { __typename?: 'LoanManager', id: string, issuanceRate: any, accountedInterest: any, domainStart: any, domainEnd: any, principalOut: any } | null, openTermLoanManager?: { __typename?: 'OpenTermLoanManager', id: string, issuanceRate: any, accountedInterest: any, domainStart: any, domainEnd: any, principalOut: any } | null, withdrawalManagerQueue?: { __typename?: 'WithdrawalManagerQueue', id: string, version: number, totalShares: any, pool: { __typename?: 'PoolV2', id: string }, requests?: Array<{ __typename?: 'WithdrawalRequest', id: string, owner: any, initialShares: any, processedShares: any, shares: any, status: WithdrawalRequestStatus, createdAt: any, processedAt: any, cancelledAt: any, isCancelable?: boolean | null }> | null, lastRequest?: { __typename?: 'WithdrawalRequest', id: string, owner: any, initialShares: any, processedShares: any, shares: any, status: WithdrawalRequestStatus, createdAt: any, processedAt: any, cancelledAt: any, isCancelable?: boolean | null } | null, nextRequest?: { __typename?: 'WithdrawalRequest', id: string, owner: any, initialShares: any, processedShares: any, shares: any, status: WithdrawalRequestStatus, createdAt: any, processedAt: any, cancelledAt: any, isCancelable?: boolean | null } | null } | null };

export type BasicTransactionFragment = { __typename?: 'Tx', id: string, amount: any, value: any, symbol: string, type: TxType, timestamp: any, transaction: { __typename?: 'Transaction', id: string } };

export type DepositSignatureFragment = { __typename?: 'DepositSignature', deadline: number, bitmap: number, r: string, s: string, v: string };

export type PoolV2PositionFragment = { __typename?: 'PoolV2Position', id: string, shares: any, lockedShares: any, totalShares: any, availableBalance?: string | null, availableShares?: string | null, lendingBalance?: string | null, interestEarned?: string | null, dripsEarned?: number | null, pool: { __typename?: 'PoolV2', asset: { __typename?: 'Asset', decimals: number, id: string, symbol: string }, poolMeta?: { __typename?: 'PoolMetadata', targetYield?: number | null } | null }, commitments?: Array<{ __typename?: 'Commitment', id: string, amount: string, days: number, date: string, depositTxes: Array<string>, dripsEarned: number, dripsPerDay: number, isWithdrawnEarly?: boolean | null, withdrawnAmount: string, withdrawnShares: string, shares: string, createdAt: string, updatedAt: string }> | null };

export type CommitmentFragment = { __typename?: 'Commitment', id: string, amount: string, days: number, date: string, depositTxes: Array<string>, dripsEarned: number, dripsPerDay: number, isWithdrawnEarly?: boolean | null, withdrawnAmount: string, withdrawnShares: string, shares: string, createdAt: string, updatedAt: string };

export type LoanDetailsFragment = { __typename?: 'OpenTermLoan', id: string, acmRatio?: string | null, interestRate: any, requestAmount: any, collateral?: { __typename?: 'Collateral', asset: CollateralAsset } | null, liquidityAsset: { __typename?: 'Asset', symbol: string, decimals: number } };

export type CommitmentBasicFragment = { __typename?: 'Commitment', date: string, days: number, amount: string, dripsPerDay: number, isWithdrawnEarly?: boolean | null, withdrawnAmount: string, seasons: Array<{ __typename?: 'Season', active: boolean, number: number }> };

export type SeasonScoreSnapshotCachedFragment = { __typename?: 'SeasonScore', currentDripsPerDay: number, seasonDrips: number, syrupEarned: number, updatedAt?: string | null, syrupEarnedUsd: number, totalRewardsYield: string, season: { __typename?: 'Season', number: number, start: string, end: string, active: boolean, dripsConversionRate?: number | null }, boosts?: Array<{ __typename?: 'SyrupBoost', type: SyrupBoostType, dripsPerDay: number, dripsEarned: number }> | null };

export type SeasonCachedFragment = { __typename?: 'Season', number: number, start: string, end: string, active: boolean, dripsConversionRate?: number | null };

export type BoostFragmentFragment = { __typename?: 'SyrupBoost', type: SyrupBoostType, dripsPerDay: number, dripsEarned: number };

export type ReferralTokenFragment = { __typename?: 'ReferralToken', id: string, token: string, isActive: boolean, alias: string, boost: number };

export type SyrupGlobalsCachedFragment = { __typename?: 'SyrupGlobals', apy: string, collateralApy: string, collateralRatio: string, poolApy: string, dripsYieldBoost: string, dripsIssued: string, tvl: string };

export type OpenTermLoanDetailsFragment = { __typename?: 'OpenTermLoan', id: string, acmRatio?: string | null, interestRate: any, requestAmount: any, principalOwed: any, collateral?: { __typename?: 'Collateral', asset: CollateralAsset } | null, liquidityAsset: { __typename?: 'Asset', decimals: number, symbol: string } };

export type PoolAssetFragment = { __typename?: 'PoolV2', id: string, asset: { __typename?: 'Asset', decimals: number, id: string, symbol: string } };

export type AaveStrategyFragment = { __typename?: 'AAVEStrategy', id: string, pool: { __typename?: 'PoolV2', id: string, asset: { __typename?: 'Asset', decimals: number, id: string, symbol: string } } };

export type SkyStrategyFragment = { __typename?: 'SkyStrategy', id: string, pool: { __typename?: 'PoolV2', id: string, asset: { __typename?: 'Asset', decimals: number, id: string, symbol: string } } };

export type CreateSyrupUserMutationVariables = Exact<{
  input: SyrupUserInput;
}>;


export type CreateSyrupUserMutation = { __typename?: 'Mutation', createSyrupUser: { __typename?: 'SyrupUser', id: string } };

export type ApplyReferralTokenMutationVariables = Exact<{
  input: ApplyReferralTokenInput;
}>;


export type ApplyReferralTokenMutation = { __typename?: 'Mutation', applyReferralToken?: { __typename?: 'MutationResponse', success: boolean } | null };

export type CommitBalanceMutationVariables = Exact<{
  address: Scalars['String']['input'];
  connector?: InputMaybe<Scalars['String']['input']>;
  shares: Scalars['String']['input'];
  poolId: Scalars['String']['input'];
  days: CommitDays;
}>;


export type CommitBalanceMutation = { __typename?: 'Mutation', commitBalance: { __typename?: 'MutationResponse', success: boolean } };

export type RecommitMutationVariables = Exact<{
  address: Scalars['String']['input'];
  commitmentId: Scalars['ID']['input'];
  days: CommitDays;
}>;


export type RecommitMutation = { __typename?: 'Mutation', recommit: { __typename?: 'MutationResponse', success: boolean } };

export type SubmitSyrupUsdcFormMutationVariables = Exact<{
  inputs: SyrupUsdcFormInput;
}>;


export type SubmitSyrupUsdcFormMutation = { __typename?: 'Mutation', submitSyrupUsdcForm: { __typename?: 'HubspotFormSubmission', success: boolean, message?: string | null } };

export type IsRestrictedQueryVariables = Exact<{ [key: string]: never; }>;


export type IsRestrictedQuery = { __typename?: 'Query', isRestricted: boolean };

export type GetAddressComplianceQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetAddressComplianceQuery = { __typename?: 'Query', addressCompliance: { __typename?: 'AddressCompliance', permitted: boolean } };

export type GetAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetsQuery = { __typename?: 'Query', assets: Array<{ __typename?: 'Asset', decimals: number, id: string, symbol: string }> };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, isSyrupLender: boolean, permissionsBitmap: any } | null };

export type GetGlobalDataQueryVariables = Exact<{
  stSyrupAddress: Scalars['ID']['input'];
}>;


export type GetGlobalDataQuery = { __typename?: 'Query', poolV2S: Array<{ __typename?: 'PoolV2', id: string, tvl?: string | null, permissionLevel: number, syrupRouter?: { __typename?: 'SyrupRouter', id: string } | null, asset: { __typename?: 'Asset', decimals: number, id: string, symbol: string }, functionLevelBitmaps?: Array<{ __typename?: 'FunctionLevelBitmap', id: string, functionId: string, bitmap: any }> | null, poolMeta?: { __typename?: 'PoolMetadata', targetYield?: number | null } | null }>, assets: Array<{ __typename?: 'Asset', decimals: number, id: string, symbol: string }>, stSyrup?: { __typename?: 'stSyrup', issuanceRate: any, vestingPeriodFinish: any } | null };

export type GetPoolsApyCachedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPoolsApyCachedQuery = { __typename?: 'Query', poolV2S: Array<{ __typename?: 'PoolV2', id: string, monthlyApy?: string | null }> };

export type GetGlobalSyrupStatsCachedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalSyrupStatsCachedQuery = { __typename?: 'Query', syrupGlobals: { __typename?: 'SyrupGlobals', apy: string, collateralApy: string, collateralRatio: string, poolApy: string, dripsYieldBoost: string, dripsIssued: string, tvl: string } };

export type GetPoolSignatureQueryVariables = Exact<{
  lender: Scalars['String']['input'];
  poolId: Scalars['String']['input'];
}>;


export type GetPoolSignatureQuery = { __typename?: 'Query', getPoolSignature: { __typename?: 'DepositSignature', deadline: number, bitmap: number, r: string, s: string, v: string } };

export type GetPortfolioDataQueryVariables = Exact<{
  account: Scalars['String']['input'];
  accountId: Scalars['ID']['input'];
  poolIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetPortfolioDataQuery = { __typename?: 'Query', poolV2Positions: Array<{ __typename?: 'PoolV2Position', id: string, shares: any, lockedShares: any, totalShares: any, availableBalance?: string | null, availableShares?: string | null, lendingBalance?: string | null, interestEarned?: string | null, dripsEarned?: number | null, pool: { __typename?: 'PoolV2', asset: { __typename?: 'Asset', decimals: number, id: string, symbol: string }, poolMeta?: { __typename?: 'PoolMetadata', targetYield?: number | null } | null }, commitments?: Array<{ __typename?: 'Commitment', id: string, amount: string, days: number, date: string, depositTxes: Array<string>, dripsEarned: number, dripsPerDay: number, isWithdrawnEarly?: boolean | null, withdrawnAmount: string, withdrawnShares: string, shares: string, createdAt: string, updatedAt: string }> | null }>, poolV2S: Array<{ __typename?: 'PoolV2', id: string, name: string, accountedInterest: any, assets: any, domainEnd: any, domainStart: any, issuanceRate: any, principalOut: any, shares: any, unrealizedLosses: any, asset: { __typename?: 'Asset', decimals: number, id: string, symbol: string }, loanManager?: { __typename?: 'LoanManager', id: string, issuanceRate: any, accountedInterest: any, domainStart: any, domainEnd: any, principalOut: any } | null, openTermLoanManager?: { __typename?: 'OpenTermLoanManager', id: string, issuanceRate: any, accountedInterest: any, domainStart: any, domainEnd: any, principalOut: any } | null, withdrawalManagerQueue?: { __typename?: 'WithdrawalManagerQueue', id: string, version: number, totalShares: any, pool: { __typename?: 'PoolV2', id: string }, requests?: Array<{ __typename?: 'WithdrawalRequest', id: string, owner: any, initialShares: any, processedShares: any, shares: any, status: WithdrawalRequestStatus, createdAt: any, processedAt: any, cancelledAt: any, isCancelable?: boolean | null }> | null, lastRequest?: { __typename?: 'WithdrawalRequest', id: string, owner: any, initialShares: any, processedShares: any, shares: any, status: WithdrawalRequestStatus, createdAt: any, processedAt: any, cancelledAt: any, isCancelable?: boolean | null } | null, nextRequest?: { __typename?: 'WithdrawalRequest', id: string, owner: any, initialShares: any, processedShares: any, shares: any, status: WithdrawalRequestStatus, createdAt: any, processedAt: any, cancelledAt: any, isCancelable?: boolean | null } | null } | null }>, txes: Array<{ __typename?: 'Tx', id: string, amount: any, value: any, symbol: string, type: TxType, timestamp: any, withdrawalRequest?: { __typename?: 'WithdrawalRequest', id: string, owner: any, initialShares: any, processedShares: any, shares: any, status: WithdrawalRequestStatus, createdAt: any, processedAt: any, cancelledAt: any, isCancelable?: boolean | null } | null, transaction: { __typename?: 'Transaction', id: string } }>, accountById?: { __typename?: 'Account', dripsEarned?: number | null, lendingApy?: string | null } | null };

export type GetDripsDataQueryVariables = Exact<{
  lender: Scalars['String']['input'];
}>;


export type GetDripsDataQuery = { __typename?: 'Query', commitments?: Array<{ __typename?: 'Commitment', date: string, days: number, amount: string, dripsPerDay: number, isWithdrawnEarly?: boolean | null, withdrawnAmount: string, seasons: Array<{ __typename?: 'Season', active: boolean, number: number }> }> | null };

export type GetSeasonScoreSnapshotCachedQueryVariables = Exact<{
  lender: Scalars['String']['input'];
}>;


export type GetSeasonScoreSnapshotCachedQuery = { __typename?: 'Query', seasonScoresSnapshot: Array<{ __typename?: 'SeasonScore', currentDripsPerDay: number, seasonDrips: number, syrupEarned: number, updatedAt?: string | null, syrupEarnedUsd: number, totalRewardsYield: string, season: { __typename?: 'Season', number: number, start: string, end: string, active: boolean, dripsConversionRate?: number | null }, boosts?: Array<{ __typename?: 'SyrupBoost', type: SyrupBoostType, dripsPerDay: number, dripsEarned: number }> | null }> };

export type GetDripsGlobalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDripsGlobalsQuery = { __typename?: 'Query', syrupGlobals: { __typename?: 'SyrupGlobals', apy: string, collateralApy: string, collateralRatio: string, poolApy: string, dripsYieldBoost: string, dripsIssued: string, tvl: string }, seasons: Array<{ __typename?: 'Season', number: number }> };

export type GetDetailsLoansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDetailsLoansQuery = { __typename?: 'Query', openTermLoans: Array<{ __typename?: 'OpenTermLoan', id: string, acmRatio?: string | null, interestRate: any, requestAmount: any, principalOwed: any, collateral?: { __typename?: 'Collateral', asset: CollateralAsset } | null, liquidityAsset: { __typename?: 'Asset', decimals: number, symbol: string } }> };

export type GetDetailsPoolsCachedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDetailsPoolsCachedQuery = { __typename?: 'Query', poolV2S: Array<{ __typename?: 'PoolV2', id: string, poolMeta?: { __typename?: 'PoolMetadata', poolCollaterals?: Array<{ __typename?: 'PoolCollateral', addresses: Array<string>, asset: CollateralAsset, assetAmount?: string | null, assetDecimals: number, assetValueUsd?: string | null }> | null } | null }> };

export type GetDetailsPoolsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDetailsPoolsQuery = { __typename?: 'Query', poolV2S: Array<{ __typename?: 'PoolV2', id: string, principalOut: any }> };

export type GetDetailsGlobalsCachedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDetailsGlobalsCachedQuery = { __typename?: 'Query', syrupGlobals: { __typename?: 'SyrupGlobals', apy: string, collateralApy: string, collateralRatio: string, poolApy: string, dripsYieldBoost: string, dripsIssued: string, tvl: string } };

export type GetLandingPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLandingPageQuery = { __typename?: 'Query', syrupGlobals: { __typename?: 'SyrupGlobals', apy: string, collateralApy: string, collateralRatio: string, poolApy: string, dripsYieldBoost: string, dripsIssued: string, tvl: string } };

export type GetReferralTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetReferralTokenQuery = { __typename?: 'Query', getReferralToken: { __typename?: 'ReferralToken', id: string, token: string, isActive: boolean, alias: string, boost: number } };

export type GetReferralDataQueryVariables = Exact<{
  address: Scalars['String']['input'];
  account: Scalars['ID']['input'];
}>;


export type GetReferralDataQuery = { __typename?: 'Query', getWalletReferralToken?: { __typename?: 'ReferralToken', id: string, token: string, isActive: boolean, alias: string, boost: number } | null, account?: { __typename?: 'Account', isSyrupLender: boolean } | null };

export type GetStakeContextDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStakeContextDataQuery = { __typename?: 'Query', stSyrup?: { __typename?: 'stSyrup', vestingPeriodFinish: any, vestingPeriodStart: any, vestedAssetsPriorPeriods: any, issuanceRate: any } | null };

export type GetStakeBalanceDataQueryVariables = Exact<{
  account: Scalars['ID']['input'];
}>;


export type GetStakeBalanceDataQuery = { __typename?: 'Query', account?: { __typename?: 'Account', depositedSyrup: any, withdrawnSyrup: any, stSyrupBalance: any, isSyrupLender: boolean } | null };

export type GetUserClaimDataQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserClaimDataQuery = { __typename?: 'Query', userAllocations?: Array<{ __typename?: 'UserAllocation', proofs?: Array<string> | null, amount: string, hasClaimed: boolean, id: string, globalAllocation: { __typename?: 'GlobalAllocation', number: number, active: boolean } }> | null };

export type GetGlobalClaimDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalClaimDataQuery = { __typename?: 'Query', globalAllocations: Array<{ __typename?: 'GlobalAllocation', active: boolean, deadline?: string | null, number: number, start?: string | null }> };

export type GetEstimatedWithdrawalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  shares: Scalars['String']['input'];
  requestId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEstimatedWithdrawalQuery = { __typename?: 'Query', estimateWithdrawal: number };

export type GetActiveStrategiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveStrategiesQuery = { __typename?: 'Query', aavestrategies: Array<{ __typename?: 'AAVEStrategy', id: string, pool: { __typename?: 'PoolV2', id: string, asset: { __typename?: 'Asset', decimals: number, id: string, symbol: string } } }>, skyStrategies: Array<{ __typename?: 'SkyStrategy', id: string, pool: { __typename?: 'PoolV2', id: string, asset: { __typename?: 'Asset', decimals: number, id: string, symbol: string } } }> };

export const SyrupUserFragmentDoc = gql`
    fragment SyrupUser on SyrupUser {
  id
  email
  createdAt
  updatedAt
}
    `;
export const AccountFragmentDoc = gql`
    fragment Account on Account {
  id
  isSyrupLender
  permissionsBitmap
}
    `;
export const PoolApyCachedFragmentDoc = gql`
    fragment PoolApyCached on PoolV2 {
  id
  monthlyApy
}
    `;
export const SyrupRouterFragmentDoc = gql`
    fragment SyrupRouter on SyrupRouter {
  id
}
    `;
export const AssetFragmentDoc = gql`
    fragment Asset on Asset {
  decimals
  id
  symbol
}
    `;
export const FunctionLevelBitmapFragmentDoc = gql`
    fragment FunctionLevelBitmap on FunctionLevelBitmap {
  id
  functionId
  bitmap
}
    `;
export const PoolFragmentDoc = gql`
    fragment Pool on PoolV2 {
  id
  tvl
  permissionLevel
  syrupRouter {
    ...SyrupRouter
  }
  asset {
    ...Asset
  }
  functionLevelBitmaps {
    ...FunctionLevelBitmap
  }
  poolMeta {
    targetYield
  }
}
    ${SyrupRouterFragmentDoc}
${AssetFragmentDoc}
${FunctionLevelBitmapFragmentDoc}`;
export const PoolCollateralFragmentDoc = gql`
    fragment PoolCollateral on PoolCollateral {
  addresses
  asset
  assetAmount
  assetDecimals
  assetValueUsd
}
    `;
export const LoanManagerFragmentDoc = gql`
    fragment LoanManager on LoanManager {
  id
  issuanceRate
  accountedInterest
  domainStart
  domainEnd
  principalOut
}
    `;
export const OpenTermLoanManagerFragmentDoc = gql`
    fragment OpenTermLoanManager on OpenTermLoanManager {
  id
  issuanceRate
  accountedInterest
  domainStart
  domainEnd
  principalOut
}
    `;
export const WithdrawalRequestFragmentDoc = gql`
    fragment WithdrawalRequest on WithdrawalRequest {
  id
  owner
  initialShares
  processedShares
  shares
  status
  createdAt
  processedAt
  cancelledAt
  isCancelable
}
    `;
export const WithdrawalManagerQueueFragmentDoc = gql`
    fragment WithdrawalManagerQueue on WithdrawalManagerQueue {
  id
  version
  pool {
    id
  }
  requests {
    ...WithdrawalRequest
  }
  totalShares
  lastRequest {
    ...WithdrawalRequest
  }
  nextRequest {
    ...WithdrawalRequest
  }
}
    ${WithdrawalRequestFragmentDoc}`;
export const PoolWithdrawalFragmentDoc = gql`
    fragment PoolWithdrawal on PoolV2 {
  id
  name
  accountedInterest
  assets
  asset {
    ...Asset
  }
  domainEnd
  domainStart
  id
  issuanceRate
  loanManager {
    ...LoanManager
  }
  name
  openTermLoanManager {
    ...OpenTermLoanManager
  }
  principalOut
  shares
  withdrawalManagerQueue {
    ...WithdrawalManagerQueue
  }
  unrealizedLosses
}
    ${AssetFragmentDoc}
${LoanManagerFragmentDoc}
${OpenTermLoanManagerFragmentDoc}
${WithdrawalManagerQueueFragmentDoc}`;
export const BasicTransactionFragmentDoc = gql`
    fragment BasicTransaction on Tx {
  id
  amount
  value
  symbol
  type
  timestamp
  transaction {
    id
  }
}
    `;
export const DepositSignatureFragmentDoc = gql`
    fragment DepositSignature on DepositSignature {
  deadline
  bitmap
  r
  s
  v
}
    `;
export const CommitmentFragmentDoc = gql`
    fragment Commitment on Commitment {
  id
  amount
  days
  date
  depositTxes
  dripsEarned
  dripsPerDay
  isWithdrawnEarly
  withdrawnAmount
  withdrawnShares
  shares
  createdAt
  updatedAt
}
    `;
export const PoolV2PositionFragmentDoc = gql`
    fragment PoolV2Position on PoolV2Position {
  id
  shares
  lockedShares
  totalShares
  availableBalance
  availableShares
  lendingBalance
  interestEarned
  dripsEarned
  pool {
    asset {
      ...Asset
    }
    poolMeta {
      targetYield
    }
  }
  commitments {
    ...Commitment
  }
}
    ${AssetFragmentDoc}
${CommitmentFragmentDoc}`;
export const LoanDetailsFragmentDoc = gql`
    fragment LoanDetails on OpenTermLoan {
  id
  acmRatio
  collateral {
    asset
  }
  interestRate
  liquidityAsset {
    symbol
    decimals
  }
  requestAmount
}
    `;
export const CommitmentBasicFragmentDoc = gql`
    fragment CommitmentBasic on Commitment {
  date
  days
  amount
  dripsPerDay
  isWithdrawnEarly
  seasons {
    active
    number
  }
  withdrawnAmount
}
    `;
export const SeasonCachedFragmentDoc = gql`
    fragment SeasonCached on Season {
  number
  start
  end
  active
  dripsConversionRate
}
    `;
export const BoostFragmentFragmentDoc = gql`
    fragment BoostFragment on SyrupBoost {
  type
  dripsPerDay
  dripsEarned
}
    `;
export const SeasonScoreSnapshotCachedFragmentDoc = gql`
    fragment SeasonScoreSnapshotCached on SeasonScore {
  currentDripsPerDay
  seasonDrips
  syrupEarned
  updatedAt
  season {
    ...SeasonCached
  }
  syrupEarnedUsd
  totalRewardsYield
  boosts {
    ...BoostFragment
  }
}
    ${SeasonCachedFragmentDoc}
${BoostFragmentFragmentDoc}`;
export const ReferralTokenFragmentDoc = gql`
    fragment ReferralToken on ReferralToken {
  id
  token
  isActive
  alias
  boost
}
    `;
export const SyrupGlobalsCachedFragmentDoc = gql`
    fragment SyrupGlobalsCached on SyrupGlobals {
  apy
  collateralApy
  collateralRatio
  poolApy
  dripsYieldBoost
  dripsIssued
  tvl
}
    `;
export const OpenTermLoanDetailsFragmentDoc = gql`
    fragment OpenTermLoanDetails on OpenTermLoan {
  id
  acmRatio
  collateral {
    asset
  }
  interestRate
  liquidityAsset {
    decimals
    symbol
  }
  requestAmount
  principalOwed
}
    `;
export const PoolAssetFragmentDoc = gql`
    fragment PoolAsset on PoolV2 {
  id
  asset {
    ...Asset
  }
}
    ${AssetFragmentDoc}`;
export const AaveStrategyFragmentDoc = gql`
    fragment AAVEStrategy on AAVEStrategy {
  id
  pool {
    ...PoolAsset
  }
}
    ${PoolAssetFragmentDoc}`;
export const SkyStrategyFragmentDoc = gql`
    fragment SkyStrategy on SkyStrategy {
  id
  pool {
    ...PoolAsset
  }
}
    ${PoolAssetFragmentDoc}`;
export const CreateSyrupUserDocument = gql`
    mutation createSyrupUser($input: SyrupUserInput!) {
  createSyrupUser(inputs: $input) {
    id
  }
}
    `;
export type CreateSyrupUserMutationFn = Apollo.MutationFunction<CreateSyrupUserMutation, CreateSyrupUserMutationVariables>;

/**
 * __useCreateSyrupUserMutation__
 *
 * To run a mutation, you first call `useCreateSyrupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSyrupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSyrupUserMutation, { data, loading, error }] = useCreateSyrupUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSyrupUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateSyrupUserMutation, CreateSyrupUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSyrupUserMutation, CreateSyrupUserMutationVariables>(CreateSyrupUserDocument, options);
      }
export type CreateSyrupUserMutationHookResult = ReturnType<typeof useCreateSyrupUserMutation>;
export type CreateSyrupUserMutationResult = Apollo.MutationResult<CreateSyrupUserMutation>;
export type CreateSyrupUserMutationOptions = Apollo.BaseMutationOptions<CreateSyrupUserMutation, CreateSyrupUserMutationVariables>;
export const ApplyReferralTokenDocument = gql`
    mutation applyReferralToken($input: ApplyReferralTokenInput!) {
  applyReferralToken(inputs: $input) {
    success
  }
}
    `;
export type ApplyReferralTokenMutationFn = Apollo.MutationFunction<ApplyReferralTokenMutation, ApplyReferralTokenMutationVariables>;

/**
 * __useApplyReferralTokenMutation__
 *
 * To run a mutation, you first call `useApplyReferralTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyReferralTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyReferralTokenMutation, { data, loading, error }] = useApplyReferralTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyReferralTokenMutation(baseOptions?: Apollo.MutationHookOptions<ApplyReferralTokenMutation, ApplyReferralTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyReferralTokenMutation, ApplyReferralTokenMutationVariables>(ApplyReferralTokenDocument, options);
      }
export type ApplyReferralTokenMutationHookResult = ReturnType<typeof useApplyReferralTokenMutation>;
export type ApplyReferralTokenMutationResult = Apollo.MutationResult<ApplyReferralTokenMutation>;
export type ApplyReferralTokenMutationOptions = Apollo.BaseMutationOptions<ApplyReferralTokenMutation, ApplyReferralTokenMutationVariables>;
export const CommitBalanceDocument = gql`
    mutation commitBalance($address: String!, $connector: String, $shares: String!, $poolId: String!, $days: CommitDays!) {
  commitBalance(
    address: $address
    connector: $connector
    shares: $shares
    poolId: $poolId
    days: $days
  ) {
    success
  }
}
    `;
export type CommitBalanceMutationFn = Apollo.MutationFunction<CommitBalanceMutation, CommitBalanceMutationVariables>;

/**
 * __useCommitBalanceMutation__
 *
 * To run a mutation, you first call `useCommitBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitBalanceMutation, { data, loading, error }] = useCommitBalanceMutation({
 *   variables: {
 *      address: // value for 'address'
 *      connector: // value for 'connector'
 *      shares: // value for 'shares'
 *      poolId: // value for 'poolId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useCommitBalanceMutation(baseOptions?: Apollo.MutationHookOptions<CommitBalanceMutation, CommitBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitBalanceMutation, CommitBalanceMutationVariables>(CommitBalanceDocument, options);
      }
export type CommitBalanceMutationHookResult = ReturnType<typeof useCommitBalanceMutation>;
export type CommitBalanceMutationResult = Apollo.MutationResult<CommitBalanceMutation>;
export type CommitBalanceMutationOptions = Apollo.BaseMutationOptions<CommitBalanceMutation, CommitBalanceMutationVariables>;
export const RecommitDocument = gql`
    mutation recommit($address: String!, $commitmentId: ID!, $days: CommitDays!) {
  recommit(address: $address, commitmentId: $commitmentId, days: $days) {
    success
  }
}
    `;
export type RecommitMutationFn = Apollo.MutationFunction<RecommitMutation, RecommitMutationVariables>;

/**
 * __useRecommitMutation__
 *
 * To run a mutation, you first call `useRecommitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecommitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recommitMutation, { data, loading, error }] = useRecommitMutation({
 *   variables: {
 *      address: // value for 'address'
 *      commitmentId: // value for 'commitmentId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useRecommitMutation(baseOptions?: Apollo.MutationHookOptions<RecommitMutation, RecommitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecommitMutation, RecommitMutationVariables>(RecommitDocument, options);
      }
export type RecommitMutationHookResult = ReturnType<typeof useRecommitMutation>;
export type RecommitMutationResult = Apollo.MutationResult<RecommitMutation>;
export type RecommitMutationOptions = Apollo.BaseMutationOptions<RecommitMutation, RecommitMutationVariables>;
export const SubmitSyrupUsdcFormDocument = gql`
    mutation submitSyrupUsdcForm($inputs: SyrupUsdcFormInput!) {
  submitSyrupUsdcForm(inputs: $inputs) {
    success
    message
  }
}
    `;
export type SubmitSyrupUsdcFormMutationFn = Apollo.MutationFunction<SubmitSyrupUsdcFormMutation, SubmitSyrupUsdcFormMutationVariables>;

/**
 * __useSubmitSyrupUsdcFormMutation__
 *
 * To run a mutation, you first call `useSubmitSyrupUsdcFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSyrupUsdcFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSyrupUsdcFormMutation, { data, loading, error }] = useSubmitSyrupUsdcFormMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSubmitSyrupUsdcFormMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSyrupUsdcFormMutation, SubmitSyrupUsdcFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSyrupUsdcFormMutation, SubmitSyrupUsdcFormMutationVariables>(SubmitSyrupUsdcFormDocument, options);
      }
export type SubmitSyrupUsdcFormMutationHookResult = ReturnType<typeof useSubmitSyrupUsdcFormMutation>;
export type SubmitSyrupUsdcFormMutationResult = Apollo.MutationResult<SubmitSyrupUsdcFormMutation>;
export type SubmitSyrupUsdcFormMutationOptions = Apollo.BaseMutationOptions<SubmitSyrupUsdcFormMutation, SubmitSyrupUsdcFormMutationVariables>;
export const IsRestrictedDocument = gql`
    query isRestricted {
  isRestricted
}
    `;

/**
 * __useIsRestrictedQuery__
 *
 * To run a query within a React component, call `useIsRestrictedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsRestrictedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsRestrictedQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsRestrictedQuery(baseOptions?: Apollo.QueryHookOptions<IsRestrictedQuery, IsRestrictedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsRestrictedQuery, IsRestrictedQueryVariables>(IsRestrictedDocument, options);
      }
export function useIsRestrictedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsRestrictedQuery, IsRestrictedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsRestrictedQuery, IsRestrictedQueryVariables>(IsRestrictedDocument, options);
        }
export function useIsRestrictedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsRestrictedQuery, IsRestrictedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsRestrictedQuery, IsRestrictedQueryVariables>(IsRestrictedDocument, options);
        }
export type IsRestrictedQueryHookResult = ReturnType<typeof useIsRestrictedQuery>;
export type IsRestrictedLazyQueryHookResult = ReturnType<typeof useIsRestrictedLazyQuery>;
export type IsRestrictedSuspenseQueryHookResult = ReturnType<typeof useIsRestrictedSuspenseQuery>;
export type IsRestrictedQueryResult = Apollo.QueryResult<IsRestrictedQuery, IsRestrictedQueryVariables>;
export const GetAddressComplianceDocument = gql`
    query getAddressCompliance($address: String!) {
  addressCompliance(address: $address) {
    permitted
  }
}
    `;

/**
 * __useGetAddressComplianceQuery__
 *
 * To run a query within a React component, call `useGetAddressComplianceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressComplianceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressComplianceQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGetAddressComplianceQuery(baseOptions: Apollo.QueryHookOptions<GetAddressComplianceQuery, GetAddressComplianceQueryVariables> & ({ variables: GetAddressComplianceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressComplianceQuery, GetAddressComplianceQueryVariables>(GetAddressComplianceDocument, options);
      }
export function useGetAddressComplianceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressComplianceQuery, GetAddressComplianceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressComplianceQuery, GetAddressComplianceQueryVariables>(GetAddressComplianceDocument, options);
        }
export function useGetAddressComplianceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressComplianceQuery, GetAddressComplianceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddressComplianceQuery, GetAddressComplianceQueryVariables>(GetAddressComplianceDocument, options);
        }
export type GetAddressComplianceQueryHookResult = ReturnType<typeof useGetAddressComplianceQuery>;
export type GetAddressComplianceLazyQueryHookResult = ReturnType<typeof useGetAddressComplianceLazyQuery>;
export type GetAddressComplianceSuspenseQueryHookResult = ReturnType<typeof useGetAddressComplianceSuspenseQuery>;
export type GetAddressComplianceQueryResult = Apollo.QueryResult<GetAddressComplianceQuery, GetAddressComplianceQueryVariables>;
export const GetAssetsDocument = gql`
    query getAssets {
  assets {
    ...Asset
  }
}
    ${AssetFragmentDoc}`;

/**
 * __useGetAssetsQuery__
 *
 * To run a query within a React component, call `useGetAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssetsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssetsQuery, GetAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument, options);
      }
export function useGetAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetsQuery, GetAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument, options);
        }
export function useGetAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssetsQuery, GetAssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument, options);
        }
export type GetAssetsQueryHookResult = ReturnType<typeof useGetAssetsQuery>;
export type GetAssetsLazyQueryHookResult = ReturnType<typeof useGetAssetsLazyQuery>;
export type GetAssetsSuspenseQueryHookResult = ReturnType<typeof useGetAssetsSuspenseQuery>;
export type GetAssetsQueryResult = Apollo.QueryResult<GetAssetsQuery, GetAssetsQueryVariables>;
export const GetAccountDocument = gql`
    query getAccount($id: ID!) {
  account(id: $id) {
    ...Account
  }
}
    ${AccountFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables> & ({ variables: GetAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountSuspenseQueryHookResult = ReturnType<typeof useGetAccountSuspenseQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetGlobalDataDocument = gql`
    query getGlobalData($stSyrupAddress: ID!) {
  poolV2S(where: {syrupRouter_not: null}) {
    ...Pool
  }
  assets(where: {isValidPoolAsset: true}) {
    ...Asset
  }
  stSyrup(id: $stSyrupAddress) {
    issuanceRate
    vestingPeriodFinish
  }
}
    ${PoolFragmentDoc}
${AssetFragmentDoc}`;

/**
 * __useGetGlobalDataQuery__
 *
 * To run a query within a React component, call `useGetGlobalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalDataQuery({
 *   variables: {
 *      stSyrupAddress: // value for 'stSyrupAddress'
 *   },
 * });
 */
export function useGetGlobalDataQuery(baseOptions: Apollo.QueryHookOptions<GetGlobalDataQuery, GetGlobalDataQueryVariables> & ({ variables: GetGlobalDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalDataQuery, GetGlobalDataQueryVariables>(GetGlobalDataDocument, options);
      }
export function useGetGlobalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalDataQuery, GetGlobalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalDataQuery, GetGlobalDataQueryVariables>(GetGlobalDataDocument, options);
        }
export function useGetGlobalDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGlobalDataQuery, GetGlobalDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGlobalDataQuery, GetGlobalDataQueryVariables>(GetGlobalDataDocument, options);
        }
export type GetGlobalDataQueryHookResult = ReturnType<typeof useGetGlobalDataQuery>;
export type GetGlobalDataLazyQueryHookResult = ReturnType<typeof useGetGlobalDataLazyQuery>;
export type GetGlobalDataSuspenseQueryHookResult = ReturnType<typeof useGetGlobalDataSuspenseQuery>;
export type GetGlobalDataQueryResult = Apollo.QueryResult<GetGlobalDataQuery, GetGlobalDataQueryVariables>;
export const GetPoolsApyCachedDocument = gql`
    query getPoolsApyCached {
  poolV2S(where: {syrupRouter_not: null}) {
    ...PoolApyCached
  }
}
    ${PoolApyCachedFragmentDoc}`;

/**
 * __useGetPoolsApyCachedQuery__
 *
 * To run a query within a React component, call `useGetPoolsApyCachedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPoolsApyCachedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPoolsApyCachedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPoolsApyCachedQuery(baseOptions?: Apollo.QueryHookOptions<GetPoolsApyCachedQuery, GetPoolsApyCachedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPoolsApyCachedQuery, GetPoolsApyCachedQueryVariables>(GetPoolsApyCachedDocument, options);
      }
export function useGetPoolsApyCachedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPoolsApyCachedQuery, GetPoolsApyCachedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPoolsApyCachedQuery, GetPoolsApyCachedQueryVariables>(GetPoolsApyCachedDocument, options);
        }
export function useGetPoolsApyCachedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPoolsApyCachedQuery, GetPoolsApyCachedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPoolsApyCachedQuery, GetPoolsApyCachedQueryVariables>(GetPoolsApyCachedDocument, options);
        }
export type GetPoolsApyCachedQueryHookResult = ReturnType<typeof useGetPoolsApyCachedQuery>;
export type GetPoolsApyCachedLazyQueryHookResult = ReturnType<typeof useGetPoolsApyCachedLazyQuery>;
export type GetPoolsApyCachedSuspenseQueryHookResult = ReturnType<typeof useGetPoolsApyCachedSuspenseQuery>;
export type GetPoolsApyCachedQueryResult = Apollo.QueryResult<GetPoolsApyCachedQuery, GetPoolsApyCachedQueryVariables>;
export const GetGlobalSyrupStatsCachedDocument = gql`
    query getGlobalSyrupStatsCached {
  syrupGlobals {
    ...SyrupGlobalsCached
  }
}
    ${SyrupGlobalsCachedFragmentDoc}`;

/**
 * __useGetGlobalSyrupStatsCachedQuery__
 *
 * To run a query within a React component, call `useGetGlobalSyrupStatsCachedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalSyrupStatsCachedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalSyrupStatsCachedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGlobalSyrupStatsCachedQuery(baseOptions?: Apollo.QueryHookOptions<GetGlobalSyrupStatsCachedQuery, GetGlobalSyrupStatsCachedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalSyrupStatsCachedQuery, GetGlobalSyrupStatsCachedQueryVariables>(GetGlobalSyrupStatsCachedDocument, options);
      }
export function useGetGlobalSyrupStatsCachedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalSyrupStatsCachedQuery, GetGlobalSyrupStatsCachedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalSyrupStatsCachedQuery, GetGlobalSyrupStatsCachedQueryVariables>(GetGlobalSyrupStatsCachedDocument, options);
        }
export function useGetGlobalSyrupStatsCachedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGlobalSyrupStatsCachedQuery, GetGlobalSyrupStatsCachedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGlobalSyrupStatsCachedQuery, GetGlobalSyrupStatsCachedQueryVariables>(GetGlobalSyrupStatsCachedDocument, options);
        }
export type GetGlobalSyrupStatsCachedQueryHookResult = ReturnType<typeof useGetGlobalSyrupStatsCachedQuery>;
export type GetGlobalSyrupStatsCachedLazyQueryHookResult = ReturnType<typeof useGetGlobalSyrupStatsCachedLazyQuery>;
export type GetGlobalSyrupStatsCachedSuspenseQueryHookResult = ReturnType<typeof useGetGlobalSyrupStatsCachedSuspenseQuery>;
export type GetGlobalSyrupStatsCachedQueryResult = Apollo.QueryResult<GetGlobalSyrupStatsCachedQuery, GetGlobalSyrupStatsCachedQueryVariables>;
export const GetPoolSignatureDocument = gql`
    query getPoolSignature($lender: String!, $poolId: String!) {
  getPoolSignature(lender: $lender, poolId: $poolId) {
    ...DepositSignature
  }
}
    ${DepositSignatureFragmentDoc}`;

/**
 * __useGetPoolSignatureQuery__
 *
 * To run a query within a React component, call `useGetPoolSignatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPoolSignatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPoolSignatureQuery({
 *   variables: {
 *      lender: // value for 'lender'
 *      poolId: // value for 'poolId'
 *   },
 * });
 */
export function useGetPoolSignatureQuery(baseOptions: Apollo.QueryHookOptions<GetPoolSignatureQuery, GetPoolSignatureQueryVariables> & ({ variables: GetPoolSignatureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPoolSignatureQuery, GetPoolSignatureQueryVariables>(GetPoolSignatureDocument, options);
      }
export function useGetPoolSignatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPoolSignatureQuery, GetPoolSignatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPoolSignatureQuery, GetPoolSignatureQueryVariables>(GetPoolSignatureDocument, options);
        }
export function useGetPoolSignatureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPoolSignatureQuery, GetPoolSignatureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPoolSignatureQuery, GetPoolSignatureQueryVariables>(GetPoolSignatureDocument, options);
        }
export type GetPoolSignatureQueryHookResult = ReturnType<typeof useGetPoolSignatureQuery>;
export type GetPoolSignatureLazyQueryHookResult = ReturnType<typeof useGetPoolSignatureLazyQuery>;
export type GetPoolSignatureSuspenseQueryHookResult = ReturnType<typeof useGetPoolSignatureSuspenseQuery>;
export type GetPoolSignatureQueryResult = Apollo.QueryResult<GetPoolSignatureQuery, GetPoolSignatureQueryVariables>;
export const GetPortfolioDataDocument = gql`
    query getPortfolioData($account: String!, $accountId: ID!, $poolIds: [String!]) {
  poolV2Positions(where: {pool_: {syrupRouter_not: null}, account: $account}) {
    ...PoolV2Position
  }
  poolV2S(where: {syrupRouter_not: null}) {
    ...PoolWithdrawal
  }
  txes(
    where: {poolV2_: {syrupRouter_not: null}, account: $account}
    first: 1000
    orderBy: timestamp
    orderDirection: desc
  ) {
    ...BasicTransaction
    withdrawalRequest {
      ...WithdrawalRequest
    }
  }
  accountById(id: $accountId) {
    dripsEarned
    lendingApy(poolIds: $poolIds)
  }
}
    ${PoolV2PositionFragmentDoc}
${PoolWithdrawalFragmentDoc}
${BasicTransactionFragmentDoc}
${WithdrawalRequestFragmentDoc}`;

/**
 * __useGetPortfolioDataQuery__
 *
 * To run a query within a React component, call `useGetPortfolioDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioDataQuery({
 *   variables: {
 *      account: // value for 'account'
 *      accountId: // value for 'accountId'
 *      poolIds: // value for 'poolIds'
 *   },
 * });
 */
export function useGetPortfolioDataQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioDataQuery, GetPortfolioDataQueryVariables> & ({ variables: GetPortfolioDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioDataQuery, GetPortfolioDataQueryVariables>(GetPortfolioDataDocument, options);
      }
export function useGetPortfolioDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioDataQuery, GetPortfolioDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioDataQuery, GetPortfolioDataQueryVariables>(GetPortfolioDataDocument, options);
        }
export function useGetPortfolioDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioDataQuery, GetPortfolioDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioDataQuery, GetPortfolioDataQueryVariables>(GetPortfolioDataDocument, options);
        }
export type GetPortfolioDataQueryHookResult = ReturnType<typeof useGetPortfolioDataQuery>;
export type GetPortfolioDataLazyQueryHookResult = ReturnType<typeof useGetPortfolioDataLazyQuery>;
export type GetPortfolioDataSuspenseQueryHookResult = ReturnType<typeof useGetPortfolioDataSuspenseQuery>;
export type GetPortfolioDataQueryResult = Apollo.QueryResult<GetPortfolioDataQuery, GetPortfolioDataQueryVariables>;
export const GetDripsDataDocument = gql`
    query getDripsData($lender: String!) {
  commitments(wallet: $lender) {
    ...CommitmentBasic
  }
}
    ${CommitmentBasicFragmentDoc}`;

/**
 * __useGetDripsDataQuery__
 *
 * To run a query within a React component, call `useGetDripsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDripsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDripsDataQuery({
 *   variables: {
 *      lender: // value for 'lender'
 *   },
 * });
 */
export function useGetDripsDataQuery(baseOptions: Apollo.QueryHookOptions<GetDripsDataQuery, GetDripsDataQueryVariables> & ({ variables: GetDripsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDripsDataQuery, GetDripsDataQueryVariables>(GetDripsDataDocument, options);
      }
export function useGetDripsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDripsDataQuery, GetDripsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDripsDataQuery, GetDripsDataQueryVariables>(GetDripsDataDocument, options);
        }
export function useGetDripsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDripsDataQuery, GetDripsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDripsDataQuery, GetDripsDataQueryVariables>(GetDripsDataDocument, options);
        }
export type GetDripsDataQueryHookResult = ReturnType<typeof useGetDripsDataQuery>;
export type GetDripsDataLazyQueryHookResult = ReturnType<typeof useGetDripsDataLazyQuery>;
export type GetDripsDataSuspenseQueryHookResult = ReturnType<typeof useGetDripsDataSuspenseQuery>;
export type GetDripsDataQueryResult = Apollo.QueryResult<GetDripsDataQuery, GetDripsDataQueryVariables>;
export const GetSeasonScoreSnapshotCachedDocument = gql`
    query getSeasonScoreSnapshotCached($lender: String!) {
  seasonScoresSnapshot(lender: $lender) {
    ...SeasonScoreSnapshotCached
  }
}
    ${SeasonScoreSnapshotCachedFragmentDoc}`;

/**
 * __useGetSeasonScoreSnapshotCachedQuery__
 *
 * To run a query within a React component, call `useGetSeasonScoreSnapshotCachedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonScoreSnapshotCachedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonScoreSnapshotCachedQuery({
 *   variables: {
 *      lender: // value for 'lender'
 *   },
 * });
 */
export function useGetSeasonScoreSnapshotCachedQuery(baseOptions: Apollo.QueryHookOptions<GetSeasonScoreSnapshotCachedQuery, GetSeasonScoreSnapshotCachedQueryVariables> & ({ variables: GetSeasonScoreSnapshotCachedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeasonScoreSnapshotCachedQuery, GetSeasonScoreSnapshotCachedQueryVariables>(GetSeasonScoreSnapshotCachedDocument, options);
      }
export function useGetSeasonScoreSnapshotCachedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeasonScoreSnapshotCachedQuery, GetSeasonScoreSnapshotCachedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeasonScoreSnapshotCachedQuery, GetSeasonScoreSnapshotCachedQueryVariables>(GetSeasonScoreSnapshotCachedDocument, options);
        }
export function useGetSeasonScoreSnapshotCachedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSeasonScoreSnapshotCachedQuery, GetSeasonScoreSnapshotCachedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSeasonScoreSnapshotCachedQuery, GetSeasonScoreSnapshotCachedQueryVariables>(GetSeasonScoreSnapshotCachedDocument, options);
        }
export type GetSeasonScoreSnapshotCachedQueryHookResult = ReturnType<typeof useGetSeasonScoreSnapshotCachedQuery>;
export type GetSeasonScoreSnapshotCachedLazyQueryHookResult = ReturnType<typeof useGetSeasonScoreSnapshotCachedLazyQuery>;
export type GetSeasonScoreSnapshotCachedSuspenseQueryHookResult = ReturnType<typeof useGetSeasonScoreSnapshotCachedSuspenseQuery>;
export type GetSeasonScoreSnapshotCachedQueryResult = Apollo.QueryResult<GetSeasonScoreSnapshotCachedQuery, GetSeasonScoreSnapshotCachedQueryVariables>;
export const GetDripsGlobalsDocument = gql`
    query getDripsGlobals {
  syrupGlobals {
    ...SyrupGlobalsCached
  }
  seasons(active: true) {
    number
  }
}
    ${SyrupGlobalsCachedFragmentDoc}`;

/**
 * __useGetDripsGlobalsQuery__
 *
 * To run a query within a React component, call `useGetDripsGlobalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDripsGlobalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDripsGlobalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDripsGlobalsQuery(baseOptions?: Apollo.QueryHookOptions<GetDripsGlobalsQuery, GetDripsGlobalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDripsGlobalsQuery, GetDripsGlobalsQueryVariables>(GetDripsGlobalsDocument, options);
      }
export function useGetDripsGlobalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDripsGlobalsQuery, GetDripsGlobalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDripsGlobalsQuery, GetDripsGlobalsQueryVariables>(GetDripsGlobalsDocument, options);
        }
export function useGetDripsGlobalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDripsGlobalsQuery, GetDripsGlobalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDripsGlobalsQuery, GetDripsGlobalsQueryVariables>(GetDripsGlobalsDocument, options);
        }
export type GetDripsGlobalsQueryHookResult = ReturnType<typeof useGetDripsGlobalsQuery>;
export type GetDripsGlobalsLazyQueryHookResult = ReturnType<typeof useGetDripsGlobalsLazyQuery>;
export type GetDripsGlobalsSuspenseQueryHookResult = ReturnType<typeof useGetDripsGlobalsSuspenseQuery>;
export type GetDripsGlobalsQueryResult = Apollo.QueryResult<GetDripsGlobalsQuery, GetDripsGlobalsQueryVariables>;
export const GetDetailsLoansDocument = gql`
    query getDetailsLoans {
  openTermLoans(
    where: {state_in: [Active, DrawdownFunds], fundingPool_: {syrupRouter_not: null}}
  ) {
    ...OpenTermLoanDetails
  }
}
    ${OpenTermLoanDetailsFragmentDoc}`;

/**
 * __useGetDetailsLoansQuery__
 *
 * To run a query within a React component, call `useGetDetailsLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailsLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailsLoansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDetailsLoansQuery(baseOptions?: Apollo.QueryHookOptions<GetDetailsLoansQuery, GetDetailsLoansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailsLoansQuery, GetDetailsLoansQueryVariables>(GetDetailsLoansDocument, options);
      }
export function useGetDetailsLoansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailsLoansQuery, GetDetailsLoansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailsLoansQuery, GetDetailsLoansQueryVariables>(GetDetailsLoansDocument, options);
        }
export function useGetDetailsLoansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailsLoansQuery, GetDetailsLoansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailsLoansQuery, GetDetailsLoansQueryVariables>(GetDetailsLoansDocument, options);
        }
export type GetDetailsLoansQueryHookResult = ReturnType<typeof useGetDetailsLoansQuery>;
export type GetDetailsLoansLazyQueryHookResult = ReturnType<typeof useGetDetailsLoansLazyQuery>;
export type GetDetailsLoansSuspenseQueryHookResult = ReturnType<typeof useGetDetailsLoansSuspenseQuery>;
export type GetDetailsLoansQueryResult = Apollo.QueryResult<GetDetailsLoansQuery, GetDetailsLoansQueryVariables>;
export const GetDetailsPoolsCachedDocument = gql`
    query getDetailsPoolsCached {
  poolV2S(where: {syrupRouter_not: null}) {
    id
    poolMeta {
      poolCollaterals {
        ...PoolCollateral
      }
    }
  }
}
    ${PoolCollateralFragmentDoc}`;

/**
 * __useGetDetailsPoolsCachedQuery__
 *
 * To run a query within a React component, call `useGetDetailsPoolsCachedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailsPoolsCachedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailsPoolsCachedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDetailsPoolsCachedQuery(baseOptions?: Apollo.QueryHookOptions<GetDetailsPoolsCachedQuery, GetDetailsPoolsCachedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailsPoolsCachedQuery, GetDetailsPoolsCachedQueryVariables>(GetDetailsPoolsCachedDocument, options);
      }
export function useGetDetailsPoolsCachedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailsPoolsCachedQuery, GetDetailsPoolsCachedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailsPoolsCachedQuery, GetDetailsPoolsCachedQueryVariables>(GetDetailsPoolsCachedDocument, options);
        }
export function useGetDetailsPoolsCachedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailsPoolsCachedQuery, GetDetailsPoolsCachedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailsPoolsCachedQuery, GetDetailsPoolsCachedQueryVariables>(GetDetailsPoolsCachedDocument, options);
        }
export type GetDetailsPoolsCachedQueryHookResult = ReturnType<typeof useGetDetailsPoolsCachedQuery>;
export type GetDetailsPoolsCachedLazyQueryHookResult = ReturnType<typeof useGetDetailsPoolsCachedLazyQuery>;
export type GetDetailsPoolsCachedSuspenseQueryHookResult = ReturnType<typeof useGetDetailsPoolsCachedSuspenseQuery>;
export type GetDetailsPoolsCachedQueryResult = Apollo.QueryResult<GetDetailsPoolsCachedQuery, GetDetailsPoolsCachedQueryVariables>;
export const GetDetailsPoolsDocument = gql`
    query getDetailsPools {
  poolV2S(where: {syrupRouter_not: null}) {
    id
    principalOut
  }
}
    `;

/**
 * __useGetDetailsPoolsQuery__
 *
 * To run a query within a React component, call `useGetDetailsPoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailsPoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailsPoolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDetailsPoolsQuery(baseOptions?: Apollo.QueryHookOptions<GetDetailsPoolsQuery, GetDetailsPoolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailsPoolsQuery, GetDetailsPoolsQueryVariables>(GetDetailsPoolsDocument, options);
      }
export function useGetDetailsPoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailsPoolsQuery, GetDetailsPoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailsPoolsQuery, GetDetailsPoolsQueryVariables>(GetDetailsPoolsDocument, options);
        }
export function useGetDetailsPoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailsPoolsQuery, GetDetailsPoolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailsPoolsQuery, GetDetailsPoolsQueryVariables>(GetDetailsPoolsDocument, options);
        }
export type GetDetailsPoolsQueryHookResult = ReturnType<typeof useGetDetailsPoolsQuery>;
export type GetDetailsPoolsLazyQueryHookResult = ReturnType<typeof useGetDetailsPoolsLazyQuery>;
export type GetDetailsPoolsSuspenseQueryHookResult = ReturnType<typeof useGetDetailsPoolsSuspenseQuery>;
export type GetDetailsPoolsQueryResult = Apollo.QueryResult<GetDetailsPoolsQuery, GetDetailsPoolsQueryVariables>;
export const GetDetailsGlobalsCachedDocument = gql`
    query getDetailsGlobalsCached {
  syrupGlobals {
    ...SyrupGlobalsCached
  }
}
    ${SyrupGlobalsCachedFragmentDoc}`;

/**
 * __useGetDetailsGlobalsCachedQuery__
 *
 * To run a query within a React component, call `useGetDetailsGlobalsCachedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailsGlobalsCachedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailsGlobalsCachedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDetailsGlobalsCachedQuery(baseOptions?: Apollo.QueryHookOptions<GetDetailsGlobalsCachedQuery, GetDetailsGlobalsCachedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailsGlobalsCachedQuery, GetDetailsGlobalsCachedQueryVariables>(GetDetailsGlobalsCachedDocument, options);
      }
export function useGetDetailsGlobalsCachedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailsGlobalsCachedQuery, GetDetailsGlobalsCachedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailsGlobalsCachedQuery, GetDetailsGlobalsCachedQueryVariables>(GetDetailsGlobalsCachedDocument, options);
        }
export function useGetDetailsGlobalsCachedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDetailsGlobalsCachedQuery, GetDetailsGlobalsCachedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDetailsGlobalsCachedQuery, GetDetailsGlobalsCachedQueryVariables>(GetDetailsGlobalsCachedDocument, options);
        }
export type GetDetailsGlobalsCachedQueryHookResult = ReturnType<typeof useGetDetailsGlobalsCachedQuery>;
export type GetDetailsGlobalsCachedLazyQueryHookResult = ReturnType<typeof useGetDetailsGlobalsCachedLazyQuery>;
export type GetDetailsGlobalsCachedSuspenseQueryHookResult = ReturnType<typeof useGetDetailsGlobalsCachedSuspenseQuery>;
export type GetDetailsGlobalsCachedQueryResult = Apollo.QueryResult<GetDetailsGlobalsCachedQuery, GetDetailsGlobalsCachedQueryVariables>;
export const GetLandingPageDocument = gql`
    query getLandingPage {
  syrupGlobals {
    ...SyrupGlobalsCached
  }
}
    ${SyrupGlobalsCachedFragmentDoc}`;

/**
 * __useGetLandingPageQuery__
 *
 * To run a query within a React component, call `useGetLandingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLandingPageQuery(baseOptions?: Apollo.QueryHookOptions<GetLandingPageQuery, GetLandingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandingPageQuery, GetLandingPageQueryVariables>(GetLandingPageDocument, options);
      }
export function useGetLandingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandingPageQuery, GetLandingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandingPageQuery, GetLandingPageQueryVariables>(GetLandingPageDocument, options);
        }
export function useGetLandingPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLandingPageQuery, GetLandingPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLandingPageQuery, GetLandingPageQueryVariables>(GetLandingPageDocument, options);
        }
export type GetLandingPageQueryHookResult = ReturnType<typeof useGetLandingPageQuery>;
export type GetLandingPageLazyQueryHookResult = ReturnType<typeof useGetLandingPageLazyQuery>;
export type GetLandingPageSuspenseQueryHookResult = ReturnType<typeof useGetLandingPageSuspenseQuery>;
export type GetLandingPageQueryResult = Apollo.QueryResult<GetLandingPageQuery, GetLandingPageQueryVariables>;
export const GetReferralTokenDocument = gql`
    query getReferralToken($token: String!) {
  getReferralToken(token: $token) {
    ...ReferralToken
  }
}
    ${ReferralTokenFragmentDoc}`;

/**
 * __useGetReferralTokenQuery__
 *
 * To run a query within a React component, call `useGetReferralTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetReferralTokenQuery(baseOptions: Apollo.QueryHookOptions<GetReferralTokenQuery, GetReferralTokenQueryVariables> & ({ variables: GetReferralTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferralTokenQuery, GetReferralTokenQueryVariables>(GetReferralTokenDocument, options);
      }
export function useGetReferralTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferralTokenQuery, GetReferralTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferralTokenQuery, GetReferralTokenQueryVariables>(GetReferralTokenDocument, options);
        }
export function useGetReferralTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferralTokenQuery, GetReferralTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferralTokenQuery, GetReferralTokenQueryVariables>(GetReferralTokenDocument, options);
        }
export type GetReferralTokenQueryHookResult = ReturnType<typeof useGetReferralTokenQuery>;
export type GetReferralTokenLazyQueryHookResult = ReturnType<typeof useGetReferralTokenLazyQuery>;
export type GetReferralTokenSuspenseQueryHookResult = ReturnType<typeof useGetReferralTokenSuspenseQuery>;
export type GetReferralTokenQueryResult = Apollo.QueryResult<GetReferralTokenQuery, GetReferralTokenQueryVariables>;
export const GetReferralDataDocument = gql`
    query getReferralData($address: String!, $account: ID!) {
  getWalletReferralToken(address: $address) {
    ...ReferralToken
  }
  account(id: $account) {
    isSyrupLender
  }
}
    ${ReferralTokenFragmentDoc}`;

/**
 * __useGetReferralDataQuery__
 *
 * To run a query within a React component, call `useGetReferralDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralDataQuery({
 *   variables: {
 *      address: // value for 'address'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useGetReferralDataQuery(baseOptions: Apollo.QueryHookOptions<GetReferralDataQuery, GetReferralDataQueryVariables> & ({ variables: GetReferralDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferralDataQuery, GetReferralDataQueryVariables>(GetReferralDataDocument, options);
      }
export function useGetReferralDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferralDataQuery, GetReferralDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferralDataQuery, GetReferralDataQueryVariables>(GetReferralDataDocument, options);
        }
export function useGetReferralDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferralDataQuery, GetReferralDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferralDataQuery, GetReferralDataQueryVariables>(GetReferralDataDocument, options);
        }
export type GetReferralDataQueryHookResult = ReturnType<typeof useGetReferralDataQuery>;
export type GetReferralDataLazyQueryHookResult = ReturnType<typeof useGetReferralDataLazyQuery>;
export type GetReferralDataSuspenseQueryHookResult = ReturnType<typeof useGetReferralDataSuspenseQuery>;
export type GetReferralDataQueryResult = Apollo.QueryResult<GetReferralDataQuery, GetReferralDataQueryVariables>;
export const GetStakeContextDataDocument = gql`
    query getStakeContextData($id: ID!) {
  stSyrup(id: $id) {
    vestingPeriodFinish
    vestingPeriodStart
    vestedAssetsPriorPeriods
    issuanceRate
  }
}
    `;

/**
 * __useGetStakeContextDataQuery__
 *
 * To run a query within a React component, call `useGetStakeContextDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeContextDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeContextDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStakeContextDataQuery(baseOptions: Apollo.QueryHookOptions<GetStakeContextDataQuery, GetStakeContextDataQueryVariables> & ({ variables: GetStakeContextDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeContextDataQuery, GetStakeContextDataQueryVariables>(GetStakeContextDataDocument, options);
      }
export function useGetStakeContextDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeContextDataQuery, GetStakeContextDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeContextDataQuery, GetStakeContextDataQueryVariables>(GetStakeContextDataDocument, options);
        }
export function useGetStakeContextDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStakeContextDataQuery, GetStakeContextDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStakeContextDataQuery, GetStakeContextDataQueryVariables>(GetStakeContextDataDocument, options);
        }
export type GetStakeContextDataQueryHookResult = ReturnType<typeof useGetStakeContextDataQuery>;
export type GetStakeContextDataLazyQueryHookResult = ReturnType<typeof useGetStakeContextDataLazyQuery>;
export type GetStakeContextDataSuspenseQueryHookResult = ReturnType<typeof useGetStakeContextDataSuspenseQuery>;
export type GetStakeContextDataQueryResult = Apollo.QueryResult<GetStakeContextDataQuery, GetStakeContextDataQueryVariables>;
export const GetStakeBalanceDataDocument = gql`
    query getStakeBalanceData($account: ID!) {
  account(id: $account) {
    depositedSyrup
    withdrawnSyrup
    stSyrupBalance
    isSyrupLender
  }
}
    `;

/**
 * __useGetStakeBalanceDataQuery__
 *
 * To run a query within a React component, call `useGetStakeBalanceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakeBalanceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakeBalanceDataQuery({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useGetStakeBalanceDataQuery(baseOptions: Apollo.QueryHookOptions<GetStakeBalanceDataQuery, GetStakeBalanceDataQueryVariables> & ({ variables: GetStakeBalanceDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStakeBalanceDataQuery, GetStakeBalanceDataQueryVariables>(GetStakeBalanceDataDocument, options);
      }
export function useGetStakeBalanceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStakeBalanceDataQuery, GetStakeBalanceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStakeBalanceDataQuery, GetStakeBalanceDataQueryVariables>(GetStakeBalanceDataDocument, options);
        }
export function useGetStakeBalanceDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStakeBalanceDataQuery, GetStakeBalanceDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStakeBalanceDataQuery, GetStakeBalanceDataQueryVariables>(GetStakeBalanceDataDocument, options);
        }
export type GetStakeBalanceDataQueryHookResult = ReturnType<typeof useGetStakeBalanceDataQuery>;
export type GetStakeBalanceDataLazyQueryHookResult = ReturnType<typeof useGetStakeBalanceDataLazyQuery>;
export type GetStakeBalanceDataSuspenseQueryHookResult = ReturnType<typeof useGetStakeBalanceDataSuspenseQuery>;
export type GetStakeBalanceDataQueryResult = Apollo.QueryResult<GetStakeBalanceDataQuery, GetStakeBalanceDataQueryVariables>;
export const GetUserClaimDataDocument = gql`
    query getUserClaimData($id: String!) {
  userAllocations(address: $id) {
    proofs
    amount
    hasClaimed
    id
    globalAllocation {
      number
      active
    }
  }
}
    `;

/**
 * __useGetUserClaimDataQuery__
 *
 * To run a query within a React component, call `useGetUserClaimDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserClaimDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserClaimDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserClaimDataQuery(baseOptions: Apollo.QueryHookOptions<GetUserClaimDataQuery, GetUserClaimDataQueryVariables> & ({ variables: GetUserClaimDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserClaimDataQuery, GetUserClaimDataQueryVariables>(GetUserClaimDataDocument, options);
      }
export function useGetUserClaimDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserClaimDataQuery, GetUserClaimDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserClaimDataQuery, GetUserClaimDataQueryVariables>(GetUserClaimDataDocument, options);
        }
export function useGetUserClaimDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserClaimDataQuery, GetUserClaimDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserClaimDataQuery, GetUserClaimDataQueryVariables>(GetUserClaimDataDocument, options);
        }
export type GetUserClaimDataQueryHookResult = ReturnType<typeof useGetUserClaimDataQuery>;
export type GetUserClaimDataLazyQueryHookResult = ReturnType<typeof useGetUserClaimDataLazyQuery>;
export type GetUserClaimDataSuspenseQueryHookResult = ReturnType<typeof useGetUserClaimDataSuspenseQuery>;
export type GetUserClaimDataQueryResult = Apollo.QueryResult<GetUserClaimDataQuery, GetUserClaimDataQueryVariables>;
export const GetGlobalClaimDataDocument = gql`
    query getGlobalClaimData {
  globalAllocations {
    active
    deadline
    number
    start
  }
}
    `;

/**
 * __useGetGlobalClaimDataQuery__
 *
 * To run a query within a React component, call `useGetGlobalClaimDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalClaimDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalClaimDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGlobalClaimDataQuery(baseOptions?: Apollo.QueryHookOptions<GetGlobalClaimDataQuery, GetGlobalClaimDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalClaimDataQuery, GetGlobalClaimDataQueryVariables>(GetGlobalClaimDataDocument, options);
      }
export function useGetGlobalClaimDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalClaimDataQuery, GetGlobalClaimDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalClaimDataQuery, GetGlobalClaimDataQueryVariables>(GetGlobalClaimDataDocument, options);
        }
export function useGetGlobalClaimDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGlobalClaimDataQuery, GetGlobalClaimDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGlobalClaimDataQuery, GetGlobalClaimDataQueryVariables>(GetGlobalClaimDataDocument, options);
        }
export type GetGlobalClaimDataQueryHookResult = ReturnType<typeof useGetGlobalClaimDataQuery>;
export type GetGlobalClaimDataLazyQueryHookResult = ReturnType<typeof useGetGlobalClaimDataLazyQuery>;
export type GetGlobalClaimDataSuspenseQueryHookResult = ReturnType<typeof useGetGlobalClaimDataSuspenseQuery>;
export type GetGlobalClaimDataQueryResult = Apollo.QueryResult<GetGlobalClaimDataQuery, GetGlobalClaimDataQueryVariables>;
export const GetEstimatedWithdrawalDocument = gql`
    query getEstimatedWithdrawal($id: ID!, $shares: String!, $requestId: String) {
  estimateWithdrawal(id: $id, shares: $shares, requestId: $requestId)
}
    `;

/**
 * __useGetEstimatedWithdrawalQuery__
 *
 * To run a query within a React component, call `useGetEstimatedWithdrawalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimatedWithdrawalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimatedWithdrawalQuery({
 *   variables: {
 *      id: // value for 'id'
 *      shares: // value for 'shares'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useGetEstimatedWithdrawalQuery(baseOptions: Apollo.QueryHookOptions<GetEstimatedWithdrawalQuery, GetEstimatedWithdrawalQueryVariables> & ({ variables: GetEstimatedWithdrawalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstimatedWithdrawalQuery, GetEstimatedWithdrawalQueryVariables>(GetEstimatedWithdrawalDocument, options);
      }
export function useGetEstimatedWithdrawalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstimatedWithdrawalQuery, GetEstimatedWithdrawalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstimatedWithdrawalQuery, GetEstimatedWithdrawalQueryVariables>(GetEstimatedWithdrawalDocument, options);
        }
export function useGetEstimatedWithdrawalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEstimatedWithdrawalQuery, GetEstimatedWithdrawalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEstimatedWithdrawalQuery, GetEstimatedWithdrawalQueryVariables>(GetEstimatedWithdrawalDocument, options);
        }
export type GetEstimatedWithdrawalQueryHookResult = ReturnType<typeof useGetEstimatedWithdrawalQuery>;
export type GetEstimatedWithdrawalLazyQueryHookResult = ReturnType<typeof useGetEstimatedWithdrawalLazyQuery>;
export type GetEstimatedWithdrawalSuspenseQueryHookResult = ReturnType<typeof useGetEstimatedWithdrawalSuspenseQuery>;
export type GetEstimatedWithdrawalQueryResult = Apollo.QueryResult<GetEstimatedWithdrawalQuery, GetEstimatedWithdrawalQueryVariables>;
export const GetActiveStrategiesDocument = gql`
    query getActiveStrategies {
  aavestrategies(where: {state_in: [Active], pool_: {syrupRouter_not: null}}) {
    ...AAVEStrategy
  }
  skyStrategies(where: {state_in: [Active], pool_: {syrupRouter_not: null}}) {
    ...SkyStrategy
  }
}
    ${AaveStrategyFragmentDoc}
${SkyStrategyFragmentDoc}`;

/**
 * __useGetActiveStrategiesQuery__
 *
 * To run a query within a React component, call `useGetActiveStrategiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveStrategiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveStrategiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveStrategiesQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveStrategiesQuery, GetActiveStrategiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveStrategiesQuery, GetActiveStrategiesQueryVariables>(GetActiveStrategiesDocument, options);
      }
export function useGetActiveStrategiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveStrategiesQuery, GetActiveStrategiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveStrategiesQuery, GetActiveStrategiesQueryVariables>(GetActiveStrategiesDocument, options);
        }
export function useGetActiveStrategiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveStrategiesQuery, GetActiveStrategiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveStrategiesQuery, GetActiveStrategiesQueryVariables>(GetActiveStrategiesDocument, options);
        }
export type GetActiveStrategiesQueryHookResult = ReturnType<typeof useGetActiveStrategiesQuery>;
export type GetActiveStrategiesLazyQueryHookResult = ReturnType<typeof useGetActiveStrategiesLazyQuery>;
export type GetActiveStrategiesSuspenseQueryHookResult = ReturnType<typeof useGetActiveStrategiesSuspenseQuery>;
export type GetActiveStrategiesQueryResult = Apollo.QueryResult<GetActiveStrategiesQuery, GetActiveStrategiesQueryVariables>;